!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.sharetribeSdk = e() : t.sharetribeSdk = e();
}("undefined" != typeof self ? self : this, function () {
  return function (t) {
    function e(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }

    var r = {};
    return e.m = t, e.c = r, e.d = function (t, r, n) {
      e.o(t, r) || Object.defineProperty(t, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, e.n = function (t) {
      var r = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(r, "a", r), r;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 81);
  }([function (t, e, r) {
    "use strict";

    function n(t) {
      return "[object Array]" === T.call(t);
    }

    function o(t) {
      return void 0 === t;
    }

    function i(t) {
      return null !== t && !o(t) && null !== t.constructor && !o(t.constructor) && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
    }

    function c(t) {
      return "[object ArrayBuffer]" === T.call(t);
    }

    function a(t) {
      return "undefined" != typeof FormData && t instanceof FormData;
    }

    function s(t) {
      return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && t.buffer instanceof ArrayBuffer;
    }

    function u(t) {
      return "string" == typeof t;
    }

    function g(t) {
      return "number" == typeof t;
    }

    function p(t) {
      return null !== t && "object" == typeof t;
    }

    function l(t) {
      if ("[object Object]" !== T.call(t)) return !1;
      var e = Object.getPrototypeOf(t);
      return null === e || e === Object.prototype;
    }

    function f(t) {
      return "[object Date]" === T.call(t);
    }

    function h(t) {
      return "[object File]" === T.call(t);
    }

    function m(t) {
      return "[object Blob]" === T.call(t);
    }

    function d(t) {
      return "[object Function]" === T.call(t);
    }

    function y(t) {
      return p(t) && d(t.pipe);
    }

    function b(t) {
      return "undefined" != typeof URLSearchParams && t instanceof URLSearchParams;
    }

    function v(t) {
      return t.replace(/^\s*/, "").replace(/\s*$/, "");
    }

    function _() {
      return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
    }

    function O(t, e) {
      if (null !== t && void 0 !== t) if ("object" != typeof t && (t = [t]), n(t)) for (var r = 0, o = t.length; r < o; r++) {
        e.call(null, t[r], r, t);
      } else for (var i in t) {
        Object.prototype.hasOwnProperty.call(t, i) && e.call(null, t[i], i, t);
      }
    }

    function w() {
      function t(t, r) {
        l(e[r]) && l(t) ? e[r] = w(e[r], t) : l(t) ? e[r] = w({}, t) : n(t) ? e[r] = t.slice() : e[r] = t;
      }

      for (var e = {}, r = 0, o = arguments.length; r < o; r++) {
        O(arguments[r], t);
      }

      return e;
    }

    function S(t, e, r) {
      return O(e, function (e, n) {
        t[n] = r && "function" == typeof e ? j(e, r) : e;
      }), t;
    }

    function E(t) {
      return 65279 === t.charCodeAt(0) && (t = t.slice(1)), t;
    }

    var j = r(63),
        T = Object.prototype.toString;
    t.exports = {
      isArray: n,
      isArrayBuffer: c,
      isBuffer: i,
      isFormData: a,
      isArrayBufferView: s,
      isString: u,
      isNumber: g,
      isObject: p,
      isPlainObject: l,
      isUndefined: o,
      isDate: f,
      isFile: h,
      isBlob: m,
      isFunction: d,
      isStream: y,
      isURLSearchParams: b,
      isStandardBrowserEnv: _,
      forEach: O,
      merge: w,
      extend: S,
      trim: v,
      stripBOM: E
    };
  }, function (t, e) {
    var r = Array.isArray;
    t.exports = r;
  }, function (t, e, r) {
    var n = r(39),
        o = "object" == typeof self && self && self.Object === Object && self,
        i = n || o || Function("return this")();
    t.exports = i;
  }, function (t, e, r) {
    function n(t, e) {
      var r = i(t, e);
      return o(r) ? r : void 0;
    }

    var o = r(84),
        i = r(89);
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      return null != t && "object" == typeof t;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      return null == t ? void 0 === t ? s : a : u && u in Object(t) ? i(t) : c(t);
    }

    var o = r(7),
        i = r(85),
        c = r(86),
        a = "[object Null]",
        s = "[object Undefined]",
        u = o ? o.toStringTag : void 0;
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(2),
        o = n.Symbol;
    t.exports = o;
  }, function (t, e, r) {
    function n(t) {
      return null != t && i(t.length) && !o(t);
    }

    var o = r(38),
        i = r(25);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return "function" == typeof t ? t : null == t ? c : "object" == typeof t ? a(t) ? i(t[0], t[1]) : o(t) : s(t);
    }

    var o = r(101),
        i = r(145),
        c = r(11),
        a = r(1),
        s = r(151);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      if ("string" == typeof t || o(t)) return t;
      var e = t + "";
      return "0" == e && 1 / t == -i ? "-0" : e;
    }

    var o = r(19),
        i = 1 / 0;
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      return t;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      return c(t) ? o(t) : i(t);
    }

    var o = r(92),
        i = r(98),
        c = r(8);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = -1,
          r = null == t ? 0 : t.length;

      for (this.clear(); ++e < r;) {
        var n = t[e];
        this.set(n[0], n[1]);
      }
    }

    var o = r(103),
        i = r(104),
        c = r(105),
        a = r(106),
        s = r(107);
    n.prototype.clear = o, n.prototype.delete = i, n.prototype.get = c, n.prototype.has = a, n.prototype.set = s, t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      for (var r = t.length; r--;) {
        if (o(t[r][0], e)) return r;
      }

      return -1;
    }

    var o = r(26);
    t.exports = n;
  }, function (t, e, r) {
    var n = r(3),
        o = n(Object, "create");
    t.exports = o;
  }, function (t, e, r) {
    function n(t, e) {
      var r = t.__data__;
      return o(e) ? r["string" == typeof e ? "string" : "hash"] : r.map;
    }

    var o = r(121);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      e = o(e, t);

      for (var r = 0, n = e.length; null != t && r < n;) {
        t = t[i(e[r++])];
      }

      return r && r == n ? t : void 0;
    }

    var o = r(18),
        i = r(10);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      return o(t) ? t : i(t, e) ? [t] : c(a(t));
    }

    var o = r(1),
        i = r(30),
        c = r(146),
        a = r(56);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return "symbol" == typeof t || i(t) && o(t) == c;
    }

    var o = r(5),
        i = r(4),
        c = "[object Symbol]";
    t.exports = n;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      if (null == t) return {};
      var r,
          n,
          i = o(t, e);

      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(t);

        for (n = 0; n < c.length; n++) {
          r = c[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (i[r] = t[r]);
        }
      }

      return i;
    }

    function o(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function i(t, e) {
      return s(t) || a(t, e) || c();
    }

    function c() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }

    function a(t, e) {
      var r = [],
          n = !0,
          o = !1,
          i = void 0;

      try {
        for (var c, a = t[Symbol.iterator](); !(n = (c = a.next()).done) && (r.push(c.value), !e || r.length !== e); n = !0) {
          ;
        }
      } catch (t) {
        o = !0, i = t;
      } finally {
        try {
          n || null == a.return || a.return();
        } finally {
          if (o) throw i;
        }
      }

      return r;
    }

    function s(t) {
      if (Array.isArray(t)) return t;
    }

    function u(t) {
      return l(t) || p(t) || g();
    }

    function g() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }

    function p(t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }

    function l(t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = new Array(t.length); e < t.length; e++) {
          r[e] = t[e];
        }

        return r;
      }
    }

    function f(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function h(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? f(r, !0).forEach(function (e) {
          m(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : f(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function m(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    var d = function d(t) {
      return Promise.resolve(t);
    },
        y = function y() {
      return h({}, arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, {
        enterQueue: u(arguments.length > 1 ? arguments[1] : void 0).reverse(),
        leaveStack: []
      });
    },
        b = function b(t, e, r) {
      return d(t).then(e[r] || d).catch(function (n) {
        var o = n.ctx || t;
        return Promise.resolve(h({}, o, {
          error: n,
          errorMiddleware: e.constructor.name,
          errorStage: r
        }));
      });
    },
        v = function v(t) {
      var e,
          r,
          n = u(t.leaveStack),
          o = u(t.enterQueue);
      return t.error ? (e = n.shift(), r = "error") : o.length ? (e = o.pop(), n.unshift(e), r = "enter") : (e = n.shift(), r = "leave"), [h({}, t, {
        enterQueue: o,
        leaveStack: n
      }), e, r];
    },
        _ = function t(e) {
      var r = v(e),
          o = i(r, 3),
          c = o[0],
          a = o[1],
          s = o[2];
      if (a) return b(c, a, s).then(t);

      if (c.error) {
        var u = c.error,
            g = n(c, ["error"]);
        return u.ctx = g, Promise.reject(u);
      }

      return Promise.resolve(c);
    },
        O = function O(t) {
      return function (e) {
        return _(y(e, t));
      };
    };

    e.a = O;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function o(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function i(t, e, r) {
      return e && o(t.prototype, e), r && o(t, r), t;
    }

    r.d(e, "a", function () {
      return c;
    });

    var c = function () {
      function t() {
        n(this, t);
      }

      return i(t, [{
        key: "leave",
        value: function value(t) {
          var e = t.authToken,
              r = t.tokenStore;
          return r ? Promise.resolve().then(function () {
            return r.setToken(e);
          }).then(function () {
            return t;
          }) : t;
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function a(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function s(t, e, r) {
      return e && a(t.prototype, e), r && a(t, r), t;
    }

    r.d(e, "a", function () {
      return u;
    });

    var u = function () {
      function t() {
        c(this, t);
      }

      return s(t, [{
        key: "leave",
        value: function value(t) {
          return o({}, t, {
            authToken: t.res.data
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    var n = r(94),
        o = r(4),
        i = Object.prototype,
        c = i.hasOwnProperty,
        a = i.propertyIsEnumerable,
        s = n(function () {
      return arguments;
    }()) ? n : function (t) {
      return o(t) && c.call(t, "callee") && !a.call(t, "callee");
    };
    t.exports = s;
  }, function (t, e) {
    function r(t, e) {
      var r = typeof t;
      return !!(e = null == e ? n : e) && ("number" == r || "symbol" != r && o.test(t)) && t > -1 && t % 1 == 0 && t < e;
    }

    var n = 9007199254740991,
        o = /^(?:0|[1-9]\d*)$/;
    t.exports = r;
  }, function (t, e) {
    function r(t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n;
    }

    var n = 9007199254740991;
    t.exports = r;
  }, function (t, e) {
    function r(t, e) {
      return t === e || t !== t && e !== e;
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(3),
        o = r(2),
        i = n(o, "Map");
    t.exports = i;
  }, function (t, e, r) {
    function n(t) {
      var e = -1,
          r = null == t ? 0 : t.length;

      for (this.clear(); ++e < r;) {
        var n = t[e];
        this.set(n[0], n[1]);
      }
    }

    var o = r(113),
        i = r(120),
        c = r(122),
        a = r(123),
        s = r(124);
    n.prototype.clear = o, n.prototype.delete = i, n.prototype.get = c, n.prototype.has = a, n.prototype.set = s, t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      var n = null == t ? void 0 : o(t, e);
      return void 0 === n ? r : n;
    }

    var o = r(17);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      if (o(t)) return !1;
      var r = typeof t;
      return !("number" != r && "symbol" != r && "boolean" != r && null != t && !i(t)) || a.test(t) || !c.test(t) || null != e && t in Object(e);
    }

    var o = r(1),
        i = r(19),
        c = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        a = /^\w*$/;
    t.exports = n;
  }, function (t, e) {
    function r(t, e) {
      for (var r = -1, n = null == t ? 0 : t.length, o = Array(n); ++r < n;) {
        o[r] = e(t[r], r, t);
      }

      return o;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t, e, r, n) {
      if (!a(t)) return t;
      e = i(e, t);

      for (var u = -1, g = e.length, p = g - 1, l = t; null != l && ++u < g;) {
        var f = s(e[u]),
            h = r;
        if ("__proto__" === f || "constructor" === f || "prototype" === f) return t;

        if (u != p) {
          var m = l[f];
          h = n ? n(m, f, l) : void 0, void 0 === h && (h = a(m) ? m : c(e[u + 1]) ? [] : {});
        }

        o(l, f, h), l = l[f];
      }

      return t;
    }

    var o = r(155),
        i = r(18),
        c = r(24),
        a = r(6),
        s = r(10);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      var n = s(t) ? o : a,
          u = arguments.length < 3;
      return n(t, c(e, 4), r, u, i);
    }

    var o = r(186),
        i = r(73),
        c = r(9),
        a = r(188),
        s = r(1);
    t.exports = n;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), r.d(e, "UUID", function () {
      return o;
    }), r.d(e, "LatLng", function () {
      return i;
    }), r.d(e, "LatLngBounds", function () {
      return c;
    }), r.d(e, "Money", function () {
      return a;
    }), r.d(e, "BigDecimal", function () {
      return s;
    }), r.d(e, "toType", function () {
      return u;
    }), r.d(e, "replacer", function () {
      return g;
    }), r.d(e, "reviver", function () {
      return p;
    });

    var o = function t(e) {
      n(this, t), this._sdkType = this.constructor._sdkType, this.uuid = e;
    };

    o._sdkType = "UUID";

    var i = function t(e, r) {
      n(this, t), this._sdkType = this.constructor._sdkType, this.lat = e, this.lng = r;
    };

    i._sdkType = "LatLng";

    var c = function t(e, r) {
      n(this, t), this._sdkType = this.constructor._sdkType, this.ne = e, this.sw = r;
    };

    c._sdkType = "LatLngBounds";

    var a = function t(e, r) {
      n(this, t), this._sdkType = this.constructor._sdkType, this.amount = e, this.currency = r;
    };

    a._sdkType = "Money";

    var s = function t(e) {
      n(this, t), this._sdkType = this.constructor._sdkType, this.value = e;
    };

    s._sdkType = "BigDecimal";

    var u = function u(t) {
      switch (t && t._sdkType) {
        case "LatLng":
          return new i(t.lat, t.lng);

        case "LatLngBounds":
          return new c(t.ne, t.sw);

        case "UUID":
          return new o(t.uuid);

        case "Money":
          return new a(t.amount, t.currency);

        case "BigDecimal":
          return new s(t.value);

        default:
          return t;
      }
    },
        g = function g(t, e) {
      return e;
    },
        p = function p(t, e) {
      return u(e);
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function o(t) {
      return a(t) || c(t) || i();
    }

    function i() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }

    function c(t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }

    function a(t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = new Array(t.length); e < t.length; e++) {
          r[e] = t[e];
        }

        return r;
      }
    }

    function s(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function u(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? s(r, !0).forEach(function (e) {
          g(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : s(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function g(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function p(t, e) {
      return h(t) || f(t, e) || l();
    }

    function l() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }

    function f(t, e) {
      var r = [],
          n = !0,
          o = !1,
          i = void 0;

      try {
        for (var c, a = t[Symbol.iterator](); !(n = (c = a.next()).done) && (r.push(c.value), !e || r.length !== e); n = !0) {
          ;
        }
      } catch (t) {
        o = !0, i = t;
      } finally {
        try {
          n || null == a.return || a.return();
        } finally {
          if (o) throw i;
        }
      }

      return r;
    }

    function h(t) {
      if (Array.isArray(t)) return t;
    }

    r.d(e, "a", function () {
      return $;
    }), r.d(e, "b", function () {
      return F;
    }), r.d(e, "c", function () {
      return V;
    });

    var m = r(6),
        d = r.n(m),
        y = r(33),
        b = r.n(y),
        v = r(60),
        _ = r.n(v),
        O = r(227),
        w = r.n(O),
        S = r(77),
        E = r.n(S),
        j = r(234),
        T = r.n(j),
        A = r(11),
        P = r.n(A),
        x = r(235),
        C = r.n(x),
        L = r(34),
        k = function k(t, e) {
      var r = t.reader,
          n = e ? e.reader : P.a;
      return function (t) {
        return n(r(t));
      };
    },
        D = {
      u: L.UUID,
      geo: L.LatLng,
      mn: L.Money,
      f: L.BigDecimal
    },
        I = [{
      sdkType: L.UUID,
      reader: function reader(t) {
        return new L.UUID(t);
      }
    }, {
      sdkType: L.LatLng,
      reader: function reader(t) {
        var e = p(t, 2),
            r = e[0],
            n = e[1];
        return new L.LatLng(r, n);
      }
    }, {
      sdkType: L.Money,
      reader: function reader(t) {
        var e = p(t, 2),
            r = e[0],
            n = e[1];
        return new L.Money(r, n);
      }
    }, {
      sdkType: L.BigDecimal,
      reader: function reader(t) {
        return new L.BigDecimal(t);
      }
    }],
        M = [{
      sdkType: L.UUID,
      writer: function writer(t) {
        return t.uuid;
      }
    }, {
      sdkType: L.LatLng,
      writer: function writer(t) {
        return [t.lat, t.lng];
      }
    }, {
      sdkType: L.Money,
      writer: function writer(t) {
        return [t.amount, t.currency];
      }
    }, {
      sdkType: L.BigDecimal,
      writer: function writer(t) {
        return t.value;
      }
    }],
        R = function R(t) {
      return T()(E()(D, function (e, r) {
        var n = w()(I, function (t) {
          return t.sdkType === e;
        }),
            o = w()(t, function (t) {
          return t.sdkType === e;
        });
        return [r, k(n, o)];
      }));
    },
        N = _()(E()(D, function (t, e) {
      var r = w()(M, function (e) {
        return e.sdkType === t;
      }),
          n = C.a.makeWriteHandler({
        tag: function tag() {
          return e;
        },
        rep: r.writer
      });
      return [t, n];
    })),
        U = {
      init: function init() {
        return {};
      },
      add: function add(t, e, r) {
        return t[e] = r, t;
      },
      finalize: P.a
    },
        q = function q() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          e = R(t);
      return C.a.reader("json", {
        handlers: u({}, e, {
          ":": function _(t) {
            return t;
          },
          set: function set(t) {
            return t;
          },
          list: function list(t) {
            return t;
          }
        }),
        mapBuilder: U
      });
    },
        B = [Object, C.a.makeWriteHandler({
      tag: function tag() {
        return "map";
      },
      rep: function rep(t) {
        return b()(t, function (t, e, r) {
          return t.set(C.a.keyword(r), e), t;
        }, C.a.map());
      }
    })],
        H = function H() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = e.verbose,
          i = r ? "json-verbose" : "json";
      return C.a.writer(i, {
        handlers: C.a.map([].concat(o(N), B)),
        transform: function transform(e) {
          if (d()(e)) {
            if (e._sdkType) return Object(L.toType)(e);
            var r = w()(t, function (t) {
              return t.appType && e instanceof t.appType || t.canHandle && t.canHandle(e);
            });
            if (r) return r.writer(e);
          }

          return e;
        },
        handlerForForeign: function handlerForForeign(t, e) {
          return Array.isArray(t) ? e.get("array") : "object" === n(t) ? e.get("map") : null;
        }
      });
    },
        $ = function $() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          e = arguments.length > 1 ? arguments[1] : void 0,
          r = t.reduce(function (t, e) {
        var r = {
          sdkType: e.sdkType || e.type,
          reader: e.reader
        },
            n = {
          sdkType: e.sdkType || e.type,
          appType: e.appType || e.customType,
          canHandle: e.canHandle,
          writer: e.writer
        };
        return t.readers.push(r), t.writers.push(n), t;
      }, {
        readers: [],
        writers: []
      }),
          n = r.readers,
          o = r.writers;
      return {
        reader: q(n),
        writer: H(o, e)
      };
    },
        F = function F(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = e.typeHandlers;
      return $(void 0 === r ? [] : r).reader.read(t);
    },
        V = function V(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = e.typeHandlers,
          n = void 0 === r ? [] : r,
          o = e.verbose;
      return $(n, {
        verbose: void 0 !== o && o
      }).writer.write(t);
    };
  }, function (t, e, r) {
    function n(t, e, r) {
      "__proto__" == e && o ? o(t, e, {
        configurable: !0,
        enumerable: !0,
        value: r,
        writable: !0
      }) : t[e] = r;
    }

    var o = r(37);
    t.exports = n;
  }, function (t, e, r) {
    var n = r(3),
        o = function () {
      try {
        var t = n(Object, "defineProperty");
        return t({}, "", {}), t;
      } catch (t) {}
    }();

    t.exports = o;
  }, function (t, e, r) {
    function n(t) {
      if (!i(t)) return !1;
      var e = o(t);
      return e == a || e == s || e == c || e == u;
    }

    var o = r(5),
        i = r(6),
        c = "[object AsyncFunction]",
        a = "[object Function]",
        s = "[object GeneratorFunction]",
        u = "[object Proxy]";
    t.exports = n;
  }, function (t, e, r) {
    (function (e) {
      var r = "object" == typeof e && e && e.Object === Object && e;
      t.exports = r;
    }).call(e, r(40));
  }, function (t, e) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (r = window);
    }

    t.exports = r;
  }, function (t, e) {
    function r(t) {
      if (null != t) {
        try {
          return o.call(t);
        } catch (t) {}

        try {
          return t + "";
        } catch (t) {}
      }

      return "";
    }

    var n = Function.prototype,
        o = n.toString;
    t.exports = r;
  }, function (t, e, r) {
    function n(t, e) {
      return t && o(t, e, i);
    }

    var o = r(90),
        i = r(12);
    t.exports = n;
  }, function (t, e, r) {
    (function (t) {
      var n = r(2),
          o = r(95),
          i = "object" == typeof e && e && !e.nodeType && e,
          c = i && "object" == typeof t && t && !t.nodeType && t,
          a = c && c.exports === i,
          s = a ? n.Buffer : void 0,
          u = s ? s.isBuffer : void 0,
          g = u || o;
      t.exports = g;
    }).call(e, r(44)(t));
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e, r) {
    var n = r(96),
        o = r(46),
        i = r(97),
        c = i && i.isTypedArray,
        a = c ? o(c) : n;
    t.exports = a;
  }, function (t, e) {
    function r(t) {
      return function (e) {
        return t(e);
      };
    }

    t.exports = r;
  }, function (t, e) {
    function r(t, e) {
      return function (r) {
        return t(e(r));
      };
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      var e = this.__data__ = new o(t);
      this.size = e.size;
    }

    var o = r(13),
        i = r(108),
        c = r(109),
        a = r(110),
        s = r(111),
        u = r(112);
    n.prototype.clear = i, n.prototype.delete = c, n.prototype.get = a, n.prototype.has = s, n.prototype.set = u, t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r, c, a) {
      return t === e || (null == t || null == e || !i(t) && !i(e) ? t !== t && e !== e : o(t, e, r, c, n, a));
    }

    var o = r(125),
        i = r(4);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r, n, u, g) {
      var p = r & a,
          l = t.length,
          f = e.length;
      if (l != f && !(p && f > l)) return !1;
      var h = g.get(t),
          m = g.get(e);
      if (h && m) return h == e && m == t;
      var d = -1,
          y = !0,
          b = r & s ? new o() : void 0;

      for (g.set(t, e), g.set(e, t); ++d < l;) {
        var v = t[d],
            _ = e[d];
        if (n) var O = p ? n(_, v, d, e, t, g) : n(v, _, d, t, e, g);

        if (void 0 !== O) {
          if (O) continue;
          y = !1;
          break;
        }

        if (b) {
          if (!i(e, function (t, e) {
            if (!c(b, e) && (v === t || u(v, t, r, n, g))) return b.push(e);
          })) {
            y = !1;
            break;
          }
        } else if (v !== _ && !u(v, _, r, n, g)) {
          y = !1;
          break;
        }
      }

      return g.delete(t), g.delete(e), y;
    }

    var o = r(51),
        i = r(128),
        c = r(52),
        a = 1,
        s = 2;
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = -1,
          r = null == t ? 0 : t.length;

      for (this.__data__ = new o(); ++e < r;) {
        this.add(t[e]);
      }
    }

    var o = r(28),
        i = r(126),
        c = r(127);
    n.prototype.add = n.prototype.push = i, n.prototype.has = c, t.exports = n;
  }, function (t, e) {
    function r(t, e) {
      return t.has(e);
    }

    t.exports = r;
  }, function (t, e) {
    function r(t, e) {
      for (var r = -1, n = e.length, o = t.length; ++r < n;) {
        t[o + r] = e[r];
      }

      return t;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      return t === t && !o(t);
    }

    var o = r(6);
    t.exports = n;
  }, function (t, e) {
    function r(t, e) {
      return function (r) {
        return null != r && r[t] === e && (void 0 !== e || t in Object(r));
      };
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      return null == t ? "" : o(t);
    }

    var o = r(57);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      if ("string" == typeof t) return t;
      if (c(t)) return i(t, n) + "";
      if (a(t)) return g ? g.call(t) : "";
      var e = t + "";
      return "0" == e && 1 / t == -s ? "-0" : e;
    }

    var o = r(7),
        i = r(31),
        c = r(1),
        a = r(19),
        s = 1 / 0,
        u = o ? o.prototype : void 0,
        g = u ? u.toString : void 0;
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      return null != t && i(t, e, o);
    }

    var o = r(149),
        i = r(150);
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      for (var e = -1, r = null == t ? 0 : t.length, n = 0, o = []; ++e < r;) {
        var i = t[e];
        i && (o[n++] = i);
      }

      return o;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      return (null == t ? 0 : t.length) ? o(t, 1) : [];
    }

    var o = r(160);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      return e = i(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var n = arguments, c = -1, a = i(n.length - e, 0), s = Array(a); ++c < a;) {
          s[c] = n[e + c];
        }

        c = -1;

        for (var u = Array(e + 1); ++c < e;) {
          u[c] = n[c];
        }

        return u[e] = r(s), o(t, this, u);
      };
    }

    var o = r(162),
        i = Math.max;
    t.exports = n;
  }, function (t, e, r) {
    var n = r(163),
        o = r(165),
        i = o(n);
    t.exports = i;
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t, e) {
      return function () {
        for (var r = new Array(arguments.length), n = 0; n < r.length; n++) {
          r[n] = arguments[n];
        }

        return t.apply(e, r);
      };
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }

    var o = r(0);

    t.exports = function (t, e, r) {
      if (!e) return t;
      var i;
      if (r) i = r(e);else if (o.isURLSearchParams(e)) i = e.toString();else {
        var c = [];
        o.forEach(e, function (t, e) {
          null !== t && void 0 !== t && (o.isArray(t) ? e += "[]" : t = [t], o.forEach(t, function (t) {
            o.isDate(t) ? t = t.toISOString() : o.isObject(t) && (t = JSON.stringify(t)), c.push(n(e) + "=" + n(t));
          }));
        }), i = c.join("&");
      }

      if (i) {
        var a = t.indexOf("#");
        -1 !== a && (t = t.slice(0, a)), t += (-1 === t.indexOf("?") ? "?" : "&") + i;
      }

      return t;
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t) {
      return !(!t || !t.__CANCEL__);
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      function n(t, e) {
        !o.isUndefined(t) && o.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
      }

      var o = r(0),
          i = r(173),
          c = {
        "Content-Type": "application/x-www-form-urlencoded"
      },
          a = {
        adapter: function () {
          var t;
          return "undefined" != typeof XMLHttpRequest ? t = r(67) : void 0 !== e && "[object process]" === Object.prototype.toString.call(e) && (t = r(67)), t;
        }(),
        transformRequest: [function (t, e) {
          return i(e, "Accept"), i(e, "Content-Type"), o.isFormData(t) || o.isArrayBuffer(t) || o.isBuffer(t) || o.isStream(t) || o.isFile(t) || o.isBlob(t) ? t : o.isArrayBufferView(t) ? t.buffer : o.isURLSearchParams(t) ? (n(e, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : o.isObject(t) ? (n(e, "application/json;charset=utf-8"), JSON.stringify(t)) : t;
        }],
        transformResponse: [function (t) {
          if ("string" == typeof t) try {
            t = JSON.parse(t);
          } catch (t) {}
          return t;
        }],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        maxBodyLength: -1,
        validateStatus: function validateStatus(t) {
          return t >= 200 && t < 300;
        }
      };
      a.headers = {
        common: {
          Accept: "application/json, text/plain, */*"
        }
      }, o.forEach(["delete", "get", "head"], function (t) {
        a.headers[t] = {};
      }), o.forEach(["post", "put", "patch"], function (t) {
        a.headers[t] = o.merge(c);
      }), t.exports = a;
    }).call(e, r(172));
  }, function (t, e, r) {
    "use strict";

    var n = r(0),
        o = r(174),
        i = r(176),
        c = r(64),
        a = r(177),
        s = r(180),
        u = r(181),
        g = r(68);

    t.exports = function (t) {
      return new Promise(function (e, r) {
        var p = t.data,
            l = t.headers;
        n.isFormData(p) && delete l["Content-Type"];
        var f = new XMLHttpRequest();

        if (t.auth) {
          var h = t.auth.username || "",
              m = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : "";
          l.Authorization = "Basic " + btoa(h + ":" + m);
        }

        var d = a(t.baseURL, t.url);

        if (f.open(t.method.toUpperCase(), c(d, t.params, t.paramsSerializer), !0), f.timeout = t.timeout, f.onreadystatechange = function () {
          if (f && 4 === f.readyState && (0 !== f.status || f.responseURL && 0 === f.responseURL.indexOf("file:"))) {
            var n = "getAllResponseHeaders" in f ? s(f.getAllResponseHeaders()) : null,
                i = t.responseType && "text" !== t.responseType ? f.response : f.responseText,
                c = {
              data: i,
              status: f.status,
              statusText: f.statusText,
              headers: n,
              config: t,
              request: f
            };
            o(e, r, c), f = null;
          }
        }, f.onabort = function () {
          f && (r(g("Request aborted", t, "ECONNABORTED", f)), f = null);
        }, f.onerror = function () {
          r(g("Network Error", t, null, f)), f = null;
        }, f.ontimeout = function () {
          var e = "timeout of " + t.timeout + "ms exceeded";
          t.timeoutErrorMessage && (e = t.timeoutErrorMessage), r(g(e, t, "ECONNABORTED", f)), f = null;
        }, n.isStandardBrowserEnv()) {
          var y = (t.withCredentials || u(d)) && t.xsrfCookieName ? i.read(t.xsrfCookieName) : void 0;
          y && (l[t.xsrfHeaderName] = y);
        }

        if ("setRequestHeader" in f && n.forEach(l, function (t, e) {
          void 0 === p && "content-type" === e.toLowerCase() ? delete l[e] : f.setRequestHeader(e, t);
        }), n.isUndefined(t.withCredentials) || (f.withCredentials = !!t.withCredentials), t.responseType) try {
          f.responseType = t.responseType;
        } catch (e) {
          if ("json" !== t.responseType) throw e;
        }
        "function" == typeof t.onDownloadProgress && f.addEventListener("progress", t.onDownloadProgress), "function" == typeof t.onUploadProgress && f.upload && f.upload.addEventListener("progress", t.onUploadProgress), t.cancelToken && t.cancelToken.promise.then(function (t) {
          f && (f.abort(), r(t), f = null);
        }), p || (p = null), f.send(p);
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(175);

    t.exports = function (t, e, r, o, i) {
      var c = new Error(t);
      return n(c, e, r, o, i);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(0);

    t.exports = function (t, e) {
      function r(t, e) {
        return n.isPlainObject(t) && n.isPlainObject(e) ? n.merge(t, e) : n.isPlainObject(e) ? n.merge({}, e) : n.isArray(e) ? e.slice() : e;
      }

      function o(o) {
        n.isUndefined(e[o]) ? n.isUndefined(t[o]) || (i[o] = r(void 0, t[o])) : i[o] = r(t[o], e[o]);
      }

      e = e || {};
      var i = {},
          c = ["url", "method", "data"],
          a = ["headers", "auth", "proxy", "params"],
          s = ["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "timeoutMessage", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "decompress", "maxContentLength", "maxBodyLength", "maxRedirects", "transport", "httpAgent", "httpsAgent", "cancelToken", "socketPath", "responseEncoding"],
          u = ["validateStatus"];
      n.forEach(c, function (t) {
        n.isUndefined(e[t]) || (i[t] = r(void 0, e[t]));
      }), n.forEach(a, o), n.forEach(s, function (o) {
        n.isUndefined(e[o]) ? n.isUndefined(t[o]) || (i[o] = r(void 0, t[o])) : i[o] = r(void 0, e[o]);
      }), n.forEach(u, function (n) {
        n in e ? i[n] = r(t[n], e[n]) : n in t && (i[n] = r(void 0, t[n]));
      });
      var g = c.concat(a).concat(s).concat(u),
          p = Object.keys(t).concat(Object.keys(e)).filter(function (t) {
        return -1 === g.indexOf(t);
      });
      return n.forEach(p, o), i;
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      this.message = t;
    }

    n.prototype.toString = function () {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }, n.prototype.__CANCEL__ = !0, t.exports = n;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      return c(t) || i(t, e) || o();
    }

    function o() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }

    function i(t, e) {
      var r = [],
          n = !0,
          o = !1,
          i = void 0;

      try {
        for (var c, a = t[Symbol.iterator](); !(n = (c = a.next()).done) && (r.push(c.value), !e || r.length !== e); n = !0) {
          ;
        }
      } catch (t) {
        o = !0, i = t;
      } finally {
        try {
          n || null == a.return || a.return();
        } finally {
          if (o) throw i;
        }
      }

      return r;
    }

    function c(t) {
      if (Array.isArray(t)) return t;
    }

    r.d(e, "d", function () {
      return m;
    }), r.d(e, "a", function () {
      return d;
    }), r.d(e, "b", function () {
      return y;
    }), r.d(e, "c", function () {
      return v;
    });

    var a = r(72),
        s = r.n(a),
        u = r(33),
        g = r.n(u),
        p = r(189),
        l = r.n(p),
        f = r(197),
        h = r.n(f),
        m = function m(t) {
      return h()(t, "/");
    },
        d = function d(t) {
      return l()(t.split("/"), "").map(function (t) {
        return t.replace(/_\w/g, function (t) {
          return t[1].toUpperCase();
        });
      });
    },
        y = function y(t) {
      return g()(t, function (t, e, r) {
        return t.push("".concat(encodeURIComponent(r), "=").concat(encodeURIComponent(e))), t;
      }, []).join("&");
    },
        b = function b(t) {
      if (s()(t)) throw new Error("Nested object in query parameter.");
      return Array.isArray(t) ? t.join(",") : t;
    },
        v = function v(t) {
      if (!s()(t)) throw new Error("Parameter not an object.");
      return Object.entries(t).filter(function (t) {
        var e = n(t, 2),
            r = e[1];
        return null !== r && void 0 !== r;
      }).map(function (t) {
        var e = n(t, 2),
            r = e[0],
            o = e[1];
        return "".concat(r, ":").concat(b(o));
      }).join(";");
    };
  }, function (t, e, r) {
    function n(t) {
      if (!c(t) || o(t) != a) return !1;
      var e = i(t);
      if (null === e) return !0;
      var r = p.call(e, "constructor") && e.constructor;
      return "function" == typeof r && r instanceof r && g.call(r) == l;
    }

    var o = r(5),
        i = r(185),
        c = r(4),
        a = "[object Object]",
        s = Function.prototype,
        u = Object.prototype,
        g = s.toString,
        p = u.hasOwnProperty,
        l = g.call(Object);
    t.exports = n;
  }, function (t, e, r) {
    var n = r(42),
        o = r(187),
        i = o(n);
    t.exports = i;
  }, function (t, e, r) {
    function n(t, e, r) {
      return e === e ? c(t, e, r) : o(t, i, r);
    }

    var o = r(75),
        i = r(192),
        c = r(193);
    t.exports = n;
  }, function (t, e) {
    function r(t, e, r, n) {
      for (var o = t.length, i = r + (n ? 1 : -1); n ? i-- : ++i < o;) {
        if (e(t[i], i, t)) return i;
      }

      return -1;
    }

    t.exports = r;
  }, function (t, e) {
    function r(t) {
      for (var e = t.length; e-- && n.test(t.charAt(e));) {
        ;
      }

      return e;
    }

    var n = /\s/;
    t.exports = r;
  }, function (t, e, r) {
    function n(t, e) {
      return (a(t) ? o : c)(t, i(e, 3));
    }

    var o = r(31),
        i = r(9),
        c = r(207),
        a = r(1);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      return null == t ? t : o(t, e, i(r));
    }

    var o = r(237),
        i = r(238);
    t.exports = n;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    var c = r(242),
        a = r.n(c),
        s = function s(t, e) {
      return "".concat(e, "-").concat(t, "-token");
    },
        u = function u(t) {
      var e = t.clientId,
          r = t.secure,
          n = s(e, "st");
      return {
        getToken: function getToken() {
          return a.a.getJSON(n);
        },
        setToken: function setToken(t) {
          var e = r ? {
            secure: !0
          } : {};
          a.a.set(n, t, o({
            expires: 30
          }, e));
        },
        removeToken: function removeToken() {
          a.a.remove(n);
        }
      };
    };

    e.a = u;
  }, function (t, e, r) {
    "use strict";

    var n = function n() {
      var t;
      return {
        getToken: function getToken() {
          return t;
        },
        setToken: function setToken(e) {
          t = e;
        },
        removeToken: function removeToken() {
          t = null;
        }
      };
    };

    e.a = n;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), r.d(e, "createInstance", function () {
      return g;
    }), r.d(e, "tokenStore", function () {
      return p;
    }), r.d(e, "transit", function () {
      return l;
    }), r.d(e, "util", function () {
      return f;
    });
    var n = r(82),
        o = r(34),
        i = r(79),
        c = r(243),
        a = r(80),
        s = r(35),
        u = r(71);
    r.d(e, "types", function () {
      return o;
    });

    var g = function g(t) {
      return new n.a(t);
    },
        p = {
      memoryStore: a.a,
      browserCookieStore: i.a,
      expressCookieStore: c.a
    },
        l = {
      read: s.b,
      write: s.c
    },
        f = {
      objectQueryString: u.c
    };
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function o(t) {
      return a(t) || c(t) || i();
    }

    function i() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }

    function c(t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }

    function a(t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = new Array(t.length); e < t.length; e++) {
          r[e] = t[e];
        }

        return r;
      }
    }

    function s(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = u(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) {
          r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    function u(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function g(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function p(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? g(r, !0).forEach(function (e) {
          l(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : g(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function l(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    r.d(e, "a", function () {
      return Et;
    });

    var f = r(83),
        h = r.n(f),
        m = r(154),
        d = r.n(m),
        y = r(29),
        b = r.n(y),
        v = r(59),
        _ = r.n(v),
        O = r(156),
        w = r.n(O),
        S = r(166),
        E = r.n(S),
        j = r(71),
        T = r(205),
        A = r(206),
        P = r(208),
        x = r(209),
        C = r(210),
        L = r(211),
        k = r(212),
        D = r(22),
        I = r(21),
        M = r(213),
        R = r(214),
        N = r(215),
        U = r(216),
        q = r(217),
        B = r(218),
        H = r(219),
        $ = r(220),
        F = r(221),
        V = r(222),
        z = r(223),
        W = r(224),
        K = r(225),
        G = r(226),
        Y = r(236),
        Q = r(239),
        X = r(240),
        Z = r(20),
        J = {
      clientId: null,
      clientSecret: null,
      baseUrl: "https://flex-api.sharetribe.com",
      assetCdnBaseUrl: "https://cdn.st-api.com",
      typeHandlers: [],
      adapter: null,
      version: "v1",
      httpAgent: null,
      httpsAgent: null,
      transitVerbose: !1
    },
        tt = function tt(t) {
      return t ? {
        "X-Transit-Verbose": "true",
        Accept: "application/transit+json"
      } : {
        Accept: "application/transit+json"
      };
    },
        et = {
      api: function api(t) {
        var e = t.baseUrl,
            r = t.version,
            n = t.adapter,
            o = t.httpAgent,
            i = t.httpsAgent,
            c = t.transitVerbose;
        return {
          headers: tt(c),
          baseURL: "".concat(e, "/").concat(r),
          transformRequest: function transformRequest(t) {
            return t;
          },
          transformResponse: function transformResponse(t) {
            return t;
          },
          adapter: n,
          paramsSerializer: A.a,
          httpAgent: o,
          httpsAgent: i
        };
      },
      auth: function auth(t) {
        var e = t.baseUrl,
            r = t.version,
            n = t.adapter,
            o = t.httpAgent,
            i = t.httpsAgent;
        return {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          },
          baseURL: "".concat(e, "/").concat(r, "/"),
          transformRequest: [function (t) {
            return Object(j.b)(t);
          }],
          adapter: n,
          httpAgent: o,
          httpsAgent: i
        };
      },
      assets: function assets(t) {
        var e = t.assetCdnBaseUrl,
            r = t.version,
            n = t.adapter,
            o = t.httpAgent,
            i = t.httpsAgent;
        return {
          headers: {
            Accept: "application/json"
          },
          baseURL: "".concat(e, "/").concat(r),
          adapter: n,
          httpAgent: o,
          httpsAgent: i
        };
      }
    },
        rt = [new R.a(), new M.a(), new C.a(), new x.a(), new P.a()],
        nt = [new N.a(), new F.a(), new z.a(), new I.a(), new D.a()],
        ot = [new R.a(), new L.a(), new x.a(), new P.a(), new k.a()],
        it = [new R.a(), new x.a(), new N.a(), new U.a(), new $.a(), new V.a()],
        ct = [new N.a(), new U.a(), new q.a(), new B.a(), new H.a(), new I.a(), new D.a()],
        at = function at(t) {
      throw t.response && (Object.assign(t, t.response), delete t.response), t.ctx && delete t.ctx, t.config && delete t.config, t;
    },
        st = function st(t) {
      return w()(t, ["onUploadProgress"]);
    },
        ut = function ut(t) {
      var e = t.params,
          r = t.queryParams,
          n = t.pathParams,
          o = t.perRequestOpts,
          i = t.ctx,
          c = t.interceptors;
      return Object(Z.a)(_()(c))(p({}, i, {
        params: e,
        queryParams: r,
        pathParams: n,
        perRequestOpts: o
      })).then(function (t) {
        return t.res;
      }).catch(at);
    },
        gt = function gt(t) {
      return function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return ut(p({
          params: e,
          queryParams: r,
          perRequestOpts: st(n)
        }, t));
      };
    },
        pt = function pt(t) {
      return function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return ut(p({
          params: e
        }, t));
      };
    },
        lt = function lt(t) {
      var e = t.method,
          r = s(t, ["method"]);
      return e && "post" === e.toLowerCase() ? gt(r) : pt(r);
    },
        ft = function ft(t, e) {
      return T.c.map(function (r) {
        var n = r.path,
            i = r.method,
            c = Object(j.a)(n);
        return {
          path: c,
          fn: lt({
            method: i,
            ctx: e,
            interceptors: [new Q.a()].concat(rt, o(b()(t, c) || []))
          })
        };
      });
    },
        ht = function ht(t) {
      var e = t.ctx,
          r = t.interceptors;
      return function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return ut({
          params: t,
          ctx: e,
          interceptors: r
        });
      };
    },
        mt = function mt(t, e) {
      return [{
        path: "login",
        fn: ht({
          ctx: e,
          interceptors: [new Q.a()].concat(nt, o(b()(t, "token")))
        })
      }, {
        path: "logout",
        fn: ht({
          ctx: e,
          interceptors: [new Q.a()].concat(ot, o(b()(t, "revoke")))
        })
      }, {
        path: "exchangeToken",
        fn: ht({
          ctx: e,
          interceptors: [].concat(it, o(b()(t, "token")))
        })
      }, {
        path: "authInfo",
        fn: ht({
          ctx: e,
          interceptors: [new W.a()]
        })
      }, {
        path: "loginWithIdp",
        fn: ht({
          ctx: e,
          interceptors: [].concat(ct, o(b()(t, "authWithIdp")))
        })
      }];
    },
        dt = function dt(t, e) {
      return [{
        path: "assetByAlias",
        fn: function fn(r) {
          var n = r.path,
              i = r.alias;
          if (!n) throw new Error("Missing mandatory parameter `path`");
          if (!i) throw new Error("Missing mandatory parameter `alias`");
          return ut({
            ctx: e,
            pathParams: {
              clientId: e.clientId,
              alias: i || "latest",
              assetPath: n
            },
            interceptors: [new Q.a()].concat(o(b()(t, "byAlias")))
          });
        }
      }, {
        path: "assetByVersion",
        fn: function fn(r) {
          var n = r.path,
              i = r.version;
          if (!i) throw new Error("Missing mandatory parameter `version`");
          if (!i) throw new Error("Missing mandatory parameter `alias`");
          return ut({
            ctx: e,
            pathParams: {
              clientId: e.clientId,
              version: i,
              assetPath: n
            },
            interceptors: [new Q.a()].concat(o(b()(t, "byVersion")))
          });
        }
      }];
    },
        yt = function yt(t) {
      var e = t.params,
          r = void 0 === e ? {} : e,
          n = t.queryParams,
          o = void 0 === n ? {} : n,
          i = t.httpOpts,
          c = i.method,
          a = void 0 === c ? "get" : c,
          s = null,
          u = null;
      "post" === a.toLowerCase() ? (s = r, u = o) : u = r;
      var g = p({}, i, {
        method: a,
        data: s,
        params: u
      });
      return E.a.request(g);
    },
        bt = function bt(t) {
      var e = t.method,
          r = t.url,
          n = t.urlTemplate,
          o = t.httpOpts,
          i = o.headers,
          c = s(o, ["headers"]);
      return {
        enter: function enter(t) {
          var o = t.params,
              a = t.queryParams,
              s = t.pathParams,
              u = t.headers,
              g = t.perRequestOpts;
          return yt({
            params: o,
            queryParams: a,
            httpOpts: p({}, g, {
              method: e || "get",
              headers: p({}, i, {}, u)
            }, c, {
              url: r || n(s)
            })
          }).then(function (e) {
            return p({}, t, {
              res: e
            });
          }).catch(function (e) {
            var r = p({}, t, {
              res: e.response
            });
            throw e.ctx = r, e;
          });
        }
      };
    },
        vt = function vt(t) {
      var e = t.baseUrl,
          r = t.tokenStore,
          n = s(t, ["baseUrl", "tokenStore"]);
      return p({}, n, {
        baseUrl: Object(j.d)(e),
        tokenStore: r || Object(X.a)(r, n.clientId, !!n.secure)
      });
    },
        _t = function _t(t) {
      if (!t.clientId) throw new Error("clientId must be provided");
      if (!t.baseUrl) throw new Error("baseUrl must be provided");
      if (!t.assetCdnBaseUrl) throw new Error("assetCdnBaseUrl must be provided");
      return "undefined" != typeof window && void 0 !== window.document && t.clientSecret && !t.dangerouslyAllowClientSecretInBrowser && (console.warn("Security warning! You are using client secret in a browser. This may expose the client secret to the public."), console.warn("If you know what you are doing and you have secured the website by other means (e.g. HTTP basic auth), you should set the SDK configuration `dangerouslyAllowClientSecretInBrowser` to `true` to dismiss this warning."), console.warn("In the future SDK versions, we may change this warning to an error causing the site not to work properly, unless `dangerouslyAllowClientSecretInBrowser` is set")), t;
    },
        Ot = function Ot(t) {
      return T.c.reduce(function (e, r) {
        var n = r.path,
            i = r.method,
            c = r.multipart,
            a = Object(j.a)(n),
            s = "api/".concat(n),
            u = [];
        return u = "post" === i && c ? [new K.a()] : "post" === i ? [new G.a()] : [], d()(e, a, [new Y.a()].concat(o(u), [bt({
          method: i,
          url: s,
          httpOpts: t
        })]));
      }, {});
    },
        wt = function wt(t) {
      return T.b.reduce(function (e, r) {
        var n = r.path,
            o = r.method,
            i = Object(j.a)(n),
            c = "auth/".concat(n);
        return d()(e, i, [bt({
          method: o,
          url: c,
          httpOpts: t
        })]);
      }, {});
    },
        St = function St(t) {
      return T.a.reduce(function (e, r) {
        var n = r.pathFn,
            o = r.method,
            i = r.name,
            c = function c(t) {
          return "assets/".concat(n(t));
        };

        return d()(e, i, [bt({
          method: o,
          urlTemplate: c,
          httpOpts: t
        })]);
      }, {});
    },
        Et = function t(e) {
      var r = this;
      n(this, t);

      var o = _t(vt(p({}, J, {}, e))),
          i = h()(et, function (t) {
        return t(o);
      }),
          c = Ot(i.api),
          a = wt(i.auth),
          s = St(i.assets),
          u = {
        api: c,
        auth: a,
        assets: s
      },
          g = {
        tokenStore: o.tokenStore,
        endpointInterceptors: u,
        clientId: o.clientId,
        clientSecret: o.clientSecret,
        typeHandlers: o.typeHandlers,
        transitVerbose: o.transitVerbose
      };

      ft(c, g).forEach(function (t) {
        var e = t.path,
            n = t.fn;
        return d()(r, e, n);
      }), mt(a, g).forEach(function (t) {
        var e = t.path,
            n = t.fn;
        return d()(r, e, n);
      }), dt(s, g).forEach(function (t) {
        var e = t.path,
            n = t.fn;
        return d()(r, e, n);
      });
    };
  }, function (t, e, r) {
    function n(t, e) {
      var r = {};
      return e = c(e, 3), i(t, function (t, n, i) {
        o(r, n, e(t, n, i));
      }), r;
    }

    var o = r(36),
        i = r(42),
        c = r(9);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return !(!c(t) || i(t)) && (o(t) ? h : u).test(a(t));
    }

    var o = r(38),
        i = r(87),
        c = r(6),
        a = r(41),
        s = /[\\^$.*+?()[\]{}|]/g,
        u = /^\[object .+?Constructor\]$/,
        g = Function.prototype,
        p = Object.prototype,
        l = g.toString,
        f = p.hasOwnProperty,
        h = RegExp("^" + l.call(f).replace(s, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = c.call(t, s),
          r = t[s];

      try {
        t[s] = void 0;
        var n = !0;
      } catch (t) {}

      var o = a.call(t);
      return n && (e ? t[s] = r : delete t[s]), o;
    }

    var o = r(7),
        i = Object.prototype,
        c = i.hasOwnProperty,
        a = i.toString,
        s = o ? o.toStringTag : void 0;
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      return o.call(t);
    }

    var n = Object.prototype,
        o = n.toString;
    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      return !!i && i in t;
    }

    var o = r(88),
        i = function () {
      var t = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "");
      return t ? "Symbol(src)_1." + t : "";
    }();

    t.exports = n;
  }, function (t, e, r) {
    var n = r(2),
        o = n["__core-js_shared__"];
    t.exports = o;
  }, function (t, e) {
    function r(t, e) {
      return null == t ? void 0 : t[e];
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(91),
        o = n();
    t.exports = o;
  }, function (t, e) {
    function r(t) {
      return function (e, r, n) {
        for (var o = -1, i = Object(e), c = n(e), a = c.length; a--;) {
          var s = c[t ? a : ++o];
          if (!1 === r(i[s], s, i)) break;
        }

        return e;
      };
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t, e) {
      var r = c(t),
          n = !r && i(t),
          g = !r && !n && a(t),
          l = !r && !n && !g && u(t),
          f = r || n || g || l,
          h = f ? o(t.length, String) : [],
          m = h.length;

      for (var d in t) {
        !e && !p.call(t, d) || f && ("length" == d || g && ("offset" == d || "parent" == d) || l && ("buffer" == d || "byteLength" == d || "byteOffset" == d) || s(d, m)) || h.push(d);
      }

      return h;
    }

    var o = r(93),
        i = r(23),
        c = r(1),
        a = r(43),
        s = r(24),
        u = r(45),
        g = Object.prototype,
        p = g.hasOwnProperty;
    t.exports = n;
  }, function (t, e) {
    function r(t, e) {
      for (var r = -1, n = Array(t); ++r < t;) {
        n[r] = e(r);
      }

      return n;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      return i(t) && o(t) == c;
    }

    var o = r(5),
        i = r(4),
        c = "[object Arguments]";
    t.exports = n;
  }, function (t, e) {
    function r() {
      return !1;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      return c(t) && i(t.length) && !!a[o(t)];
    }

    var o = r(5),
        i = r(25),
        c = r(4),
        a = {};
    a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = !0, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = !1, t.exports = n;
  }, function (t, e, r) {
    (function (t) {
      var n = r(39),
          o = "object" == typeof e && e && !e.nodeType && e,
          i = o && "object" == typeof t && t && !t.nodeType && t,
          c = i && i.exports === o,
          a = c && n.process,
          s = function () {
        try {
          var t = i && i.require && i.require("util").types;

          return t || a && a.binding && a.binding("util");
        } catch (t) {}
      }();

      t.exports = s;
    }).call(e, r(44)(t));
  }, function (t, e, r) {
    function n(t) {
      if (!o(t)) return i(t);
      var e = [];

      for (var r in Object(t)) {
        a.call(t, r) && "constructor" != r && e.push(r);
      }

      return e;
    }

    var o = r(99),
        i = r(100),
        c = Object.prototype,
        a = c.hasOwnProperty;
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || n);
    }

    var n = Object.prototype;
    t.exports = r;
  }, function (t, e, r) {
    var n = r(47),
        o = n(Object.keys, Object);
    t.exports = o;
  }, function (t, e, r) {
    function n(t) {
      var e = i(t);
      return 1 == e.length && e[0][2] ? c(e[0][0], e[0][1]) : function (r) {
        return r === t || o(r, t, e);
      };
    }

    var o = r(102),
        i = r(144),
        c = r(55);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r, n) {
      var s = r.length,
          u = s,
          g = !n;
      if (null == t) return !u;

      for (t = Object(t); s--;) {
        var p = r[s];
        if (g && p[2] ? p[1] !== t[p[0]] : !(p[0] in t)) return !1;
      }

      for (; ++s < u;) {
        p = r[s];
        var l = p[0],
            f = t[l],
            h = p[1];

        if (g && p[2]) {
          if (void 0 === f && !(l in t)) return !1;
        } else {
          var m = new o();
          if (n) var d = n(f, h, l, t, e, m);
          if (!(void 0 === d ? i(h, f, c | a, n, m) : d)) return !1;
        }
      }

      return !0;
    }

    var o = r(48),
        i = r(49),
        c = 1,
        a = 2;
    t.exports = n;
  }, function (t, e) {
    function r() {
      this.__data__ = [], this.size = 0;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      var e = this.__data__,
          r = o(e, t);
      return !(r < 0) && (r == e.length - 1 ? e.pop() : c.call(e, r, 1), --this.size, !0);
    }

    var o = r(14),
        i = Array.prototype,
        c = i.splice;
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = this.__data__,
          r = o(e, t);
      return r < 0 ? void 0 : e[r][1];
    }

    var o = r(14);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return o(this.__data__, t) > -1;
    }

    var o = r(14);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      var r = this.__data__,
          n = o(r, t);
      return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
    }

    var o = r(14);
    t.exports = n;
  }, function (t, e, r) {
    function n() {
      this.__data__ = new o(), this.size = 0;
    }

    var o = r(13);
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      var e = this.__data__,
          r = e.delete(t);
      return this.size = e.size, r;
    }

    t.exports = r;
  }, function (t, e) {
    function r(t) {
      return this.__data__.get(t);
    }

    t.exports = r;
  }, function (t, e) {
    function r(t) {
      return this.__data__.has(t);
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t, e) {
      var r = this.__data__;

      if (r instanceof o) {
        var n = r.__data__;
        if (!i || n.length < a - 1) return n.push([t, e]), this.size = ++r.size, this;
        r = this.__data__ = new c(n);
      }

      return r.set(t, e), this.size = r.size, this;
    }

    var o = r(13),
        i = r(27),
        c = r(28),
        a = 200;
    t.exports = n;
  }, function (t, e, r) {
    function n() {
      this.size = 0, this.__data__ = {
        hash: new o(),
        map: new (c || i)(),
        string: new o()
      };
    }

    var o = r(114),
        i = r(13),
        c = r(27);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = -1,
          r = null == t ? 0 : t.length;

      for (this.clear(); ++e < r;) {
        var n = t[e];
        this.set(n[0], n[1]);
      }
    }

    var o = r(115),
        i = r(116),
        c = r(117),
        a = r(118),
        s = r(119);
    n.prototype.clear = o, n.prototype.delete = i, n.prototype.get = c, n.prototype.has = a, n.prototype.set = s, t.exports = n;
  }, function (t, e, r) {
    function n() {
      this.__data__ = o ? o(null) : {}, this.size = 0;
    }

    var o = r(15);
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      var e = this.__data__;

      if (o) {
        var r = e[t];
        return r === i ? void 0 : r;
      }

      return a.call(e, t) ? e[t] : void 0;
    }

    var o = r(15),
        i = "__lodash_hash_undefined__",
        c = Object.prototype,
        a = c.hasOwnProperty;
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = this.__data__;
      return o ? void 0 !== e[t] : c.call(e, t);
    }

    var o = r(15),
        i = Object.prototype,
        c = i.hasOwnProperty;
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      var r = this.__data__;
      return this.size += this.has(t) ? 0 : 1, r[t] = o && void 0 === e ? i : e, this;
    }

    var o = r(15),
        i = "__lodash_hash_undefined__";
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = o(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    }

    var o = r(16);
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      var e = typeof t;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      return o(this, t).get(t);
    }

    var o = r(16);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return o(this, t).has(t);
    }

    var o = r(16);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      var r = o(this, t),
          n = r.size;
      return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
    }

    var o = r(16);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r, n, d, b) {
      var v = u(t),
          _ = u(e),
          O = v ? h : s(t),
          w = _ ? h : s(e);

      O = O == f ? m : O, w = w == f ? m : w;
      var S = O == m,
          E = w == m,
          j = O == w;

      if (j && g(t)) {
        if (!g(e)) return !1;
        v = !0, S = !1;
      }

      if (j && !S) return b || (b = new o()), v || p(t) ? i(t, e, r, n, d, b) : c(t, e, O, r, n, d, b);

      if (!(r & l)) {
        var T = S && y.call(t, "__wrapped__"),
            A = E && y.call(e, "__wrapped__");

        if (T || A) {
          var P = T ? t.value() : t,
              x = A ? e.value() : e;
          return b || (b = new o()), d(P, x, r, n, b);
        }
      }

      return !!j && (b || (b = new o()), a(t, e, r, n, d, b));
    }

    var o = r(48),
        i = r(50),
        c = r(129),
        a = r(133),
        s = r(139),
        u = r(1),
        g = r(43),
        p = r(45),
        l = 1,
        f = "[object Arguments]",
        h = "[object Array]",
        m = "[object Object]",
        d = Object.prototype,
        y = d.hasOwnProperty;
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      return this.__data__.set(t, n), this;
    }

    var n = "__lodash_hash_undefined__";
    t.exports = r;
  }, function (t, e) {
    function r(t) {
      return this.__data__.has(t);
    }

    t.exports = r;
  }, function (t, e) {
    function r(t, e) {
      for (var r = -1, n = null == t ? 0 : t.length; ++r < n;) {
        if (e(t[r], r, t)) return !0;
      }

      return !1;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t, e, r, n, o, S, j) {
      switch (r) {
        case w:
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
          t = t.buffer, e = e.buffer;

        case O:
          return !(t.byteLength != e.byteLength || !S(new i(t), new i(e)));

        case l:
        case f:
        case d:
          return c(+t, +e);

        case h:
          return t.name == e.name && t.message == e.message;

        case y:
        case v:
          return t == e + "";

        case m:
          var T = s;

        case b:
          var A = n & g;
          if (T || (T = u), t.size != e.size && !A) return !1;
          var P = j.get(t);
          if (P) return P == e;
          n |= p, j.set(t, e);
          var x = a(T(t), T(e), n, o, S, j);
          return j.delete(t), x;

        case _:
          if (E) return E.call(t) == E.call(e);
      }

      return !1;
    }

    var o = r(7),
        i = r(130),
        c = r(26),
        a = r(50),
        s = r(131),
        u = r(132),
        g = 1,
        p = 2,
        l = "[object Boolean]",
        f = "[object Date]",
        h = "[object Error]",
        m = "[object Map]",
        d = "[object Number]",
        y = "[object RegExp]",
        b = "[object Set]",
        v = "[object String]",
        _ = "[object Symbol]",
        O = "[object ArrayBuffer]",
        w = "[object DataView]",
        S = o ? o.prototype : void 0,
        E = S ? S.valueOf : void 0;
    t.exports = n;
  }, function (t, e, r) {
    var n = r(2),
        o = n.Uint8Array;
    t.exports = o;
  }, function (t, e) {
    function r(t) {
      var e = -1,
          r = Array(t.size);
      return t.forEach(function (t, n) {
        r[++e] = [n, t];
      }), r;
    }

    t.exports = r;
  }, function (t, e) {
    function r(t) {
      var e = -1,
          r = Array(t.size);
      return t.forEach(function (t) {
        r[++e] = t;
      }), r;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t, e, r, n, c, s) {
      var u = r & i,
          g = o(t),
          p = g.length;
      if (p != o(e).length && !u) return !1;

      for (var l = p; l--;) {
        var f = g[l];
        if (!(u ? f in e : a.call(e, f))) return !1;
      }

      var h = s.get(t),
          m = s.get(e);
      if (h && m) return h == e && m == t;
      var d = !0;
      s.set(t, e), s.set(e, t);

      for (var y = u; ++l < p;) {
        f = g[l];
        var b = t[f],
            v = e[f];
        if (n) var _ = u ? n(v, b, f, e, t, s) : n(b, v, f, t, e, s);

        if (!(void 0 === _ ? b === v || c(b, v, r, n, s) : _)) {
          d = !1;
          break;
        }

        y || (y = "constructor" == f);
      }

      if (d && !y) {
        var O = t.constructor,
            w = e.constructor;
        O != w && "constructor" in t && "constructor" in e && !("function" == typeof O && O instanceof O && "function" == typeof w && w instanceof w) && (d = !1);
      }

      return s.delete(t), s.delete(e), d;
    }

    var o = r(134),
        i = 1,
        c = Object.prototype,
        a = c.hasOwnProperty;
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return o(t, c, i);
    }

    var o = r(135),
        i = r(136),
        c = r(12);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      var n = e(t);
      return i(t) ? n : o(n, r(t));
    }

    var o = r(53),
        i = r(1);
    t.exports = n;
  }, function (t, e, r) {
    var n = r(137),
        o = r(138),
        i = Object.prototype,
        c = i.propertyIsEnumerable,
        a = Object.getOwnPropertySymbols,
        s = a ? function (t) {
      return null == t ? [] : (t = Object(t), n(a(t), function (e) {
        return c.call(t, e);
      }));
    } : o;
    t.exports = s;
  }, function (t, e) {
    function r(t, e) {
      for (var r = -1, n = null == t ? 0 : t.length, o = 0, i = []; ++r < n;) {
        var c = t[r];
        e(c, r, t) && (i[o++] = c);
      }

      return i;
    }

    t.exports = r;
  }, function (t, e) {
    function r() {
      return [];
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(140),
        o = r(27),
        i = r(141),
        c = r(142),
        a = r(143),
        s = r(5),
        u = r(41),
        g = u(n),
        p = u(o),
        l = u(i),
        f = u(c),
        h = u(a),
        m = s;
    (n && "[object DataView]" != m(new n(new ArrayBuffer(1))) || o && "[object Map]" != m(new o()) || i && "[object Promise]" != m(i.resolve()) || c && "[object Set]" != m(new c()) || a && "[object WeakMap]" != m(new a())) && (m = function m(t) {
      var e = s(t),
          r = "[object Object]" == e ? t.constructor : void 0,
          n = r ? u(r) : "";
      if (n) switch (n) {
        case g:
          return "[object DataView]";

        case p:
          return "[object Map]";

        case l:
          return "[object Promise]";

        case f:
          return "[object Set]";

        case h:
          return "[object WeakMap]";
      }
      return e;
    }), t.exports = m;
  }, function (t, e, r) {
    var n = r(3),
        o = r(2),
        i = n(o, "DataView");
    t.exports = i;
  }, function (t, e, r) {
    var n = r(3),
        o = r(2),
        i = n(o, "Promise");
    t.exports = i;
  }, function (t, e, r) {
    var n = r(3),
        o = r(2),
        i = n(o, "Set");
    t.exports = i;
  }, function (t, e, r) {
    var n = r(3),
        o = r(2),
        i = n(o, "WeakMap");
    t.exports = i;
  }, function (t, e, r) {
    function n(t) {
      for (var e = i(t), r = e.length; r--;) {
        var n = e[r],
            c = t[n];
        e[r] = [n, c, o(c)];
      }

      return e;
    }

    var o = r(54),
        i = r(12);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      return a(t) && s(e) ? u(g(t), e) : function (r) {
        var n = i(r, t);
        return void 0 === n && n === e ? c(r, t) : o(e, n, p | l);
      };
    }

    var o = r(49),
        i = r(29),
        c = r(58),
        a = r(30),
        s = r(54),
        u = r(55),
        g = r(10),
        p = 1,
        l = 2;
    t.exports = n;
  }, function (t, e, r) {
    var n = r(147),
        o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        i = /\\(\\)?/g,
        c = n(function (t) {
      var e = [];
      return 46 === t.charCodeAt(0) && e.push(""), t.replace(o, function (t, r, n, o) {
        e.push(n ? o.replace(i, "$1") : r || t);
      }), e;
    });
    t.exports = c;
  }, function (t, e, r) {
    function n(t) {
      var e = o(t, function (t) {
        return r.size === i && r.clear(), t;
      }),
          r = e.cache;
      return e;
    }

    var o = r(148),
        i = 500;
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError(i);

      var r = function r() {
        var n = arguments,
            o = e ? e.apply(this, n) : n[0],
            i = r.cache;
        if (i.has(o)) return i.get(o);
        var c = t.apply(this, n);
        return r.cache = i.set(o, c) || i, c;
      };

      return r.cache = new (n.Cache || o)(), r;
    }

    var o = r(28),
        i = "Expected a function";
    n.Cache = o, t.exports = n;
  }, function (t, e) {
    function r(t, e) {
      return null != t && e in Object(t);
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t, e, r) {
      e = o(e, t);

      for (var n = -1, g = e.length, p = !1; ++n < g;) {
        var l = u(e[n]);
        if (!(p = null != t && r(t, l))) break;
        t = t[l];
      }

      return p || ++n != g ? p : !!(g = null == t ? 0 : t.length) && s(g) && a(l, g) && (c(t) || i(t));
    }

    var o = r(18),
        i = r(23),
        c = r(1),
        a = r(24),
        s = r(25),
        u = r(10);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return c(t) ? o(a(t)) : i(t);
    }

    var o = r(152),
        i = r(153),
        c = r(30),
        a = r(10);
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      return function (e) {
        return null == e ? void 0 : e[t];
      };
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      return function (e) {
        return o(e, t);
      };
    }

    var o = r(17);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      return null == t ? t : o(t, e, r);
    }

    var o = r(32);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      var n = t[e];
      a.call(t, e) && i(n, r) && (void 0 !== r || e in t) || o(t, e, r);
    }

    var o = r(36),
        i = r(26),
        c = Object.prototype,
        a = c.hasOwnProperty;
    t.exports = n;
  }, function (t, e, r) {
    var n = r(157),
        o = r(159),
        i = o(function (t, e) {
      return null == t ? {} : n(t, e);
    });
    t.exports = i;
  }, function (t, e, r) {
    function n(t, e) {
      return o(t, e, function (e, r) {
        return i(t, r);
      });
    }

    var o = r(158),
        i = r(58);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      for (var n = -1, a = e.length, s = {}; ++n < a;) {
        var u = e[n],
            g = o(t, u);
        r(g, u) && i(s, c(u, t), g);
      }

      return s;
    }

    var o = r(17),
        i = r(32),
        c = r(18);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return c(i(t, void 0, o), t + "");
    }

    var o = r(60),
        i = r(61),
        c = r(62);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r, c, a) {
      var s = -1,
          u = t.length;

      for (r || (r = i), a || (a = []); ++s < u;) {
        var g = t[s];
        e > 0 && r(g) ? e > 1 ? n(g, e - 1, r, c, a) : o(a, g) : c || (a[a.length] = g);
      }

      return a;
    }

    var o = r(53),
        i = r(161);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return c(t) || i(t) || !!(a && t && t[a]);
    }

    var o = r(7),
        i = r(23),
        c = r(1),
        a = o ? o.isConcatSpreadable : void 0;
    t.exports = n;
  }, function (t, e) {
    function r(t, e, r) {
      switch (r.length) {
        case 0:
          return t.call(e);

        case 1:
          return t.call(e, r[0]);

        case 2:
          return t.call(e, r[0], r[1]);

        case 3:
          return t.call(e, r[0], r[1], r[2]);
      }

      return t.apply(e, r);
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(164),
        o = r(37),
        i = r(11),
        c = o ? function (t, e) {
      return o(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: n(e),
        writable: !0
      });
    } : i;
    t.exports = c;
  }, function (t, e) {
    function r(t) {
      return function () {
        return t;
      };
    }

    t.exports = r;
  }, function (t, e) {
    function r(t) {
      var e = 0,
          r = 0;
      return function () {
        var c = i(),
            a = o - (c - r);

        if (r = c, a > 0) {
          if (++e >= n) return arguments[0];
        } else e = 0;

        return t.apply(void 0, arguments);
      };
    }

    var n = 800,
        o = 16,
        i = Date.now;
    t.exports = r;
  }, function (t, e, r) {
    t.exports = r(167);
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      var e = new c(t),
          r = i(c.prototype.request, e);
      return o.extend(r, c.prototype, e), o.extend(r, e), r;
    }

    var o = r(0),
        i = r(63),
        c = r(168),
        a = r(69),
        s = r(66),
        u = n(s);
    u.Axios = c, u.create = function (t) {
      return n(a(u.defaults, t));
    }, u.Cancel = r(70), u.CancelToken = r(182), u.isCancel = r(65), u.all = function (t) {
      return Promise.all(t);
    }, u.spread = r(183), u.isAxiosError = r(184), t.exports = u, t.exports.default = u;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      this.defaults = t, this.interceptors = {
        request: new c(),
        response: new c()
      };
    }

    var o = r(0),
        i = r(64),
        c = r(169),
        a = r(170),
        s = r(69);
    n.prototype.request = function (t) {
      "string" == typeof t ? (t = arguments[1] || {}, t.url = arguments[0]) : t = t || {}, t = s(this.defaults, t), t.method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
      var e = [a, void 0],
          r = Promise.resolve(t);

      for (this.interceptors.request.forEach(function (t) {
        e.unshift(t.fulfilled, t.rejected);
      }), this.interceptors.response.forEach(function (t) {
        e.push(t.fulfilled, t.rejected);
      }); e.length;) {
        r = r.then(e.shift(), e.shift());
      }

      return r;
    }, n.prototype.getUri = function (t) {
      return t = s(this.defaults, t), i(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
    }, o.forEach(["delete", "get", "head", "options"], function (t) {
      n.prototype[t] = function (e, r) {
        return this.request(s(r || {}, {
          method: t,
          url: e,
          data: (r || {}).data
        }));
      };
    }), o.forEach(["post", "put", "patch"], function (t) {
      n.prototype[t] = function (e, r, n) {
        return this.request(s(n || {}, {
          method: t,
          url: e,
          data: r
        }));
      };
    }), t.exports = n;
  }, function (t, e, r) {
    "use strict";

    function n() {
      this.handlers = [];
    }

    var o = r(0);
    n.prototype.use = function (t, e) {
      return this.handlers.push({
        fulfilled: t,
        rejected: e
      }), this.handlers.length - 1;
    }, n.prototype.eject = function (t) {
      this.handlers[t] && (this.handlers[t] = null);
    }, n.prototype.forEach = function (t) {
      o.forEach(this.handlers, function (e) {
        null !== e && t(e);
      });
    }, t.exports = n;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      t.cancelToken && t.cancelToken.throwIfRequested();
    }

    var o = r(0),
        i = r(171),
        c = r(65),
        a = r(66);

    t.exports = function (t) {
      return n(t), t.headers = t.headers || {}, t.data = i(t.data, t.headers, t.transformRequest), t.headers = o.merge(t.headers.common || {}, t.headers[t.method] || {}, t.headers), o.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (e) {
        delete t.headers[e];
      }), (t.adapter || a.adapter)(t).then(function (e) {
        return n(t), e.data = i(e.data, e.headers, t.transformResponse), e;
      }, function (e) {
        return c(e) || (n(t), e && e.response && (e.response.data = i(e.response.data, e.response.headers, t.transformResponse))), Promise.reject(e);
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(0);

    t.exports = function (t, e, r) {
      return n.forEach(r, function (r) {
        t = r(t, e);
      }), t;
    };
  }, function (t, e) {
    function r() {
      throw new Error("setTimeout has not been defined");
    }

    function n() {
      throw new Error("clearTimeout has not been defined");
    }

    function o(t) {
      if (g === setTimeout) return setTimeout(t, 0);
      if ((g === r || !g) && setTimeout) return g = setTimeout, setTimeout(t, 0);

      try {
        return g(t, 0);
      } catch (e) {
        try {
          return g.call(null, t, 0);
        } catch (e) {
          return g.call(this, t, 0);
        }
      }
    }

    function i(t) {
      if (p === clearTimeout) return clearTimeout(t);
      if ((p === n || !p) && clearTimeout) return p = clearTimeout, clearTimeout(t);

      try {
        return p(t);
      } catch (e) {
        try {
          return p.call(null, t);
        } catch (e) {
          return p.call(this, t);
        }
      }
    }

    function c() {
      m && f && (m = !1, f.length ? h = f.concat(h) : d = -1, h.length && a());
    }

    function a() {
      if (!m) {
        var t = o(c);
        m = !0;

        for (var e = h.length; e;) {
          for (f = h, h = []; ++d < e;) {
            f && f[d].run();
          }

          d = -1, e = h.length;
        }

        f = null, m = !1, i(t);
      }
    }

    function s(t, e) {
      this.fun = t, this.array = e;
    }

    function u() {}

    var g,
        p,
        l = t.exports = {};
    !function () {
      try {
        g = "function" == typeof setTimeout ? setTimeout : r;
      } catch (t) {
        g = r;
      }

      try {
        p = "function" == typeof clearTimeout ? clearTimeout : n;
      } catch (t) {
        p = n;
      }
    }();
    var f,
        h = [],
        m = !1,
        d = -1;
    l.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        e[r - 1] = arguments[r];
      }
      h.push(new s(t, e)), 1 !== h.length || m || o(a);
    }, s.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, l.title = "browser", l.browser = !0, l.env = {}, l.argv = [], l.version = "", l.versions = {}, l.on = u, l.addListener = u, l.once = u, l.off = u, l.removeListener = u, l.removeAllListeners = u, l.emit = u, l.prependListener = u, l.prependOnceListener = u, l.listeners = function (t) {
      return [];
    }, l.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, l.cwd = function () {
      return "/";
    }, l.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, l.umask = function () {
      return 0;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(0);

    t.exports = function (t, e) {
      n.forEach(t, function (r, n) {
        n !== e && n.toUpperCase() === e.toUpperCase() && (t[e] = r, delete t[n]);
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(68);

    t.exports = function (t, e, r) {
      var o = r.config.validateStatus;
      r.status && o && !o(r.status) ? e(n("Request failed with status code " + r.status, r.config, null, r.request, r)) : t(r);
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t, e, r, n, o) {
      return t.config = e, r && (t.code = r), t.request = n, t.response = o, t.isAxiosError = !0, t.toJSON = function () {
        return {
          message: this.message,
          name: this.name,
          description: this.description,
          number: this.number,
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          config: this.config,
          code: this.code
        };
      }, t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(0);
    t.exports = n.isStandardBrowserEnv() ? function () {
      return {
        write: function write(t, e, r, o, i, c) {
          var a = [];
          a.push(t + "=" + encodeURIComponent(e)), n.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), n.isString(o) && a.push("path=" + o), n.isString(i) && a.push("domain=" + i), !0 === c && a.push("secure"), document.cookie = a.join("; ");
        },
        read: function read(t) {
          var e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
          return e ? decodeURIComponent(e[3]) : null;
        },
        remove: function remove(t) {
          this.write(t, "", Date.now() - 864e5);
        }
      };
    }() : function () {
      return {
        write: function write() {},
        read: function read() {
          return null;
        },
        remove: function remove() {}
      };
    }();
  }, function (t, e, r) {
    "use strict";

    var n = r(178),
        o = r(179);

    t.exports = function (t, e) {
      return t && !n(e) ? o(t, e) : e;
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t, e) {
      return e ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(0),
        o = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

    t.exports = function (t) {
      var e,
          r,
          i,
          c = {};
      return t ? (n.forEach(t.split("\n"), function (t) {
        if (i = t.indexOf(":"), e = n.trim(t.substr(0, i)).toLowerCase(), r = n.trim(t.substr(i + 1)), e) {
          if (c[e] && o.indexOf(e) >= 0) return;
          c[e] = "set-cookie" === e ? (c[e] ? c[e] : []).concat([r]) : c[e] ? c[e] + ", " + r : r;
        }
      }), c) : c;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(0);
    t.exports = n.isStandardBrowserEnv() ? function () {
      function t(t) {
        var e = t;
        return r && (o.setAttribute("href", e), e = o.href), o.setAttribute("href", e), {
          href: o.href,
          protocol: o.protocol ? o.protocol.replace(/:$/, "") : "",
          host: o.host,
          search: o.search ? o.search.replace(/^\?/, "") : "",
          hash: o.hash ? o.hash.replace(/^#/, "") : "",
          hostname: o.hostname,
          port: o.port,
          pathname: "/" === o.pathname.charAt(0) ? o.pathname : "/" + o.pathname
        };
      }

      var e,
          r = /(msie|trident)/i.test(navigator.userAgent),
          o = document.createElement("a");
      return e = t(window.location.href), function (r) {
        var o = n.isString(r) ? t(r) : r;
        return o.protocol === e.protocol && o.host === e.host;
      };
    }() : function () {
      return function () {
        return !0;
      };
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      if ("function" != typeof t) throw new TypeError("executor must be a function.");
      var e;
      this.promise = new Promise(function (t) {
        e = t;
      });
      var r = this;
      t(function (t) {
        r.reason || (r.reason = new o(t), e(r.reason));
      });
    }

    var o = r(70);
    n.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }, n.source = function () {
      var t;
      return {
        token: new n(function (e) {
          t = e;
        }),
        cancel: t
      };
    }, t.exports = n;
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t) {
      return function (e) {
        return t.apply(null, e);
      };
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t) {
      return "object" == typeof t && !0 === t.isAxiosError;
    };
  }, function (t, e, r) {
    var n = r(47),
        o = n(Object.getPrototypeOf, Object);
    t.exports = o;
  }, function (t, e) {
    function r(t, e, r, n) {
      var o = -1,
          i = null == t ? 0 : t.length;

      for (n && i && (r = t[++o]); ++o < i;) {
        r = e(r, t[o], o, t);
      }

      return r;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t, e) {
      return function (r, n) {
        if (null == r) return r;
        if (!o(r)) return t(r, n);

        for (var i = r.length, c = e ? i : -1, a = Object(r); (e ? c-- : ++c < i) && !1 !== n(a[c], c, a);) {
          ;
        }

        return r;
      };
    }

    var o = r(8);
    t.exports = n;
  }, function (t, e) {
    function r(t, e, r, n, o) {
      return o(t, function (t, o, i) {
        r = n ? (n = !1, t) : e(r, t, o, i);
      }), r;
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(190),
        o = r(195),
        i = r(196),
        c = o(function (t, e) {
      return i(t) ? n(t, e) : [];
    });
    t.exports = c;
  }, function (t, e, r) {
    function n(t, e, r, n) {
      var p = -1,
          l = i,
          f = !0,
          h = t.length,
          m = [],
          d = e.length;
      if (!h) return m;
      r && (e = a(e, s(r))), n ? (l = c, f = !1) : e.length >= g && (l = u, f = !1, e = new o(e));

      t: for (; ++p < h;) {
        var y = t[p],
            b = null == r ? y : r(y);

        if (y = n || 0 !== y ? y : 0, f && b === b) {
          for (var v = d; v--;) {
            if (e[v] === b) continue t;
          }

          m.push(y);
        } else l(e, b, n) || m.push(y);
      }

      return m;
    }

    var o = r(51),
        i = r(191),
        c = r(194),
        a = r(31),
        s = r(46),
        u = r(52),
        g = 200;
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      return !!(null == t ? 0 : t.length) && o(t, e, 0) > -1;
    }

    var o = r(74);
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      return t !== t;
    }

    t.exports = r;
  }, function (t, e) {
    function r(t, e, r) {
      for (var n = r - 1, o = t.length; ++n < o;) {
        if (t[n] === e) return n;
      }

      return -1;
    }

    t.exports = r;
  }, function (t, e) {
    function r(t, e, r) {
      for (var n = -1, o = null == t ? 0 : t.length; ++n < o;) {
        if (r(e, t[n])) return !0;
      }

      return !1;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t, e) {
      return c(i(t, e, o), t + "");
    }

    var o = r(11),
        i = r(61),
        c = r(62);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return i(t) && o(t);
    }

    var o = r(8),
        i = r(4);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      if ((t = s(t)) && (r || void 0 === e)) return t.slice(0, u(t) + 1);
      if (!t || !(e = o(e))) return t;
      var n = a(t),
          g = c(n, a(e)) + 1;
      return i(n, 0, g).join("");
    }

    var o = r(57),
        i = r(198),
        c = r(200),
        a = r(201),
        s = r(56),
        u = r(76);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      var n = t.length;
      return r = void 0 === r ? n : r, !e && r >= n ? t : o(t, e, r);
    }

    var o = r(199);
    t.exports = n;
  }, function (t, e) {
    function r(t, e, r) {
      var n = -1,
          o = t.length;
      e < 0 && (e = -e > o ? 0 : o + e), r = r > o ? o : r, r < 0 && (r += o), o = e > r ? 0 : r - e >>> 0, e >>>= 0;

      for (var i = Array(o); ++n < o;) {
        i[n] = t[n + e];
      }

      return i;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t, e) {
      for (var r = t.length; r-- && o(e, t[r], 0) > -1;) {
        ;
      }

      return r;
    }

    var o = r(74);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return i(t) ? c(t) : o(t);
    }

    var o = r(202),
        i = r(203),
        c = r(204);
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      return t.split("");
    }

    t.exports = r;
  }, function (t, e) {
    function r(t) {
      return n.test(t);
    }

    var n = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
    t.exports = r;
  }, function (t, e) {
    function r(t) {
      return t.match(p) || [];
    }

    var n = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
        o = "\\ud83c[\\udffb-\\udfff]",
        i = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        c = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        a = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",
        s = "(?:\\u200d(?:" + ["[^\\ud800-\\udfff]", i, c].join("|") + ")[\\ufe0e\\ufe0f]?" + a + ")*",
        u = "[\\ufe0e\\ufe0f]?" + a + s,
        g = "(?:" + ["[^\\ud800-\\udfff]" + n + "?", n, i, c, "[\\ud800-\\udfff]"].join("|") + ")",
        p = RegExp(o + "(?=" + o + ")|" + g + u, "g");
    t.exports = r;
  }, function (t, e, r) {
    "use strict";

    r.d(e, "c", function () {
      return n;
    }), r.d(e, "b", function () {
      return o;
    }), r.d(e, "a", function () {
      return i;
    });
    var n = [{
      path: "marketplace/show",
      method: "get"
    }, {
      path: "users/show",
      method: "get"
    }, {
      path: "current_user/show",
      method: "get"
    }, {
      path: "current_user/create",
      method: "post"
    }, {
      path: "current_user/create_with_idp",
      method: "post"
    }, {
      path: "current_user/update_profile",
      method: "post"
    }, {
      path: "current_user/change_email",
      method: "post"
    }, {
      path: "current_user/change_password",
      method: "post"
    }, {
      path: "current_user/delete",
      method: "post"
    }, {
      path: "current_user/verify_email",
      method: "post"
    }, {
      path: "current_user/send_verification_email",
      method: "post"
    }, {
      path: "current_user/create_stripe_account",
      method: "post"
    }, {
      path: "current_user/update_stripe_account",
      method: "post"
    }, {
      path: "current_user/delete_stripe_account",
      method: "post"
    }, {
      path: "password_reset/request",
      method: "post"
    }, {
      path: "password_reset/reset",
      method: "post"
    }, {
      path: "listings/show",
      method: "get"
    }, {
      path: "own_listings/show",
      method: "get"
    }, {
      path: "listings/query",
      method: "get"
    }, {
      path: "own_listings/query",
      method: "get"
    }, {
      path: "listings/search",
      method: "get"
    }, {
      path: "own_listings/create",
      method: "post"
    }, {
      path: "own_listings/create_draft",
      method: "post"
    }, {
      path: "own_listings/publish_draft",
      method: "post"
    }, {
      path: "own_listings/discard_draft",
      method: "post"
    }, {
      path: "own_listings/update",
      method: "post"
    }, {
      path: "own_listings/open",
      method: "post"
    }, {
      path: "own_listings/close",
      method: "post"
    }, {
      path: "own_listings/add_image",
      method: "post"
    }, {
      path: "availability_exceptions/create",
      method: "post"
    }, {
      path: "availability_exceptions/delete",
      method: "post"
    }, {
      path: "availability_exceptions/query",
      method: "get"
    }, {
      path: "images/upload",
      method: "post",
      multipart: !0
    }, {
      path: "transactions/initiate",
      method: "post"
    }, {
      path: "transactions/initiate_speculative",
      method: "post"
    }, {
      path: "transactions/transition",
      method: "post"
    }, {
      path: "transactions/transition_speculative",
      method: "post"
    }, {
      path: "transactions/query",
      method: "get"
    }, {
      path: "transactions/show",
      method: "get"
    }, {
      path: "process_transitions/query",
      method: "get"
    }, {
      path: "bookings/query",
      method: "get"
    }, {
      path: "messages/query",
      method: "get"
    }, {
      path: "messages/send",
      method: "post"
    }, {
      path: "reviews/query",
      method: "get"
    }, {
      path: "reviews/show",
      method: "get"
    }, {
      path: "timeslots/query",
      method: "get"
    }, {
      path: "stripe_account/create",
      method: "post"
    }, {
      path: "stripe_account/fetch",
      method: "get"
    }, {
      path: "stripe_account/update",
      method: "post"
    }, {
      path: "stripe_account_links/create",
      method: "post"
    }, {
      path: "stripe_persons/create",
      method: "post"
    }, {
      path: "stripe_setup_intents/create",
      method: "post"
    }, {
      path: "stripe_customer/create",
      method: "post"
    }, {
      path: "stripe_customer/add_payment_method",
      method: "post"
    }, {
      path: "stripe_customer/delete_payment_method",
      method: "post"
    }, {
      path: "stock_adjustments/query",
      method: "get"
    }, {
      path: "stock_adjustments/create",
      method: "post"
    }, {
      path: "stock/compare_and_set",
      method: "post"
    }],
        o = [{
      path: "token",
      method: "post"
    }, {
      path: "revoke",
      method: "post"
    }, {
      path: "auth_with_idp",
      method: "post"
    }],
        i = [{
      pathFn: function pathFn(t) {
        var e = t.clientId,
            r = t.version,
            n = t.assetPath;
        return "pub/".concat(e, "/v/").concat(r, "/").concat(n);
      },
      method: "get",
      name: "byVersion"
    }, {
      pathFn: function pathFn(t) {
        var e = t.clientId,
            r = t.alias,
            n = t.assetPath;
        return "pub/".concat(e, "/a/").concat(r, "/").concat(n);
      },
      method: "get",
      name: "byAlias"
    }];
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    var o = r(77),
        i = r.n(o),
        c = r(59),
        a = r.n(c),
        s = r(34),
        u = function u(t) {
      return encodeURIComponent(t).replace(/%2C/gi, ",");
    },
        g = function t(e) {
      var r;
      if (e instanceof s.UUID) r = e.uuid;else if (e instanceof s.LatLng) r = "".concat(e.lat, ",").concat(e.lng);else if (e instanceof s.LatLngBounds) r = "".concat(e.ne.lat, ",").concat(e.ne.lng, ",").concat(e.sw.lat, ",").concat(e.sw.lng);else if (Array.isArray(e)) r = e.map(t);else if (e instanceof Date) r = e.toISOString();else if (null == e) r = e;else {
        if ("object" === n(e)) throw new Error("unknown-type");
        r = e;
      }
      return r;
    },
        p = function p(t, e) {
      var r;

      try {
        r = g(e);
      } catch (r) {
        throw r && "unknown-type" === r.message ? new Error("Don't know how to serialize query parameter '".concat(t, "': ").concat(e)) : r;
      }

      return null == r ? null : [t, u(r)];
    },
        l = function l(t) {
      return a()(i()(t, function (t, e) {
        var r = p(e, t);
        return r ? r.join("=") : null;
      })).join("&");
    };

    e.a = l;
  }, function (t, e, r) {
    function n(t, e) {
      var r = -1,
          n = i(t) ? Array(t.length) : [];
      return o(t, function (t, o, i) {
        n[++r] = e(t, o, i);
      }), n;
    }

    var o = r(73),
        i = r(8);
    t.exports = n;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function a(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function s(t, e, r) {
      return e && a(t.prototype, e), r && a(t, r), t;
    }

    r.d(e, "a", function () {
      return g;
    });

    var u = function u(t) {
      var e = t.token_type && t.token_type.toLowerCase();

      switch (e) {
        case "bearer":
          return "Bearer ".concat(t.access_token);

        default:
          throw new Error("Unknown token type: ".concat(e));
      }
    },
        g = function () {
      function t() {
        c(this, t);
      }

      return s(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.authToken,
              r = t.headers,
              n = void 0 === r ? {} : r;
          return e ? o({}, t, {
            headers: o({}, n, {}, {
              Authorization: u(e)
            })
          }) : t;
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return c(t) || i(t) || o();
    }

    function o() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }

    function i(t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }

    function c(t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = new Array(t.length); e < t.length; e++) {
          r[e] = t[e];
        }

        return r;
      }
    }

    function a(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function s(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? a(r, !0).forEach(function (e) {
          u(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : a(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function u(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function g(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function p(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function l(t, e, r) {
      return e && p(t.prototype, e), r && p(t, r), t;
    }

    r.d(e, "a", function () {
      return d;
    });

    var f = r(20),
        h = r(21),
        m = r(22),
        d = function () {
      function t() {
        g(this, t);
      }

      return l(t, [{
        key: "enter",
        value: function value(e) {
          var r = e.enterQueue,
              o = e.refreshTokenRetry;
          o = void 0 === o ? {} : o;
          var i = o.attempts,
              c = void 0 === i ? 0 : i;
          return s({}, e, {
            refreshTokenRetry: {
              retryQueue: [].concat(n(r), [new t()]),
              attempts: c + 1
            }
          });
        }
      }, {
        key: "error",
        value: function value(t) {
          var e = t.authToken,
              r = t.clientId,
              o = t.tokenStore,
              i = t.endpointInterceptors,
              c = t.refreshTokenRetry,
              a = c.retryQueue,
              u = c.attempts;
          return u > 1 ? t : t.res && 401 === t.res.status && e.refresh_token ? Object(f.a)([new h.a(), new m.a()].concat(n(i.auth.token)))({
            params: {
              client_id: r,
              grant_type: "refresh_token",
              refresh_token: e.refresh_token
            },
            tokenStore: o
          }).then(function (e) {
            var r = e.authToken;
            return s({}, t, {
              authToken: r,
              enterQueue: a,
              error: null
            });
          }).catch(function (e) {
            return s({}, t, {
              refreshTokenRetry: {
                retryQueue: a,
                attempts: u,
                res: e.response
              }
            });
          }) : t;
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return c(t) || i(t) || o();
    }

    function o() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }

    function i(t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }

    function c(t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = new Array(t.length); e < t.length; e++) {
          r[e] = t[e];
        }

        return r;
      }
    }

    function a(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function s(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? a(r, !0).forEach(function (e) {
          u(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : a(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function u(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function g(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function p(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function l(t, e, r) {
      return e && p(t.prototype, e), r && p(t, r), t;
    }

    r.d(e, "a", function () {
      return d;
    });

    var f = r(20),
        h = r(21),
        m = r(22),
        d = function () {
      function t() {
        g(this, t);
      }

      return l(t, [{
        key: "enter",
        value: function value(e) {
          var r = e.enterQueue,
              o = e.anonTokenRetry;
          o = void 0 === o ? {} : o;
          var i = o.attempts,
              c = void 0 === i ? 0 : i;
          return s({}, e, {
            anonTokenRetry: {
              retryQueue: [].concat(n(r), [new t()]),
              attempts: c + 1
            }
          });
        }
      }, {
        key: "error",
        value: function value(t) {
          var e = t.clientId,
              r = t.tokenStore,
              o = t.endpointInterceptors,
              i = t.anonTokenRetry,
              c = i.retryQueue;
          return i.attempts > 1 ? t : t.res && 401 === t.res.status ? Object(f.a)([new h.a(), new m.a()].concat(n(o.auth.token)))({
            params: {
              client_id: e,
              grant_type: "client_credentials",
              scope: "public-read"
            },
            tokenStore: r
          }).then(function (e) {
            var r = e.authToken;
            return s({}, t, {
              authToken: r,
              enterQueue: c,
              error: null
            });
          }) : t;
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function a(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function s(t, e, r) {
      return e && a(t.prototype, e), r && a(t, r), t;
    }

    r.d(e, "a", function () {
      return p;
    });

    var u = r(29),
        g = r.n(u),
        p = function () {
      function t() {
        c(this, t);
      }

      return s(t, [{
        key: "leave",
        value: function value(e) {
          return t.clearTokenAndResque(e);
        }
      }, {
        key: "error",
        value: function value(e) {
          var r = e.res || {},
              n = r.status,
              o = g()(e, ["refreshTokenRetry", "res", "status"]);
          return 401 === n && 401 === o ? t.clearTokenAndResque(e) : e;
        }
      }], [{
        key: "clearTokenAndResque",
        value: function value(t) {
          var e = t.tokenStore;
          return e ? Promise.resolve().then(e.removeToken).then(function () {
            return o({}, t, {
              error: null
            });
          }) : o({}, t, {
            error: null
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function a(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function s(t, e, r) {
      return e && a(t.prototype, e), r && a(t, r), t;
    }

    r.d(e, "a", function () {
      return u;
    });

    var u = function () {
      function t() {
        c(this, t);
      }

      return s(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.authToken;
          e = void 0 === e ? {} : e;
          var r = e.refresh_token;
          return r ? o({}, t, {
            params: {
              token: r
            }
          }) : o({}, t, {
            enterQueue: []
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t) {
      return u(t) || s(t) || a();
    }

    function a() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }

    function s(t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }

    function u(t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = new Array(t.length); e < t.length; e++) {
          r[e] = t[e];
        }

        return r;
      }
    }

    function g(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function p(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function l(t, e, r) {
      return e && p(t.prototype, e), r && p(t, r), t;
    }

    r.d(e, "a", function () {
      return d;
    });

    var f = r(20),
        h = r(21),
        m = r(22),
        d = function () {
      function t() {
        g(this, t);
      }

      return l(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.tokenStore,
              r = t.authToken,
              n = t.endpointInterceptors,
              i = t.clientId;
          return r ? t : Object(f.a)([new h.a(), new m.a()].concat(c(n.auth.token)))({
            params: {
              client_id: i,
              grant_type: "client_credentials",
              scope: "public-read"
            },
            tokenStore: e
          }).then(function (e) {
            var r = e.authToken;
            return o({}, t, {
              authToken: r
            });
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function a(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function s(t, e, r) {
      return e && a(t.prototype, e), r && a(t, r), t;
    }

    r.d(e, "a", function () {
      return u;
    });

    var u = function () {
      function t() {
        c(this, t);
      }

      return s(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.tokenStore;
          return e ? Promise.resolve().then(e.getToken).then(function (e) {
            return e ? o({}, t, {
              authToken: e
            }) : t;
          }) : t;
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = a(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) {
          r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    function a(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function s(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function u(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function g(t, e, r) {
      return e && u(t.prototype, e), r && u(t, r), t;
    }

    r.d(e, "a", function () {
      return p;
    });

    var p = function () {
      function t() {
        s(this, t);
      }

      return g(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.clientId,
              r = t.params;
          return o({}, c(t, ["clientId", "params"]), {
            clientId: e,
            params: o({}, r, {
              client_id: e
            })
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = a(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) {
          r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    function a(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function s(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function u(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function g(t, e, r) {
      return e && u(t.prototype, e), r && u(t, r), t;
    }

    r.d(e, "a", function () {
      return p;
    });

    var p = function () {
      function t() {
        s(this, t);
      }

      return g(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.clientSecret,
              r = t.params,
              n = c(t, ["clientSecret", "params"]);
          if (!e) throw new Error("SDK instance is missing the clientSecret config.");
          return o({}, n, {
            clientSecret: e,
            params: o({}, r, {
              client_secret: e
            })
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = a(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) {
          r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    function a(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function s(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function u(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function g(t, e, r) {
      return e && u(t.prototype, e), r && u(t, r), t;
    }

    r.d(e, "a", function () {
      return p;
    });

    var p = function () {
      function t() {
        s(this, t);
      }

      return g(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.params,
              r = c(t, ["params"]),
              n = e.idpClientId;
          return o({}, r, {
            idpClientId: n,
            params: o({}, e, {
              idp_client_id: n
            })
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = a(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) {
          r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    function a(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function s(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function u(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function g(t, e, r) {
      return e && u(t.prototype, e), r && u(t, r), t;
    }

    r.d(e, "a", function () {
      return p;
    });

    var p = function () {
      function t() {
        s(this, t);
      }

      return g(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.params,
              r = c(t, ["params"]),
              n = e.idpId;
          return o({}, r, {
            idpId: n,
            params: o({}, e, {
              idp_id: n
            })
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = a(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) {
          r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    function a(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function s(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function u(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function g(t, e, r) {
      return e && u(t.prototype, e), r && u(t, r), t;
    }

    r.d(e, "a", function () {
      return p;
    });

    var p = function () {
      function t() {
        s(this, t);
      }

      return g(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.params,
              r = c(t, ["params"]),
              n = e.idpToken;
          return o({}, r, {
            idpToken: n,
            params: o({}, e, {
              idp_token: n
            })
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function a(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function s(t, e, r) {
      return e && a(t.prototype, e), r && a(t, r), t;
    }

    r.d(e, "a", function () {
      return u;
    });

    var u = function () {
      function t() {
        c(this, t);
      }

      return s(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.authToken,
              r = t.params;
          return e && e.access_token ? o({}, t, {
            params: o({}, r, {
              subject_token: e.access_token
            })
          }) : t;
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = a(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) {
          r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    function a(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function s(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function u(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function g(t, e, r) {
      return e && u(t.prototype, e), r && u(t, r), t;
    }

    r.d(e, "a", function () {
      return p;
    });

    var p = function () {
      function t() {
        s(this, t);
      }

      return g(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.params,
              r = c(t, ["params"]),
              n = e.username,
              i = e.password,
              a = e.code;
          return n && i ? o({}, r, {
            params: o({
              grant_type: "password"
            }, e)
          }) : a ? o({}, r, {
            params: o({
              grant_type: "authorization_code"
            }, e)
          }) : o({}, r, {
            params: o({}, e)
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = a(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) {
          r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    function a(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function s(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function u(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function g(t, e, r) {
      return e && u(t.prototype, e), r && u(t, r), t;
    }

    r.d(e, "a", function () {
      return p;
    });

    var p = function () {
      function t() {
        s(this, t);
      }

      return g(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.params;
          return o({}, c(t, ["params"]), {
            params: o({}, e, {
              grant_type: "token_exchange"
            })
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = a(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) {
          r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    function a(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function s(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function u(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function g(t, e, r) {
      return e && u(t.prototype, e), r && u(t, r), t;
    }

    r.d(e, "a", function () {
      return p;
    });

    var p = function () {
      function t() {
        s(this, t);
      }

      return g(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.params,
              r = c(t, ["params"]),
              n = e.username,
              i = e.password;
          return n && i ? o({}, r, {
            params: o({
              scope: "user"
            }, e)
          }) : o({}, r, {
            params: o({}, e)
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function a(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function s(t, e, r) {
      return e && a(t.prototype, e), r && a(t, r), t;
    }

    r.d(e, "a", function () {
      return u;
    });

    var u = function () {
      function t() {
        c(this, t);
      }

      return s(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.tokenStore;
          return e ? Promise.resolve().then(e.getToken).then(function (e) {
            if (e) {
              var r = e.scope;

              if (r) {
                var n = r.split(" "),
                    i = "public-read" === r;
                return o({}, t, {
                  res: {
                    scopes: n,
                    isAnonymous: i,
                    grantType: i ? "client_credentials" : "refresh_token"
                  }
                });
              }

              var c = !e.refresh_token;
              return o({}, t, {
                res: {
                  isAnonymous: c,
                  grantType: c ? "client_credentials" : "refresh_token"
                }
              });
            }

            return o({}, t, {
              res: {}
            });
          }) : o({}, t, {
            res: {}
          });
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = a(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) {
          r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    function a(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function s(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function u(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function g(t, e, r) {
      return e && u(t.prototype, e), r && u(t, r), t;
    }

    r.d(e, "a", function () {
      return m;
    });

    var p = r(33),
        l = r.n(p),
        f = r(72),
        h = r.n(f),
        m = function () {
      function t() {
        s(this, t);
      }

      return g(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.params,
              r = c(t, ["params"]);

          if (h()(e)) {
            if ("undefined" == typeof FormData) throw new Error("Don't know how to create multipart request from Object, when the FormData is undefined");
            return o({
              params: l()(e, function (t, e, r) {
                return t.append(r, e), t;
              }, new FormData())
            }, r);
          }

          return o({
            params: e
          }, r);
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = a(t, e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);

        for (n = 0; n < i.length; n++) {
          r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    function a(t, e) {
      if (null == t) return {};
      var r,
          n,
          o = {},
          i = Object.keys(t);

      for (n = 0; n < i.length; n++) {
        r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
      }

      return o;
    }

    function s(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function u(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function g(t, e, r) {
      return e && u(t.prototype, e), r && u(t, r), t;
    }

    r.d(e, "a", function () {
      return l;
    });

    var p = r(35),
        l = function () {
      function t() {
        s(this, t);
      }

      return g(t, [{
        key: "enter",
        value: function value(t) {
          var e = t.params,
              r = t.headers,
              n = void 0 === r ? {} : r,
              i = t.typeHandlers,
              a = t.transitVerbose,
              s = c(t, ["params", "headers", "typeHandlers", "transitVerbose"]);
          return "application/transit+json" === n["Content-Type"] ? t : o({
            params: Object(p.a)(i, {
              verbose: a
            }).writer.write(e),
            headers: o({}, n, {
              "Content-Type": "application/transit+json"
            }),
            typeHandlers: i,
            transitVerbose: a
          }, s);
        }
      }]), t;
    }();
  }, function (t, e, r) {
    var n = r(228),
        o = r(229),
        i = n(o);
    t.exports = i;
  }, function (t, e, r) {
    function n(t) {
      return function (e, r, n) {
        var a = Object(e);

        if (!i(e)) {
          var s = o(r, 3);
          e = c(e), r = function r(t) {
            return s(a[t], t, a);
          };
        }

        var u = t(e, r, n);
        return u > -1 ? a[s ? e[u] : u] : void 0;
      };
    }

    var o = r(9),
        i = r(8),
        c = r(12);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      var n = null == t ? 0 : t.length;
      if (!n) return -1;
      var s = null == r ? 0 : c(r);
      return s < 0 && (s = a(n + s, 0)), o(t, i(e, 3), s);
    }

    var o = r(75),
        i = r(9),
        c = r(230),
        a = Math.max;
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = o(t),
          r = e % 1;
      return e === e ? r ? e - r : e : 0;
    }

    var o = r(231);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      if (!t) return 0 === t ? t : 0;

      if ((t = o(t)) === i || t === -i) {
        return (t < 0 ? -1 : 1) * c;
      }

      return t === t ? t : 0;
    }

    var o = r(232),
        i = 1 / 0,
        c = 1.7976931348623157e308;
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      if ("number" == typeof t) return t;
      if (c(t)) return a;

      if (i(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = i(e) ? e + "" : e;
      }

      if ("string" != typeof t) return 0 === t ? t : +t;
      t = o(t);
      var r = u.test(t);
      return r || g.test(t) ? p(t.slice(2), r ? 2 : 8) : s.test(t) ? a : +t;
    }

    var o = r(233),
        i = r(6),
        c = r(19),
        a = NaN,
        s = /^[-+]0x[0-9a-f]+$/i,
        u = /^0b[01]+$/i,
        g = /^0o[0-7]+$/i,
        p = parseInt;
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return t ? t.slice(0, o(t) + 1).replace(i, "") : t;
    }

    var o = r(76),
        i = /^\s+/;
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      for (var e = -1, r = null == t ? 0 : t.length, n = {}; ++e < r;) {
        var o = t[e];
        n[o[0]] = o[1];
      }

      return n;
    }

    t.exports = r;
  }, function (module, exports, __webpack_require__) {
    (function (global) {
      var $jscomp = $jscomp || {};
      $jscomp.scope = {}, $jscomp.checkStringArgs = function (t, e, r) {
        if (null == t) throw new TypeError("The 'this' value for String.prototype." + r + " must not be null or undefined");
        if (e instanceof RegExp) throw new TypeError("First argument to String.prototype." + r + " must not be a regular expression");
        return t + "";
      }, $jscomp.defineProperty = "function" == typeof Object.defineProperties ? Object.defineProperty : function (t, e, r) {
        t != Array.prototype && t != Object.prototype && (t[e] = r.value);
      }, $jscomp.getGlobal = function (t) {
        return "undefined" != typeof window && window === t ? t : void 0 !== global && null != global ? global : t;
      }, $jscomp.global = $jscomp.getGlobal(this), $jscomp.polyfill = function (t, e, r, n) {
        if (e) {
          for (r = $jscomp.global, t = t.split("."), n = 0; n < t.length - 1; n++) {
            var o = t[n];
            o in r || (r[o] = {}), r = r[o];
          }

          t = t[t.length - 1], n = r[t], e = e(n), e != n && null != e && $jscomp.defineProperty(r, t, {
            configurable: !0,
            writable: !0,
            value: e
          });
        }
      }, $jscomp.polyfill("String.prototype.repeat", function (t) {
        return t || function (t) {
          var e = $jscomp.checkStringArgs(this, null, "repeat");
          if (0 > t || 1342177279 < t) throw new RangeError("Invalid count value");
          t |= 0;

          for (var r = ""; t;) {
            1 & t && (r += e), (t >>>= 1) && (e += e);
          }

          return r;
        };
      }, "es6-impl", "es3"), $jscomp.SYMBOL_PREFIX = "jscomp_symbol_", $jscomp.initSymbol = function () {
        $jscomp.initSymbol = function () {}, $jscomp.global.Symbol || ($jscomp.global.Symbol = $jscomp.Symbol);
      }, $jscomp.symbolCounter_ = 0, $jscomp.Symbol = function (t) {
        return $jscomp.SYMBOL_PREFIX + (t || "") + $jscomp.symbolCounter_++;
      }, $jscomp.initSymbolIterator = function () {
        $jscomp.initSymbol();
        var t = $jscomp.global.Symbol.iterator;
        t || (t = $jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator")), "function" != typeof Array.prototype[t] && $jscomp.defineProperty(Array.prototype, t, {
          configurable: !0,
          writable: !0,
          value: function value() {
            return $jscomp.arrayIterator(this);
          }
        }), $jscomp.initSymbolIterator = function () {};
      }, $jscomp.arrayIterator = function (t) {
        var e = 0;
        return $jscomp.iteratorPrototype(function () {
          return e < t.length ? {
            done: !1,
            value: t[e++]
          } : {
            done: !0
          };
        });
      }, $jscomp.iteratorPrototype = function (t) {
        return $jscomp.initSymbolIterator(), t = {
          next: t
        }, t[$jscomp.global.Symbol.iterator] = function () {
          return this;
        }, t;
      }, $jscomp.iteratorFromArray = function (t, e) {
        $jscomp.initSymbolIterator(), t instanceof String && (t += "");
        var r = 0,
            n = {
          next: function next() {
            if (r < t.length) {
              var o = r++;
              return {
                value: e(o, t[o]),
                done: !1
              };
            }

            return n.next = function () {
              return {
                done: !0,
                value: void 0
              };
            }, n.next();
          }
        };
        return n[Symbol.iterator] = function () {
          return n;
        }, n;
      }, $jscomp.polyfill("Array.prototype.entries", function (t) {
        return t || function () {
          return $jscomp.iteratorFromArray(this, function (t, e) {
            return [t, e];
          });
        };
      }, "es6-impl", "es3"), $jscomp.polyfill("Array.prototype.keys", function (t) {
        return t || function () {
          return $jscomp.iteratorFromArray(this, function (t) {
            return t;
          });
        };
      }, "es6-impl", "es3"), $jscomp.polyfill("Array.prototype.values", function (t) {
        return t || function () {
          return $jscomp.iteratorFromArray(this, function (t, e) {
            return e;
          });
        };
      }, "es6", "es3");
      var COMPILED = !0,
          goog = goog || {};
      goog.global = this, goog.isDef = function (t) {
        return void 0 !== t;
      }, goog.exportPath_ = function (t, e, r) {
        t = t.split("."), r = r || goog.global, t[0] in r || !r.execScript || r.execScript("var " + t[0]);

        for (var n; t.length && (n = t.shift());) {
          !t.length && goog.isDef(e) ? r[n] = e : r = r[n] && r[n] !== Object.prototype[n] ? r[n] : r[n] = {};
        }
      }, goog.define = function (t, e) {
        var r = e;
        COMPILED || (goog.global.CLOSURE_UNCOMPILED_DEFINES && Object.prototype.hasOwnProperty.call(goog.global.CLOSURE_UNCOMPILED_DEFINES, t) ? r = goog.global.CLOSURE_UNCOMPILED_DEFINES[t] : goog.global.CLOSURE_DEFINES && Object.prototype.hasOwnProperty.call(goog.global.CLOSURE_DEFINES, t) && (r = goog.global.CLOSURE_DEFINES[t])), goog.exportPath_(t, r);
      }, goog.DEBUG = !0, goog.LOCALE = "en", goog.TRUSTED_SITE = !0, goog.STRICT_MODE_COMPATIBLE = !1, goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG, goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1, goog.provide = function (t) {
        if (goog.isInModuleLoader_()) throw Error("goog.provide can not be used within a goog.module.");
        if (!COMPILED && goog.isProvided_(t)) throw Error('Namespace "' + t + '" already declared.');
        goog.constructNamespace_(t);
      }, goog.constructNamespace_ = function (t, e) {
        if (!COMPILED) {
          delete goog.implicitNamespaces_[t];

          for (var r = t; (r = r.substring(0, r.lastIndexOf("."))) && !goog.getObjectByName(r);) {
            goog.implicitNamespaces_[r] = !0;
          }
        }

        goog.exportPath_(t, e);
      }, goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/, goog.module = function (t) {
        if (!goog.isString(t) || !t || -1 == t.search(goog.VALID_MODULE_RE_)) throw Error("Invalid module identifier");
        if (!goog.isInModuleLoader_()) throw Error("Module " + t + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
        if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");

        if (goog.moduleLoaderState_.moduleName = t, !COMPILED) {
          if (goog.isProvided_(t)) throw Error('Namespace "' + t + '" already declared.');
          delete goog.implicitNamespaces_[t];
        }
      }, goog.module.get = function (t) {
        return goog.module.getInternal_(t);
      }, goog.module.getInternal_ = function (t) {
        if (!COMPILED) {
          if (t in goog.loadedModules_) return goog.loadedModules_[t];
          if (!goog.implicitNamespaces_[t]) return t = goog.getObjectByName(t), null != t ? t : null;
        }

        return null;
      }, goog.moduleLoaderState_ = null, goog.isInModuleLoader_ = function () {
        return null != goog.moduleLoaderState_;
      }, goog.module.declareLegacyNamespace = function () {
        if (!COMPILED && !goog.isInModuleLoader_()) throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
        if (!COMPILED && !goog.moduleLoaderState_.moduleName) throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
        goog.moduleLoaderState_.declareLegacyNamespace = !0;
      }, goog.setTestOnly = function (t) {
        if (goog.DISALLOW_TEST_ONLY_CODE) throw t = t || "", Error("Importing test-only code into non-debug environment" + (t ? ": " + t : "."));
      }, goog.forwardDeclare = function (t) {}, COMPILED || (goog.isProvided_ = function (t) {
        return t in goog.loadedModules_ || !goog.implicitNamespaces_[t] && goog.isDefAndNotNull(goog.getObjectByName(t));
      }, goog.implicitNamespaces_ = {
        "goog.module": !0
      }), goog.getObjectByName = function (t, e) {
        for (var r, n = t.split("."), o = e || goog.global; r = n.shift();) {
          if (!goog.isDefAndNotNull(o[r])) return null;
          o = o[r];
        }

        return o;
      }, goog.globalize = function (t, e) {
        var r,
            n = e || goog.global;

        for (r in t) {
          n[r] = t[r];
        }
      }, goog.addDependency = function (t, e, r, n) {
        if (goog.DEPENDENCIES_ENABLED) {
          var o;
          t = t.replace(/\\/g, "/");
          var i = goog.dependencies_;
          n && "boolean" != typeof n || (n = n ? {
            module: "goog"
          } : {});

          for (var c = 0; o = e[c]; c++) {
            i.nameToPath[o] = t, i.loadFlags[t] = n;
          }

          for (n = 0; e = r[n]; n++) {
            t in i.requires || (i.requires[t] = {}), i.requires[t][e] = !0;
          }
        }
      }, goog.ENABLE_DEBUG_LOADER = !0, goog.logToConsole_ = function (t) {
        goog.global.console && goog.global.console.error(t);
      }, goog.require = function (t) {
        if (!COMPILED) {
          if (goog.ENABLE_DEBUG_LOADER && goog.IS_OLD_IE_ && goog.maybeProcessDeferredDep_(t), goog.isProvided_(t)) {
            if (goog.isInModuleLoader_()) return goog.module.getInternal_(t);
          } else if (goog.ENABLE_DEBUG_LOADER) {
            var e = goog.getPathFromDeps_(t);
            if (!e) throw t = "goog.require could not find: " + t, goog.logToConsole_(t), Error(t);
            goog.writeScripts_(e);
          }

          return null;
        }
      }, goog.basePath = "", goog.nullFunction = function () {}, goog.abstractMethod = function () {
        throw Error("unimplemented abstract method");
      }, goog.addSingletonGetter = function (t) {
        t.instance_ = void 0, t.getInstance = function () {
          return t.instance_ ? t.instance_ : (goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = t), t.instance_ = new t());
        };
      }, goog.instantiatedSingletons_ = [], goog.LOAD_MODULE_USING_EVAL = !0, goog.SEAL_MODULE_EXPORTS = goog.DEBUG, goog.loadedModules_ = {}, goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER, goog.TRANSPILE = "detect", goog.TRANSPILER = "transpile.js", goog.DEPENDENCIES_ENABLED && (goog.dependencies_ = {
        loadFlags: {},
        nameToPath: {},
        requires: {},
        visited: {},
        written: {},
        deferred: {}
      }, goog.inHtmlDocument_ = function () {
        var t = goog.global.document;
        return null != t && "write" in t;
      }, goog.findBasePath_ = function () {
        if (goog.isDef(goog.global.CLOSURE_BASE_PATH)) goog.basePath = goog.global.CLOSURE_BASE_PATH;else if (goog.inHtmlDocument_()) for (var t = goog.global.document.getElementsByTagName("SCRIPT"), e = t.length - 1; 0 <= e; --e) {
          var r = t[e].src,
              n = r.lastIndexOf("?"),
              n = -1 == n ? r.length : n;

          if ("base.js" == r.substr(n - 7, 7)) {
            goog.basePath = r.substr(0, n - 7);
            break;
          }
        }
      }, goog.importScript_ = function (t, e) {
        (goog.global.CLOSURE_IMPORT_SCRIPT || goog.writeScriptTag_)(t, e) && (goog.dependencies_.written[t] = !0);
      }, goog.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.oldIeWaiting_ = !1, goog.importProcessedScript_ = function (t, e, r) {
        goog.importScript_("", 'goog.retrieveAndExec_("' + t + '", ' + e + ", " + r + ");");
      }, goog.queuedModules_ = [], goog.wrapModule_ = function (t, e) {
        return goog.LOAD_MODULE_USING_EVAL && goog.isDef(goog.global.JSON) ? "goog.loadModule(" + goog.global.JSON.stringify(e + "\n//# sourceURL=" + t + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + e + "\n;return exports});\n//# sourceURL=" + t + "\n";
      }, goog.loadQueuedModules_ = function () {
        var t = goog.queuedModules_.length;

        if (0 < t) {
          var e = goog.queuedModules_;
          goog.queuedModules_ = [];

          for (var r = 0; r < t; r++) {
            goog.maybeProcessDeferredPath_(e[r]);
          }
        }

        goog.oldIeWaiting_ = !1;
      }, goog.maybeProcessDeferredDep_ = function (t) {
        goog.isDeferredModule_(t) && goog.allDepsAreAvailable_(t) && (t = goog.getPathFromDeps_(t), goog.maybeProcessDeferredPath_(goog.basePath + t));
      }, goog.isDeferredModule_ = function (t) {
        var e = (t = goog.getPathFromDeps_(t)) && goog.dependencies_.loadFlags[t] || {},
            r = e.lang || "es3";
        return !(!t || "goog" != e.module && !goog.needsTranspile_(r)) && goog.basePath + t in goog.dependencies_.deferred;
      }, goog.allDepsAreAvailable_ = function (t) {
        if ((t = goog.getPathFromDeps_(t)) && t in goog.dependencies_.requires) for (var e in goog.dependencies_.requires[t]) {
          if (!goog.isProvided_(e) && !goog.isDeferredModule_(e)) return !1;
        }
        return !0;
      }, goog.maybeProcessDeferredPath_ = function (t) {
        if (t in goog.dependencies_.deferred) {
          var e = goog.dependencies_.deferred[t];
          delete goog.dependencies_.deferred[t], goog.globalEval(e);
        }
      }, goog.loadModuleFromUrl = function (t) {
        goog.retrieveAndExec_(t, !0, !1);
      }, goog.writeScriptSrcNode_ = function (t) {
        goog.global.document.write('<script type="text/javascript" src="' + t + '"><\/script>');
      }, goog.appendScriptSrcNode_ = function (t) {
        var e = goog.global.document,
            r = e.createElement("script");
        r.type = "text/javascript", r.src = t, r.defer = !1, r.async = !1, e.head.appendChild(r);
      }, goog.writeScriptTag_ = function (t, e) {
        if (goog.inHtmlDocument_()) {
          var r = goog.global.document;

          if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && "complete" == r.readyState) {
            if (/\bdeps.js$/.test(t)) return !1;
            throw Error('Cannot write "' + t + '" after document load');
          }

          if (void 0 === e) {
            if (goog.IS_OLD_IE_) {
              goog.oldIeWaiting_ = !0;
              var n = " onreadystatechange='goog.onScriptLoad_(this, " + ++goog.lastNonModuleScriptIndex_ + ")' ";
              r.write('<script type="text/javascript" src="' + t + '"' + n + "><\/script>");
            } else goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING ? goog.appendScriptSrcNode_(t) : goog.writeScriptSrcNode_(t);
          } else r.write('<script type="text/javascript">' + goog.protectScriptTag_(e) + "<\/script>");
          return !0;
        }

        return !1;
      }, goog.protectScriptTag_ = function (t) {
        return t.replace(/<\/(SCRIPT)/gi, "\\x3c/$1");
      }, goog.needsTranspile_ = function (t) {
        if ("always" == goog.TRANSPILE) return !0;
        if ("never" == goog.TRANSPILE) return !1;
        if (goog.requiresTranspilation_ || (goog.requiresTranspilation_ = goog.createRequiresTranspilation_()), t in goog.requiresTranspilation_) return goog.requiresTranspilation_[t];
        throw Error("Unknown language mode: " + t);
      }, goog.requiresTranspilation_ = null, goog.lastNonModuleScriptIndex_ = 0, goog.onScriptLoad_ = function (t, e) {
        return "complete" == t.readyState && goog.lastNonModuleScriptIndex_ == e && goog.loadQueuedModules_(), !0;
      }, goog.writeScripts_ = function (t) {
        function e(t) {
          if (!(t in o.written || t in o.visited)) {
            if (o.visited[t] = !0, t in o.requires) for (var i in o.requires[t]) {
              if (!goog.isProvided_(i)) {
                if (!(i in o.nameToPath)) throw Error("Undefined nameToPath for " + i);
                e(o.nameToPath[i]);
              }
            }
            t in n || (n[t] = !0, r.push(t));
          }
        }

        var r = [],
            n = {},
            o = goog.dependencies_;
        e(t);

        for (var i = 0; i < r.length; i++) {
          t = r[i], goog.dependencies_.written[t] = !0;
        }

        var c = goog.moduleLoaderState_;

        for (goog.moduleLoaderState_ = null, i = 0; i < r.length; i++) {
          if (!(t = r[i])) throw goog.moduleLoaderState_ = c, Error("Undefined script input");
          var a = o.loadFlags[t] || {},
              s = goog.needsTranspile_(a.lang || "es3");
          "goog" == a.module || s ? goog.importProcessedScript_(goog.basePath + t, "goog" == a.module, s) : goog.importScript_(goog.basePath + t);
        }

        goog.moduleLoaderState_ = c;
      }, goog.getPathFromDeps_ = function (t) {
        return t in goog.dependencies_.nameToPath ? goog.dependencies_.nameToPath[t] : null;
      }, goog.findBasePath_(), goog.global.CLOSURE_NO_DEPS || goog.importScript_(goog.basePath + "deps.js")), goog.hasBadLetScoping = null, goog.useSafari10Workaround = function () {
        if (null == goog.hasBadLetScoping) {
          try {
            var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
          } catch (t) {
            a = !1;
          }

          goog.hasBadLetScoping = a;
        }

        return goog.hasBadLetScoping;
      }, goog.workaroundSafari10EvalBug = function (t) {
        return "(function(){" + t + "\n;})();\n";
      }, goog.loadModule = function (t) {
        var e = goog.moduleLoaderState_;

        try {
          if (goog.moduleLoaderState_ = {
            moduleName: void 0,
            declareLegacyNamespace: !1
          }, goog.isFunction(t)) var r = t.call(void 0, {});else {
            if (!goog.isString(t)) throw Error("Invalid module definition");
            goog.useSafari10Workaround() && (t = goog.workaroundSafari10EvalBug(t)), r = goog.loadModuleFromSource_.call(void 0, t);
          }
          var n = goog.moduleLoaderState_.moduleName;
          if (!goog.isString(n) || !n) throw Error('Invalid module name "' + n + '"');
          goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(n, r) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof r && null != r && Object.seal(r), goog.loadedModules_[n] = r;
        } finally {
          goog.moduleLoaderState_ = e;
        }
      }, goog.loadModuleFromSource_ = function (a) {
        return eval(a), {};
      }, goog.normalizePath_ = function (t) {
        t = t.split("/");

        for (var e = 0; e < t.length;) {
          "." == t[e] ? t.splice(e, 1) : e && ".." == t[e] && t[e - 1] && ".." != t[e - 1] ? t.splice(--e, 2) : e++;
        }

        return t.join("/");
      }, goog.loadFileSync_ = function (t) {
        if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(t);

        try {
          var e = new goog.global.XMLHttpRequest();
          return e.open("get", t, !1), e.send(), 0 == e.status || 200 == e.status ? e.responseText : null;
        } catch (t) {
          return null;
        }
      }, goog.retrieveAndExec_ = function (t, e, r) {
        if (!COMPILED) {
          var n = t;
          t = goog.normalizePath_(t);
          var o = goog.global.CLOSURE_IMPORT_SCRIPT || goog.writeScriptTag_,
              i = goog.loadFileSync_(t);
          if (null == i) throw Error('Load of "' + t + '" failed');
          r && (i = goog.transpile_.call(goog.global, i, t)), i = e ? goog.wrapModule_(t, i) : i + "\n//# sourceURL=" + t, goog.IS_OLD_IE_ && goog.oldIeWaiting_ ? (goog.dependencies_.deferred[n] = i, goog.queuedModules_.push(n)) : o(t, i);
        }
      }, goog.transpile_ = function (a, b) {
        var c = goog.global.$jscomp;
        c || (goog.global.$jscomp = c = {});
        var d = c.transpile;

        if (!d) {
          var e = goog.basePath + goog.TRANSPILER,
              f = goog.loadFileSync_(e);

          if (f) {
            if (eval(f + "\n//# sourceURL=" + e), goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
            goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile, c = goog.global.$jscomp, d = c.transpile;
          }
        }

        return d || (d = c.transpile = function (t, e) {
          return goog.logToConsole_(e + " requires transpilation but no transpiler was found."), t;
        }), d(a, b);
      }, goog.typeOf = function (t) {
        var e = typeof t;

        if ("object" == e) {
          if (!t) return "null";
          if (t instanceof Array) return "array";
          if (t instanceof Object) return e;
          var r = Object.prototype.toString.call(t);
          if ("[object Window]" == r) return "object";
          if ("[object Array]" == r || "number" == typeof t.length && void 0 !== t.splice && void 0 !== t.propertyIsEnumerable && !t.propertyIsEnumerable("splice")) return "array";
          if ("[object Function]" == r || void 0 !== t.call && void 0 !== t.propertyIsEnumerable && !t.propertyIsEnumerable("call")) return "function";
        } else if ("function" == e && void 0 === t.call) return "object";

        return e;
      }, goog.isNull = function (t) {
        return null === t;
      }, goog.isDefAndNotNull = function (t) {
        return null != t;
      }, goog.isArray = function (t) {
        return "array" == goog.typeOf(t);
      }, goog.isArrayLike = function (t) {
        var e = goog.typeOf(t);
        return "array" == e || "object" == e && "number" == typeof t.length;
      }, goog.isDateLike = function (t) {
        return goog.isObject(t) && "function" == typeof t.getFullYear;
      }, goog.isString = function (t) {
        return "string" == typeof t;
      }, goog.isBoolean = function (t) {
        return "boolean" == typeof t;
      }, goog.isNumber = function (t) {
        return "number" == typeof t;
      }, goog.isFunction = function (t) {
        return "function" == goog.typeOf(t);
      }, goog.isObject = function (t) {
        var e = typeof t;
        return "object" == e && null != t || "function" == e;
      }, goog.getUid = function (t) {
        return t[goog.UID_PROPERTY_] || (t[goog.UID_PROPERTY_] = ++goog.uidCounter_);
      }, goog.hasUid = function (t) {
        return !!t[goog.UID_PROPERTY_];
      }, goog.removeUid = function (t) {
        null !== t && "removeAttribute" in t && t.removeAttribute(goog.UID_PROPERTY_);

        try {
          delete t[goog.UID_PROPERTY_];
        } catch (t) {}
      }, goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0), goog.uidCounter_ = 0, goog.getHashCode = goog.getUid, goog.removeHashCode = goog.removeUid, goog.cloneObject = function (t) {
        var e = goog.typeOf(t);

        if ("object" == e || "array" == e) {
          if (t.clone) return t.clone();
          var r,
              e = "array" == e ? [] : {};

          for (r in t) {
            e[r] = goog.cloneObject(t[r]);
          }

          return e;
        }

        return t;
      }, goog.bindNative_ = function (t, e, r) {
        return t.call.apply(t.bind, arguments);
      }, goog.bindJs_ = function (t, e, r) {
        if (!t) throw Error();

        if (2 < arguments.length) {
          var n = Array.prototype.slice.call(arguments, 2);
          return function () {
            var r = Array.prototype.slice.call(arguments);
            return Array.prototype.unshift.apply(r, n), t.apply(e, r);
          };
        }

        return function () {
          return t.apply(e, arguments);
        };
      }, goog.bind = function (t, e, r) {
        return Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_, goog.bind.apply(null, arguments);
      }, goog.partial = function (t, e) {
        var r = Array.prototype.slice.call(arguments, 1);
        return function () {
          var e = r.slice();
          return e.push.apply(e, arguments), t.apply(this, e);
        };
      }, goog.mixin = function (t, e) {
        for (var r in e) {
          t[r] = e[r];
        }
      }, goog.now = goog.TRUSTED_SITE && Date.now || function () {
        return +new Date();
      }, goog.globalEval = function (t) {
        if (goog.global.execScript) goog.global.execScript(t, "JavaScript");else {
          if (!goog.global.eval) throw Error("goog.globalEval not available");
          if (null == goog.evalWorksForGlobals_) if (goog.global.eval("var _evalTest_ = 1;"), void 0 !== goog.global._evalTest_) {
            try {
              delete goog.global._evalTest_;
            } catch (t) {}

            goog.evalWorksForGlobals_ = !0;
          } else goog.evalWorksForGlobals_ = !1;
          if (goog.evalWorksForGlobals_) goog.global.eval(t);else {
            var e = goog.global.document,
                r = e.createElement("SCRIPT");
            r.type = "text/javascript", r.defer = !1, r.appendChild(e.createTextNode(t)), e.body.appendChild(r), e.body.removeChild(r);
          }
        }
      }, goog.evalWorksForGlobals_ = null, goog.getCssName = function (t, e) {
        if ("." == String(t).charAt(0)) throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + t);

        var r = function r(t) {
          return goog.cssNameMapping_[t] || t;
        },
            n = function n(t) {
          t = t.split("-");

          for (var e = [], n = 0; n < t.length; n++) {
            e.push(r(t[n]));
          }

          return e.join("-");
        },
            n = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? r : n : function (t) {
          return t;
        },
            n = e ? t + "-" + n(e) : n(t);

        return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(n) : n;
      }, goog.setCssNameMapping = function (t, e) {
        goog.cssNameMapping_ = t, goog.cssNameMappingStyle_ = e;
      }, !COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING), goog.getMsg = function (t, e) {
        return e && (t = t.replace(/\{\$([^}]+)}/g, function (t, r) {
          return null != e && r in e ? e[r] : t;
        })), t;
      }, goog.getMsgWithFallback = function (t, e) {
        return t;
      }, goog.exportSymbol = function (t, e, r) {
        goog.exportPath_(t, e, r);
      }, goog.exportProperty = function (t, e, r) {
        t[e] = r;
      }, goog.inherits = function (t, e) {
        function r() {}

        r.prototype = e.prototype, t.superClass_ = e.prototype, t.prototype = new r(), t.prototype.constructor = t, t.base = function (t, r, n) {
          for (var o = Array(arguments.length - 2), i = 2; i < arguments.length; i++) {
            o[i - 2] = arguments[i];
          }

          return e.prototype[r].apply(t, o);
        };
      }, goog.base = function (t, e, r) {
        var n = arguments.callee.caller;
        if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !n) throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");

        if (n.superClass_) {
          for (var o = Array(arguments.length - 1), i = 1; i < arguments.length; i++) {
            o[i - 1] = arguments[i];
          }

          return n.superClass_.constructor.apply(t, o);
        }

        for (o = Array(arguments.length - 2), i = 2; i < arguments.length; i++) {
          o[i - 2] = arguments[i];
        }

        for (var i = !1, c = t.constructor; c; c = c.superClass_ && c.superClass_.constructor) {
          if (c.prototype[e] === n) i = !0;else if (i) return c.prototype[e].apply(t, o);
        }

        if (t[e] === n) return t.constructor.prototype[e].apply(t, o);
        throw Error("goog.base called from a method of one name to a method of a different name");
      }, goog.scope = function (t) {
        if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a goog.module.");
        t.call(goog.global);
      }, COMPILED || (goog.global.COMPILED = COMPILED), goog.defineClass = function (t, e) {
        var r = e.constructor,
            n = e.statics;
        return r && r != Object.prototype.constructor || (r = function r() {
          throw Error("cannot instantiate an interface (no constructor defined).");
        }), r = goog.defineClass.createSealingConstructor_(r, t), t && goog.inherits(r, t), delete e.constructor, delete e.statics, goog.defineClass.applyProperties_(r.prototype, e), null != n && (n instanceof Function ? n(r) : goog.defineClass.applyProperties_(r, n)), r;
      }, goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG, goog.defineClass.createSealingConstructor_ = function (t, e) {
        if (!goog.defineClass.SEAL_CLASS_INSTANCES) return t;

        var r = !goog.defineClass.isUnsealable_(e),
            n = function n() {
          var e = t.apply(this, arguments) || this;
          return e[goog.UID_PROPERTY_] = e[goog.UID_PROPERTY_], this.constructor === n && r && Object.seal instanceof Function && Object.seal(e), e;
        };

        return n;
      }, goog.defineClass.isUnsealable_ = function (t) {
        return t && t.prototype && t.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
      }, goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.defineClass.applyProperties_ = function (t, e) {
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }

        for (var n = 0; n < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; n++) {
          r = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[n], Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
      }, goog.tagUnsealableClass = function (t) {
        !COMPILED && goog.defineClass.SEAL_CLASS_INSTANCES && (t.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_] = !0);
      }, goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable", goog.createRequiresTranspilation_ = function () {
        function a(t, e) {
          d ? c[t] = !0 : e() ? c[t] = !1 : d = c[t] = !0;
        }

        function b(a) {
          try {
            return !!eval(a);
          } catch (t) {
            return !1;
          }
        }

        var c = {
          es3: !1
        },
            d = !1,
            e = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : "";
        return a("es5", function () {
          return b("[1,].length==1");
        }), a("es6", function () {
          var t = e.match(/Edge\/(\d+)(\.\d)*/i);
          return !(t && 15 > Number(t[1])) && b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()');
        }), a("es6-impl", function () {
          return !0;
        }), a("es7", function () {
          return b("2 ** 2 == 4");
        }), a("es8", function () {
          return b("async () => 1, true");
        }), c;
      }, goog.debug = {}, goog.debug.Error = function (t) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, goog.debug.Error);else {
          var e = Error().stack;
          e && (this.stack = e);
        }
        t && (this.message = String(t)), this.reportErrorToServer = !0;
      }, goog.inherits(goog.debug.Error, Error), goog.debug.Error.prototype.name = "CustomError", goog.dom = {}, goog.dom.NodeType = {
        ELEMENT: 1,
        ATTRIBUTE: 2,
        TEXT: 3,
        CDATA_SECTION: 4,
        ENTITY_REFERENCE: 5,
        ENTITY: 6,
        PROCESSING_INSTRUCTION: 7,
        COMMENT: 8,
        DOCUMENT: 9,
        DOCUMENT_TYPE: 10,
        DOCUMENT_FRAGMENT: 11,
        NOTATION: 12
      }, goog.string = {}, goog.string.DETECT_DOUBLE_ESCAPING = !1, goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1, goog.string.Unicode = {
        NBSP: " "
      }, goog.string.startsWith = function (t, e) {
        return 0 == t.lastIndexOf(e, 0);
      }, goog.string.endsWith = function (t, e) {
        var r = t.length - e.length;
        return 0 <= r && t.indexOf(e, r) == r;
      }, goog.string.caseInsensitiveStartsWith = function (t, e) {
        return 0 == goog.string.caseInsensitiveCompare(e, t.substr(0, e.length));
      }, goog.string.caseInsensitiveEndsWith = function (t, e) {
        return 0 == goog.string.caseInsensitiveCompare(e, t.substr(t.length - e.length, e.length));
      }, goog.string.caseInsensitiveEquals = function (t, e) {
        return t.toLowerCase() == e.toLowerCase();
      }, goog.string.subs = function (t, e) {
        for (var r = t.split("%s"), n = "", o = Array.prototype.slice.call(arguments, 1); o.length && 1 < r.length;) {
          n += r.shift() + o.shift();
        }

        return n + r.join("%s");
      }, goog.string.collapseWhitespace = function (t) {
        return t.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
      }, goog.string.isEmptyOrWhitespace = function (t) {
        return /^[\s\xa0]*$/.test(t);
      }, goog.string.isEmptyString = function (t) {
        return 0 == t.length;
      }, goog.string.isEmpty = goog.string.isEmptyOrWhitespace, goog.string.isEmptyOrWhitespaceSafe = function (t) {
        return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(t));
      }, goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe, goog.string.isBreakingWhitespace = function (t) {
        return !/[^\t\n\r ]/.test(t);
      }, goog.string.isAlpha = function (t) {
        return !/[^a-zA-Z]/.test(t);
      }, goog.string.isNumeric = function (t) {
        return !/[^0-9]/.test(t);
      }, goog.string.isAlphaNumeric = function (t) {
        return !/[^a-zA-Z0-9]/.test(t);
      }, goog.string.isSpace = function (t) {
        return " " == t;
      }, goog.string.isUnicodeChar = function (t) {
        return 1 == t.length && " " <= t && "~" >= t || "" <= t && "�" >= t;
      }, goog.string.stripNewlines = function (t) {
        return t.replace(/(\r\n|\r|\n)+/g, " ");
      }, goog.string.canonicalizeNewlines = function (t) {
        return t.replace(/(\r\n|\r|\n)/g, "\n");
      }, goog.string.normalizeWhitespace = function (t) {
        return t.replace(/\xa0|\s/g, " ");
      }, goog.string.normalizeSpaces = function (t) {
        return t.replace(/\xa0|[ \t]+/g, " ");
      }, goog.string.collapseBreakingSpaces = function (t) {
        return t.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
      }, goog.string.trim = goog.TRUSTED_SITE && String.prototype.trim ? function (t) {
        return t.trim();
      } : function (t) {
        return t.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
      }, goog.string.trimLeft = function (t) {
        return t.replace(/^[\s\xa0]+/, "");
      }, goog.string.trimRight = function (t) {
        return t.replace(/[\s\xa0]+$/, "");
      }, goog.string.caseInsensitiveCompare = function (t, e) {
        var r = String(t).toLowerCase(),
            n = String(e).toLowerCase();
        return r < n ? -1 : r == n ? 0 : 1;
      }, goog.string.numberAwareCompare_ = function (t, e, r) {
        if (t == e) return 0;
        if (!t) return -1;
        if (!e) return 1;

        for (var n = t.toLowerCase().match(r), o = e.toLowerCase().match(r), i = Math.min(n.length, o.length), c = 0; c < i; c++) {
          r = n[c];
          var a = o[c];
          if (r != a) return t = parseInt(r, 10), !isNaN(t) && (e = parseInt(a, 10), !isNaN(e) && t - e) ? t - e : r < a ? -1 : 1;
        }

        return n.length != o.length ? n.length - o.length : t < e ? -1 : 1;
      }, goog.string.intAwareCompare = function (t, e) {
        return goog.string.numberAwareCompare_(t, e, /\d+|\D+/g);
      }, goog.string.floatAwareCompare = function (t, e) {
        return goog.string.numberAwareCompare_(t, e, /\d+|\.\d+|\D+/g);
      }, goog.string.numerateCompare = goog.string.floatAwareCompare, goog.string.urlEncode = function (t) {
        return encodeURIComponent(String(t));
      }, goog.string.urlDecode = function (t) {
        return decodeURIComponent(t.replace(/\+/g, " "));
      }, goog.string.newLineToBr = function (t, e) {
        return t.replace(/(\r\n|\r|\n)/g, e ? "<br />" : "<br>");
      }, goog.string.htmlEscape = function (t, e) {
        if (e) t = t.replace(goog.string.AMP_RE_, "&amp;").replace(goog.string.LT_RE_, "&lt;").replace(goog.string.GT_RE_, "&gt;").replace(goog.string.QUOT_RE_, "&quot;").replace(goog.string.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.NULL_RE_, "&#0;"), goog.string.DETECT_DOUBLE_ESCAPING && (t = t.replace(goog.string.E_RE_, "&#101;"));else {
          if (!goog.string.ALL_RE_.test(t)) return t;
          -1 != t.indexOf("&") && (t = t.replace(goog.string.AMP_RE_, "&amp;")), -1 != t.indexOf("<") && (t = t.replace(goog.string.LT_RE_, "&lt;")), -1 != t.indexOf(">") && (t = t.replace(goog.string.GT_RE_, "&gt;")), -1 != t.indexOf('"') && (t = t.replace(goog.string.QUOT_RE_, "&quot;")), -1 != t.indexOf("'") && (t = t.replace(goog.string.SINGLE_QUOTE_RE_, "&#39;")), -1 != t.indexOf("\0") && (t = t.replace(goog.string.NULL_RE_, "&#0;")), goog.string.DETECT_DOUBLE_ESCAPING && -1 != t.indexOf("e") && (t = t.replace(goog.string.E_RE_, "&#101;"));
        }
        return t;
      }, goog.string.AMP_RE_ = /&/g, goog.string.LT_RE_ = /</g, goog.string.GT_RE_ = />/g, goog.string.QUOT_RE_ = /"/g, goog.string.SINGLE_QUOTE_RE_ = /'/g, goog.string.NULL_RE_ = /\x00/g, goog.string.E_RE_ = /e/g, goog.string.ALL_RE_ = goog.string.DETECT_DOUBLE_ESCAPING ? /[\x00&<>"'e]/ : /[\x00&<>"']/, goog.string.unescapeEntities = function (t) {
        return goog.string.contains(t, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(t) : goog.string.unescapePureXmlEntities_(t) : t;
      }, goog.string.unescapeEntitiesWithDocument = function (t, e) {
        return goog.string.contains(t, "&") ? goog.string.unescapeEntitiesUsingDom_(t, e) : t;
      }, goog.string.unescapeEntitiesUsingDom_ = function (t, e) {
        var r = {
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"'
        },
            n = e ? e.createElement("div") : goog.global.document.createElement("div");
        return t.replace(goog.string.HTML_ENTITY_PATTERN_, function (t, e) {
          var o = r[t];
          if (o) return o;

          if ("#" == e.charAt(0)) {
            var i = Number("0" + e.substr(1));
            isNaN(i) || (o = String.fromCharCode(i));
          }

          return o || (n.innerHTML = t + " ", o = n.firstChild.nodeValue.slice(0, -1)), r[t] = o;
        });
      }, goog.string.unescapePureXmlEntities_ = function (t) {
        return t.replace(/&([^;]+);/g, function (t, e) {
          switch (e) {
            case "amp":
              return "&";

            case "lt":
              return "<";

            case "gt":
              return ">";

            case "quot":
              return '"';

            default:
              if ("#" == e.charAt(0)) {
                var r = Number("0" + e.substr(1));
                if (!isNaN(r)) return String.fromCharCode(r);
              }

              return t;
          }
        });
      }, goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g, goog.string.whitespaceEscape = function (t, e) {
        return goog.string.newLineToBr(t.replace(/  /g, " &#160;"), e);
      }, goog.string.preserveSpaces = function (t) {
        return t.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
      }, goog.string.stripQuotes = function (t, e) {
        for (var r = e.length, n = 0; n < r; n++) {
          var o = 1 == r ? e : e.charAt(n);
          if (t.charAt(0) == o && t.charAt(t.length - 1) == o) return t.substring(1, t.length - 1);
        }

        return t;
      }, goog.string.truncate = function (t, e, r) {
        return r && (t = goog.string.unescapeEntities(t)), t.length > e && (t = t.substring(0, e - 3) + "..."), r && (t = goog.string.htmlEscape(t)), t;
      }, goog.string.truncateMiddle = function (t, e, r, n) {
        if (r && (t = goog.string.unescapeEntities(t)), n && t.length > e) {
          n > e && (n = e);
          var o = t.length - n;
          t = t.substring(0, e - n) + "..." + t.substring(o);
        } else t.length > e && (n = Math.floor(e / 2), o = t.length - n, t = t.substring(0, n + e % 2) + "..." + t.substring(o));

        return r && (t = goog.string.htmlEscape(t)), t;
      }, goog.string.specialEscapeChars_ = {
        "\0": "\\0",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "\t": "\\t",
        "\v": "\\x0B",
        '"': '\\"',
        "\\": "\\\\",
        "<": "<"
      }, goog.string.jsEscapeCache_ = {
        "'": "\\'"
      }, goog.string.quote = function (t) {
        t = String(t);

        for (var e = ['"'], r = 0; r < t.length; r++) {
          var n = t.charAt(r),
              o = n.charCodeAt(0);
          e[r + 1] = goog.string.specialEscapeChars_[n] || (31 < o && 127 > o ? n : goog.string.escapeChar(n));
        }

        return e.push('"'), e.join("");
      }, goog.string.escapeString = function (t) {
        for (var e = [], r = 0; r < t.length; r++) {
          e[r] = goog.string.escapeChar(t.charAt(r));
        }

        return e.join("");
      }, goog.string.escapeChar = function (t) {
        if (t in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[t];
        if (t in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[t] = goog.string.specialEscapeChars_[t];
        var e = t.charCodeAt(0);
        if (31 < e && 127 > e) var r = t;else 256 > e ? (r = "\\x", (16 > e || 256 < e) && (r += "0")) : (r = "\\u", 4096 > e && (r += "0")), r += e.toString(16).toUpperCase();
        return goog.string.jsEscapeCache_[t] = r;
      }, goog.string.contains = function (t, e) {
        return -1 != t.indexOf(e);
      }, goog.string.caseInsensitiveContains = function (t, e) {
        return goog.string.contains(t.toLowerCase(), e.toLowerCase());
      }, goog.string.countOf = function (t, e) {
        return t && e ? t.split(e).length - 1 : 0;
      }, goog.string.removeAt = function (t, e, r) {
        var n = t;
        return 0 <= e && e < t.length && 0 < r && (n = t.substr(0, e) + t.substr(e + r, t.length - e - r)), n;
      }, goog.string.remove = function (t, e) {
        return t.replace(e, "");
      }, goog.string.removeAll = function (t, e) {
        var r = new RegExp(goog.string.regExpEscape(e), "g");
        return t.replace(r, "");
      }, goog.string.replaceAll = function (t, e, r) {
        return e = new RegExp(goog.string.regExpEscape(e), "g"), t.replace(e, r.replace(/\$/g, "$$$$"));
      }, goog.string.regExpEscape = function (t) {
        return String(t).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
      }, goog.string.repeat = String.prototype.repeat ? function (t, e) {
        return t.repeat(e);
      } : function (t, e) {
        return Array(e + 1).join(t);
      }, goog.string.padNumber = function (t, e, r) {
        return t = goog.isDef(r) ? t.toFixed(r) : String(t), r = t.indexOf("."), -1 == r && (r = t.length), goog.string.repeat("0", Math.max(0, e - r)) + t;
      }, goog.string.makeSafe = function (t) {
        return null == t ? "" : String(t);
      }, goog.string.buildString = function (t) {
        return Array.prototype.join.call(arguments, "");
      }, goog.string.getRandomString = function () {
        return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
      }, goog.string.compareVersions = function (t, e) {
        for (var r = 0, n = goog.string.trim(String(t)).split("."), o = goog.string.trim(String(e)).split("."), i = Math.max(n.length, o.length), c = 0; 0 == r && c < i; c++) {
          var a = n[c] || "",
              s = o[c] || "";

          do {
            if (a = /(\d*)(\D*)(.*)/.exec(a) || ["", "", "", ""], s = /(\d*)(\D*)(.*)/.exec(s) || ["", "", "", ""], 0 == a[0].length && 0 == s[0].length) break;
            var r = 0 == a[1].length ? 0 : parseInt(a[1], 10),
                u = 0 == s[1].length ? 0 : parseInt(s[1], 10),
                r = goog.string.compareElements_(r, u) || goog.string.compareElements_(0 == a[2].length, 0 == s[2].length) || goog.string.compareElements_(a[2], s[2]),
                a = a[3],
                s = s[3];
          } while (0 == r);
        }

        return r;
      }, goog.string.compareElements_ = function (t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
      }, goog.string.hashCode = function (t) {
        for (var e = 0, r = 0; r < t.length; ++r) {
          e = 31 * e + t.charCodeAt(r) >>> 0;
        }

        return e;
      }, goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0, goog.string.createUniqueString = function () {
        return "goog_" + goog.string.uniqueStringCounter_++;
      }, goog.string.toNumber = function (t) {
        var e = Number(t);
        return 0 == e && goog.string.isEmptyOrWhitespace(t) ? NaN : e;
      }, goog.string.isLowerCamelCase = function (t) {
        return /^[a-z]+([A-Z][a-z]*)*$/.test(t);
      }, goog.string.isUpperCamelCase = function (t) {
        return /^([A-Z][a-z]*)+$/.test(t);
      }, goog.string.toCamelCase = function (t) {
        return String(t).replace(/\-([a-z])/g, function (t, e) {
          return e.toUpperCase();
        });
      }, goog.string.toSelectorCase = function (t) {
        return String(t).replace(/([A-Z])/g, "-$1").toLowerCase();
      }, goog.string.toTitleCase = function (t, e) {
        var r = goog.isString(e) ? goog.string.regExpEscape(e) : "\\s";
        return t.replace(new RegExp("(^" + (r ? "|[" + r + "]+" : "") + ")([a-z])", "g"), function (t, e, r) {
          return e + r.toUpperCase();
        });
      }, goog.string.capitalize = function (t) {
        return String(t.charAt(0)).toUpperCase() + String(t.substr(1)).toLowerCase();
      }, goog.string.parseInt = function (t) {
        return isFinite(t) && (t = String(t)), goog.isString(t) ? /^\s*-?0x/i.test(t) ? parseInt(t, 16) : parseInt(t, 10) : NaN;
      }, goog.string.splitLimit = function (t, e, r) {
        t = t.split(e);

        for (var n = []; 0 < r && t.length;) {
          n.push(t.shift()), r--;
        }

        return t.length && n.push(t.join(e)), n;
      }, goog.string.lastComponent = function (t, e) {
        if (!e) return t;
        "string" == typeof e && (e = [e]);

        for (var r = -1, n = 0; n < e.length; n++) {
          if ("" != e[n]) {
            var o = t.lastIndexOf(e[n]);
            o > r && (r = o);
          }
        }

        return -1 == r ? t : t.slice(r + 1);
      }, goog.string.editDistance = function (t, e) {
        var r = [],
            n = [];
        if (t == e) return 0;
        if (!t.length || !e.length) return Math.max(t.length, e.length);

        for (var o = 0; o < e.length + 1; o++) {
          r[o] = o;
        }

        for (o = 0; o < t.length; o++) {
          n[0] = o + 1;

          for (var i = 0; i < e.length; i++) {
            n[i + 1] = Math.min(n[i] + 1, r[i + 1] + 1, r[i] + Number(t[o] != e[i]));
          }

          for (i = 0; i < r.length; i++) {
            r[i] = n[i];
          }
        }

        return n[e.length];
      }, goog.asserts = {}, goog.asserts.ENABLE_ASSERTS = goog.DEBUG, goog.asserts.AssertionError = function (t, e) {
        e.unshift(t), goog.debug.Error.call(this, goog.string.subs.apply(null, e)), e.shift(), this.messagePattern = t;
      }, goog.inherits(goog.asserts.AssertionError, goog.debug.Error), goog.asserts.AssertionError.prototype.name = "AssertionError", goog.asserts.DEFAULT_ERROR_HANDLER = function (t) {
        throw t;
      }, goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
      goog.asserts.doAssertFailure_ = function (t, e, r, n) {
        var o = "Assertion failed";

        if (r) {
          o += ": " + r;
          var i = n;
        } else t && (o += ": " + t, i = e);

        t = new goog.asserts.AssertionError("" + o, i || []), goog.asserts.errorHandler_(t);
      }, goog.asserts.setErrorHandler = function (t) {
        goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = t);
      }, goog.asserts.assert = function (t, e, r) {
        return goog.asserts.ENABLE_ASSERTS && !t && goog.asserts.doAssertFailure_("", null, e, Array.prototype.slice.call(arguments, 2)), t;
      }, goog.asserts.fail = function (t, e) {
        goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (t ? ": " + t : ""), Array.prototype.slice.call(arguments, 1)));
      }, goog.asserts.assertNumber = function (t, e, r) {
        return goog.asserts.ENABLE_ASSERTS && !goog.isNumber(t) && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(t), t], e, Array.prototype.slice.call(arguments, 2)), t;
      }, goog.asserts.assertString = function (t, e, r) {
        return goog.asserts.ENABLE_ASSERTS && !goog.isString(t) && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(t), t], e, Array.prototype.slice.call(arguments, 2)), t;
      }, goog.asserts.assertFunction = function (t, e, r) {
        return goog.asserts.ENABLE_ASSERTS && !goog.isFunction(t) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(t), t], e, Array.prototype.slice.call(arguments, 2)), t;
      }, goog.asserts.assertObject = function (t, e, r) {
        return goog.asserts.ENABLE_ASSERTS && !goog.isObject(t) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(t), t], e, Array.prototype.slice.call(arguments, 2)), t;
      }, goog.asserts.assertArray = function (t, e, r) {
        return goog.asserts.ENABLE_ASSERTS && !goog.isArray(t) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(t), t], e, Array.prototype.slice.call(arguments, 2)), t;
      }, goog.asserts.assertBoolean = function (t, e, r) {
        return goog.asserts.ENABLE_ASSERTS && !goog.isBoolean(t) && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(t), t], e, Array.prototype.slice.call(arguments, 2)), t;
      }, goog.asserts.assertElement = function (t, e, r) {
        return !goog.asserts.ENABLE_ASSERTS || goog.isObject(t) && t.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(t), t], e, Array.prototype.slice.call(arguments, 2)), t;
      }, goog.asserts.assertInstanceof = function (t, e, r, n) {
        return !goog.asserts.ENABLE_ASSERTS || t instanceof e || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(e), goog.asserts.getType_(t)], r, Array.prototype.slice.call(arguments, 3)), t;
      }, goog.asserts.assertObjectPrototypeIsIntact = function () {
        for (var t in Object.prototype) {
          goog.asserts.fail(t + " should not be enumerable in Object.prototype.");
        }
      }, goog.asserts.getType_ = function (t) {
        return t instanceof Function ? t.displayName || t.name || "unknown type name" : t instanceof Object ? t.constructor.displayName || t.constructor.name || Object.prototype.toString.call(t) : null === t ? "null" : typeof t;
      }, goog.object = {}, goog.object.is = function (t, e) {
        return t === e ? 0 !== t || 1 / t == 1 / e : t !== t && e !== e;
      }, goog.object.forEach = function (t, e, r) {
        for (var n in t) {
          e.call(r, t[n], n, t);
        }
      }, goog.object.filter = function (t, e, r) {
        var n,
            o = {};

        for (n in t) {
          e.call(r, t[n], n, t) && (o[n] = t[n]);
        }

        return o;
      }, goog.object.map = function (t, e, r) {
        var n,
            o = {};

        for (n in t) {
          o[n] = e.call(r, t[n], n, t);
        }

        return o;
      }, goog.object.some = function (t, e, r) {
        for (var n in t) {
          if (e.call(r, t[n], n, t)) return !0;
        }

        return !1;
      }, goog.object.every = function (t, e, r) {
        for (var n in t) {
          if (!e.call(r, t[n], n, t)) return !1;
        }

        return !0;
      }, goog.object.getCount = function (t) {
        var e,
            r = 0;

        for (e in t) {
          r++;
        }

        return r;
      }, goog.object.getAnyKey = function (t) {
        for (var e in t) {
          return e;
        }
      }, goog.object.getAnyValue = function (t) {
        for (var e in t) {
          return t[e];
        }
      }, goog.object.contains = function (t, e) {
        return goog.object.containsValue(t, e);
      }, goog.object.getValues = function (t) {
        var e,
            r = [],
            n = 0;

        for (e in t) {
          r[n++] = t[e];
        }

        return r;
      }, goog.object.getKeys = function (t) {
        var e,
            r = [],
            n = 0;

        for (e in t) {
          r[n++] = e;
        }

        return r;
      }, goog.object.getValueByKeys = function (t, e) {
        for (var r = goog.isArrayLike(e), n = r ? e : arguments, r = r ? 0 : 1; r < n.length && (t = t[n[r]], goog.isDef(t)); r++) {
          ;
        }

        return t;
      }, goog.object.containsKey = function (t, e) {
        return null !== t && e in t;
      }, goog.object.containsValue = function (t, e) {
        for (var r in t) {
          if (t[r] == e) return !0;
        }

        return !1;
      }, goog.object.findKey = function (t, e, r) {
        for (var n in t) {
          if (e.call(r, t[n], n, t)) return n;
        }
      }, goog.object.findValue = function (t, e, r) {
        return (e = goog.object.findKey(t, e, r)) && t[e];
      }, goog.object.isEmpty = function (t) {
        for (var e in t) {
          return !1;
        }

        return !0;
      }, goog.object.clear = function (t) {
        for (var e in t) {
          delete t[e];
        }
      }, goog.object.remove = function (t, e) {
        var r;
        return (r = e in t) && delete t[e], r;
      }, goog.object.add = function (t, e, r) {
        if (null !== t && e in t) throw Error('The object already contains the key "' + e + '"');
        goog.object.set(t, e, r);
      }, goog.object.get = function (t, e, r) {
        return null !== t && e in t ? t[e] : r;
      }, goog.object.set = function (t, e, r) {
        t[e] = r;
      }, goog.object.setIfUndefined = function (t, e, r) {
        return e in t ? t[e] : t[e] = r;
      }, goog.object.setWithReturnValueIfNotSet = function (t, e, r) {
        return e in t ? t[e] : (r = r(), t[e] = r);
      }, goog.object.equals = function (t, e) {
        for (var r in t) {
          if (!(r in e) || t[r] !== e[r]) return !1;
        }

        for (r in e) {
          if (!(r in t)) return !1;
        }

        return !0;
      }, goog.object.clone = function (t) {
        var e,
            r = {};

        for (e in t) {
          r[e] = t[e];
        }

        return r;
      }, goog.object.unsafeClone = function (t) {
        var e = goog.typeOf(t);

        if ("object" == e || "array" == e) {
          if (goog.isFunction(t.clone)) return t.clone();
          var r,
              e = "array" == e ? [] : {};

          for (r in t) {
            e[r] = goog.object.unsafeClone(t[r]);
          }

          return e;
        }

        return t;
      }, goog.object.transpose = function (t) {
        var e,
            r = {};

        for (e in t) {
          r[t[e]] = e;
        }

        return r;
      }, goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.object.extend = function (t, e) {
        for (var r, n, o = 1; o < arguments.length; o++) {
          n = arguments[o];

          for (r in n) {
            t[r] = n[r];
          }

          for (var i = 0; i < goog.object.PROTOTYPE_FIELDS_.length; i++) {
            r = goog.object.PROTOTYPE_FIELDS_[i], Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
        }
      }, goog.object.create = function (t) {
        var e = arguments.length;
        if (1 == e && goog.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
        if (e % 2) throw Error("Uneven number of arguments");

        for (var r = {}, n = 0; n < e; n += 2) {
          r[arguments[n]] = arguments[n + 1];
        }

        return r;
      }, goog.object.createSet = function (t) {
        var e = arguments.length;
        if (1 == e && goog.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);

        for (var r = {}, n = 0; n < e; n++) {
          r[arguments[n]] = !0;
        }

        return r;
      }, goog.object.createImmutableView = function (t) {
        var e = t;
        return Object.isFrozen && !Object.isFrozen(t) && (e = Object.create(t), Object.freeze(e)), e;
      }, goog.object.isImmutableView = function (t) {
        return !!Object.isFrozen && Object.isFrozen(t);
      }, goog.object.getAllPropertyNames = function (t, e, r) {
        if (!t) return [];
        if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(t);

        for (var n = {}; t && (t !== Object.prototype || e) && (t !== Function.prototype || r);) {
          for (var o = Object.getOwnPropertyNames(t), i = 0; i < o.length; i++) {
            n[o[i]] = !0;
          }

          t = Object.getPrototypeOf(t);
        }

        return goog.object.getKeys(n);
      }, goog.reflect = {}, goog.reflect.object = function (t, e) {
        return e;
      }, goog.reflect.objectProperty = function (t, e) {
        return t;
      }, goog.reflect.sinkValue = function (t) {
        return goog.reflect.sinkValue[" "](t), t;
      }, goog.reflect.sinkValue[" "] = goog.nullFunction, goog.reflect.canAccessProperty = function (t, e) {
        try {
          return goog.reflect.sinkValue(t[e]), !0;
        } catch (t) {}

        return !1;
      }, goog.reflect.cache = function (t, e, r, n) {
        return n = n ? n(e) : e, Object.prototype.hasOwnProperty.call(t, n) ? t[n] : t[n] = r(e);
      }, goog.math = {}, goog.math.Long = function (t, e) {
        this.low_ = 0 | t, this.high_ = 0 | e;
      }, goog.math.Long.IntCache_ = {}, goog.math.Long.valueCache_ = {}, goog.math.Long.getCachedIntValue_ = function (t) {
        return goog.reflect.cache(goog.math.Long.IntCache_, t, function (t) {
          return new goog.math.Long(t, 0 > t ? -1 : 0);
        });
      }, goog.math.Long.MAX_VALUE_FOR_RADIX_ = "  111111111111111111111111111111111111111111111111111111111111111 2021110011022210012102010021220101220221 13333333333333333333333333333333 1104332401304422434310311212 1540241003031030222122211 22341010611245052052300 777777777777777777777 67404283172107811827 9223372036854775807 1728002635214590697 41a792678515120367 10b269549075433c37 4340724c6c71dc7a7 160e2ad3246366807 7fffffffffffffff 33d3d8307b214008 16agh595df825fa7 ba643dci0ffeehh 5cbfjia3fh26ja7 2heiciiie82dh97 1adaibb21dckfa7 i6k448cf4192c2 acd772jnc9l0l7 64ie1focnn5g77 3igoecjbmca687 27c48l5b37oaop 1bk39f3ah3dmq7 q1se8f0m04isb hajppbc1fc207 bm03i95hia437 7vvvvvvvvvvvv 5hg4ck9jd4u37 3tdtk1v8j6tpp 2pijmikexrxp7 1y2p0ij32e8e7".split(" "), goog.math.Long.MIN_VALUE_FOR_RADIX_ = "  -1000000000000000000000000000000000000000000000000000000000000000 -2021110011022210012102010021220101220222 -20000000000000000000000000000000 -1104332401304422434310311213 -1540241003031030222122212 -22341010611245052052301 -1000000000000000000000 -67404283172107811828 -9223372036854775808 -1728002635214590698 -41a792678515120368 -10b269549075433c38 -4340724c6c71dc7a8 -160e2ad3246366808 -8000000000000000 -33d3d8307b214009 -16agh595df825fa8 -ba643dci0ffeehi -5cbfjia3fh26ja8 -2heiciiie82dh98 -1adaibb21dckfa8 -i6k448cf4192c3 -acd772jnc9l0l8 -64ie1focnn5g78 -3igoecjbmca688 -27c48l5b37oaoq -1bk39f3ah3dmq8 -q1se8f0m04isc -hajppbc1fc208 -bm03i95hia438 -8000000000000 -5hg4ck9jd4u38 -3tdtk1v8j6tpq -2pijmikexrxp8 -1y2p0ij32e8e8".split(" "), goog.math.Long.fromInt = function (t) {
        var e = 0 | t;
        return goog.asserts.assert(t === e, "value should be a 32-bit integer"), -128 <= e && 128 > e ? goog.math.Long.getCachedIntValue_(e) : new goog.math.Long(e, 0 > e ? -1 : 0);
      }, goog.math.Long.fromNumber = function (t) {
        return isNaN(t) ? goog.math.Long.getZero() : t <= -goog.math.Long.TWO_PWR_63_DBL_ ? goog.math.Long.getMinValue() : t + 1 >= goog.math.Long.TWO_PWR_63_DBL_ ? goog.math.Long.getMaxValue() : 0 > t ? goog.math.Long.fromNumber(-t).negate() : new goog.math.Long(t % goog.math.Long.TWO_PWR_32_DBL_ | 0, t / goog.math.Long.TWO_PWR_32_DBL_ | 0);
      }, goog.math.Long.fromBits = function (t, e) {
        return new goog.math.Long(t, e);
      }, goog.math.Long.fromString = function (t, e) {
        if (0 == t.length) throw Error("number format error: empty string");
        var r = e || 10;
        if (2 > r || 36 < r) throw Error("radix out of range: " + r);
        if ("-" == t.charAt(0)) return goog.math.Long.fromString(t.substring(1), r).negate();
        if (0 <= t.indexOf("-")) throw Error('number format error: interior "-" character: ' + t);

        for (var n = goog.math.Long.fromNumber(Math.pow(r, 8)), o = goog.math.Long.getZero(), i = 0; i < t.length; i += 8) {
          var c = Math.min(8, t.length - i),
              a = parseInt(t.substring(i, i + c), r);
          8 > c ? (c = goog.math.Long.fromNumber(Math.pow(r, c)), o = o.multiply(c).add(goog.math.Long.fromNumber(a))) : (o = o.multiply(n), o = o.add(goog.math.Long.fromNumber(a)));
        }

        return o;
      }, goog.math.Long.isStringInRange = function (t, e) {
        var r = e || 10;
        if (2 > r || 36 < r) throw Error("radix out of range: " + r);
        return r = "-" == t.charAt(0) ? goog.math.Long.MIN_VALUE_FOR_RADIX_[r] : goog.math.Long.MAX_VALUE_FOR_RADIX_[r], t.length < r.length || t.length == r.length && t <= r;
      }, goog.math.Long.TWO_PWR_16_DBL_ = 65536, goog.math.Long.TWO_PWR_32_DBL_ = goog.math.Long.TWO_PWR_16_DBL_ * goog.math.Long.TWO_PWR_16_DBL_, goog.math.Long.TWO_PWR_64_DBL_ = goog.math.Long.TWO_PWR_32_DBL_ * goog.math.Long.TWO_PWR_32_DBL_, goog.math.Long.TWO_PWR_63_DBL_ = goog.math.Long.TWO_PWR_64_DBL_ / 2, goog.math.Long.getZero = function () {
        return goog.math.Long.getCachedIntValue_(0);
      }, goog.math.Long.getOne = function () {
        return goog.math.Long.getCachedIntValue_(1);
      }, goog.math.Long.getNegOne = function () {
        return goog.math.Long.getCachedIntValue_(-1);
      }, goog.math.Long.getMaxValue = function () {
        return goog.reflect.cache(goog.math.Long.valueCache_, goog.math.Long.ValueCacheId_.MAX_VALUE, function () {
          return goog.math.Long.fromBits(-1, 2147483647);
        });
      }, goog.math.Long.getMinValue = function () {
        return goog.reflect.cache(goog.math.Long.valueCache_, goog.math.Long.ValueCacheId_.MIN_VALUE, function () {
          return goog.math.Long.fromBits(0, -2147483648);
        });
      }, goog.math.Long.getTwoPwr24 = function () {
        return goog.reflect.cache(goog.math.Long.valueCache_, goog.math.Long.ValueCacheId_.TWO_PWR_24, function () {
          return goog.math.Long.fromInt(16777216);
        });
      }, goog.math.Long.prototype.toInt = function () {
        return this.low_;
      }, goog.math.Long.prototype.toNumber = function () {
        return this.high_ * goog.math.Long.TWO_PWR_32_DBL_ + this.getLowBitsUnsigned();
      }, goog.math.Long.prototype.toString = function (t) {
        if (2 > (t = t || 10) || 36 < t) throw Error("radix out of range: " + t);
        if (this.isZero()) return "0";

        if (this.isNegative()) {
          if (this.equals(goog.math.Long.getMinValue())) {
            var e = goog.math.Long.fromNumber(t),
                r = this.div(e);
            return e = r.multiply(e).subtract(this), r.toString(t) + e.toInt().toString(t);
          }

          return "-" + this.negate().toString(t);
        }

        r = goog.math.Long.fromNumber(Math.pow(t, 6)), e = this;

        for (var n = "";;) {
          var o = e.div(r),
              i = (e.subtract(o.multiply(r)).toInt() >>> 0).toString(t);
          if (e = o, e.isZero()) return i + n;

          for (; 6 > i.length;) {
            i = "0" + i;
          }

          n = "" + i + n;
        }
      }, goog.math.Long.prototype.getHighBits = function () {
        return this.high_;
      }, goog.math.Long.prototype.getLowBits = function () {
        return this.low_;
      }, goog.math.Long.prototype.getLowBitsUnsigned = function () {
        return 0 <= this.low_ ? this.low_ : goog.math.Long.TWO_PWR_32_DBL_ + this.low_;
      }, goog.math.Long.prototype.getNumBitsAbs = function () {
        if (this.isNegative()) return this.equals(goog.math.Long.getMinValue()) ? 64 : this.negate().getNumBitsAbs();

        for (var t = 0 != this.high_ ? this.high_ : this.low_, e = 31; 0 < e && 0 == (t & 1 << e); e--) {
          ;
        }

        return 0 != this.high_ ? e + 33 : e + 1;
      }, goog.math.Long.prototype.isZero = function () {
        return 0 == this.high_ && 0 == this.low_;
      }, goog.math.Long.prototype.isNegative = function () {
        return 0 > this.high_;
      }, goog.math.Long.prototype.isOdd = function () {
        return 1 == (1 & this.low_);
      }, goog.math.Long.prototype.equals = function (t) {
        return this.high_ == t.high_ && this.low_ == t.low_;
      }, goog.math.Long.prototype.notEquals = function (t) {
        return this.high_ != t.high_ || this.low_ != t.low_;
      }, goog.math.Long.prototype.lessThan = function (t) {
        return 0 > this.compare(t);
      }, goog.math.Long.prototype.lessThanOrEqual = function (t) {
        return 0 >= this.compare(t);
      }, goog.math.Long.prototype.greaterThan = function (t) {
        return 0 < this.compare(t);
      }, goog.math.Long.prototype.greaterThanOrEqual = function (t) {
        return 0 <= this.compare(t);
      }, goog.math.Long.prototype.compare = function (t) {
        if (this.equals(t)) return 0;
        var e = this.isNegative(),
            r = t.isNegative();
        return e && !r ? -1 : !e && r ? 1 : this.subtract(t).isNegative() ? -1 : 1;
      }, goog.math.Long.prototype.negate = function () {
        return this.equals(goog.math.Long.getMinValue()) ? goog.math.Long.getMinValue() : this.not().add(goog.math.Long.getOne());
      }, goog.math.Long.prototype.add = function (t) {
        var e = this.high_ >>> 16,
            r = 65535 & this.high_,
            n = this.low_ >>> 16,
            o = t.high_ >>> 16,
            i = 65535 & t.high_,
            c = t.low_ >>> 16;
        return t = (65535 & this.low_) + (65535 & t.low_) + 0, c = 0 + (t >>> 16) + (n + c), n = 0 + (c >>> 16), n += r + i, e = 0 + (n >>> 16) + (e + o) & 65535, goog.math.Long.fromBits((65535 & c) << 16 | 65535 & t, e << 16 | 65535 & n);
      }, goog.math.Long.prototype.subtract = function (t) {
        return this.add(t.negate());
      }, goog.math.Long.prototype.multiply = function (t) {
        if (this.isZero() || t.isZero()) return goog.math.Long.getZero();
        if (this.equals(goog.math.Long.getMinValue())) return t.isOdd() ? goog.math.Long.getMinValue() : goog.math.Long.getZero();
        if (t.equals(goog.math.Long.getMinValue())) return this.isOdd() ? goog.math.Long.getMinValue() : goog.math.Long.getZero();
        if (this.isNegative()) return t.isNegative() ? this.negate().multiply(t.negate()) : this.negate().multiply(t).negate();
        if (t.isNegative()) return this.multiply(t.negate()).negate();
        if (this.lessThan(goog.math.Long.getTwoPwr24()) && t.lessThan(goog.math.Long.getTwoPwr24())) return goog.math.Long.fromNumber(this.toNumber() * t.toNumber());
        var e = this.high_ >>> 16,
            r = 65535 & this.high_,
            n = this.low_ >>> 16,
            o = 65535 & this.low_,
            i = t.high_ >>> 16,
            c = 65535 & t.high_,
            a = t.low_ >>> 16;
        t = 65535 & t.low_;
        var s = 0 + o * t,
            u = 0 + (s >>> 16) + n * t,
            g = 0 + (u >>> 16);
        u = (65535 & u) + o * a, g += u >>> 16, g += r * t;
        var p = 0 + (g >>> 16);
        return g = (65535 & g) + n * a, p += g >>> 16, g = (65535 & g) + o * c, p = p + (g >>> 16) + (e * t + r * a + n * c + o * i) & 65535, goog.math.Long.fromBits((65535 & u) << 16 | 65535 & s, p << 16 | 65535 & g);
      }, goog.math.Long.prototype.div = function (t) {
        if (t.isZero()) throw Error("division by zero");
        if (this.isZero()) return goog.math.Long.getZero();

        if (this.equals(goog.math.Long.getMinValue())) {
          if (t.equals(goog.math.Long.getOne()) || t.equals(goog.math.Long.getNegOne())) return goog.math.Long.getMinValue();
          if (t.equals(goog.math.Long.getMinValue())) return goog.math.Long.getOne();
          var e = this.shiftRight(1);
          if (e = e.div(t).shiftLeft(1), e.equals(goog.math.Long.getZero())) return t.isNegative() ? goog.math.Long.getOne() : goog.math.Long.getNegOne();
          var r = this.subtract(t.multiply(e));
          return e.add(r.div(t));
        }

        if (t.equals(goog.math.Long.getMinValue())) return goog.math.Long.getZero();
        if (this.isNegative()) return t.isNegative() ? this.negate().div(t.negate()) : this.negate().div(t).negate();
        if (t.isNegative()) return this.div(t.negate()).negate();
        var n = goog.math.Long.getZero();

        for (r = this; r.greaterThanOrEqual(t);) {
          e = Math.max(1, Math.floor(r.toNumber() / t.toNumber()));

          for (var o = Math.ceil(Math.log(e) / Math.LN2), o = 48 >= o ? 1 : Math.pow(2, o - 48), i = goog.math.Long.fromNumber(e), c = i.multiply(t); c.isNegative() || c.greaterThan(r);) {
            e -= o, i = goog.math.Long.fromNumber(e), c = i.multiply(t);
          }

          i.isZero() && (i = goog.math.Long.getOne()), n = n.add(i), r = r.subtract(c);
        }

        return n;
      }, goog.math.Long.prototype.modulo = function (t) {
        return this.subtract(this.div(t).multiply(t));
      }, goog.math.Long.prototype.not = function () {
        return goog.math.Long.fromBits(~this.low_, ~this.high_);
      }, goog.math.Long.prototype.and = function (t) {
        return goog.math.Long.fromBits(this.low_ & t.low_, this.high_ & t.high_);
      }, goog.math.Long.prototype.or = function (t) {
        return goog.math.Long.fromBits(this.low_ | t.low_, this.high_ | t.high_);
      }, goog.math.Long.prototype.xor = function (t) {
        return goog.math.Long.fromBits(this.low_ ^ t.low_, this.high_ ^ t.high_);
      }, goog.math.Long.prototype.shiftLeft = function (t) {
        if (0 == (t &= 63)) return this;
        var e = this.low_;
        return 32 > t ? goog.math.Long.fromBits(e << t, this.high_ << t | e >>> 32 - t) : goog.math.Long.fromBits(0, e << t - 32);
      }, goog.math.Long.prototype.shiftRight = function (t) {
        if (0 == (t &= 63)) return this;
        var e = this.high_;
        return 32 > t ? goog.math.Long.fromBits(this.low_ >>> t | e << 32 - t, e >> t) : goog.math.Long.fromBits(e >> t - 32, 0 <= e ? 0 : -1);
      }, goog.math.Long.prototype.shiftRightUnsigned = function (t) {
        if (0 == (t &= 63)) return this;
        var e = this.high_;
        return 32 > t ? goog.math.Long.fromBits(this.low_ >>> t | e << 32 - t, e >>> t) : 32 == t ? goog.math.Long.fromBits(e, 0) : goog.math.Long.fromBits(e >>> t - 32, 0);
      }, goog.math.Long.ValueCacheId_ = {
        MAX_VALUE: 1,
        MIN_VALUE: 2,
        TWO_PWR_24: 6
      };
      var com = {
        cognitect: {}
      };
      com.cognitect.transit = {}, com.cognitect.transit.delimiters = {}, com.cognitect.transit.delimiters.ESC = "~", com.cognitect.transit.delimiters.TAG = "#", com.cognitect.transit.delimiters.SUB = "^", com.cognitect.transit.delimiters.RES = "`", com.cognitect.transit.delimiters.ESC_TAG = "~#", com.cognitect.transit.caching = {}, com.cognitect.transit.caching.MIN_SIZE_CACHEABLE = 3, com.cognitect.transit.caching.BASE_CHAR_IDX = 48, com.cognitect.transit.caching.CACHE_CODE_DIGITS = 44, com.cognitect.transit.caching.MAX_CACHE_ENTRIES = com.cognitect.transit.caching.CACHE_CODE_DIGITS * com.cognitect.transit.caching.CACHE_CODE_DIGITS, com.cognitect.transit.caching.MAX_CACHE_SIZE = 4096, com.cognitect.transit.caching.isCacheable = function (t, e) {
        if (t.length > com.cognitect.transit.caching.MIN_SIZE_CACHEABLE) {
          if (e) return !0;
          var r = t.charAt(0),
              n = t.charAt(1);
          return r === com.cognitect.transit.delimiters.ESC && (":" === n || "$" === n || "#" === n);
        }

        return !1;
      }, com.cognitect.transit.caching.idxToCode = function (t) {
        var e = Math.floor(t / com.cognitect.transit.caching.CACHE_CODE_DIGITS);
        return t = String.fromCharCode(t % com.cognitect.transit.caching.CACHE_CODE_DIGITS + com.cognitect.transit.caching.BASE_CHAR_IDX), 0 === e ? com.cognitect.transit.delimiters.SUB + t : com.cognitect.transit.delimiters.SUB + String.fromCharCode(e + com.cognitect.transit.caching.BASE_CHAR_IDX) + t;
      }, com.cognitect.transit.caching.WriteCache = function () {
        this.cacheSize = this.gen = this.idx = 0, this.cache = {};
      }, com.cognitect.transit.caching.WriteCache.prototype.write = function (t, e) {
        if (com.cognitect.transit.caching.isCacheable(t, e)) {
          this.cacheSize === com.cognitect.transit.caching.MAX_CACHE_SIZE ? (this.clear(), this.gen = 0, this.cache = {}) : this.idx === com.cognitect.transit.caching.MAX_CACHE_ENTRIES && this.clear();
          var r = this.cache[t];
          return null == r ? (this.cache[t] = [com.cognitect.transit.caching.idxToCode(this.idx), this.gen], this.idx++, t) : r[1] != this.gen ? (r[1] = this.gen, r[0] = com.cognitect.transit.caching.idxToCode(this.idx), this.idx++, t) : r[0];
        }

        return t;
      }, com.cognitect.transit.caching.WriteCache.prototype.clear = function () {
        this.idx = 0, this.gen++;
      }, com.cognitect.transit.caching.writeCache = function () {
        return new com.cognitect.transit.caching.WriteCache();
      }, com.cognitect.transit.caching.isCacheCode = function (t) {
        return t.charAt(0) === com.cognitect.transit.delimiters.SUB && " " !== t.charAt(1);
      }, com.cognitect.transit.caching.codeToIdx = function (t) {
        if (2 === t.length) return t.charCodeAt(1) - com.cognitect.transit.caching.BASE_CHAR_IDX;
        var e = (t.charCodeAt(1) - com.cognitect.transit.caching.BASE_CHAR_IDX) * com.cognitect.transit.caching.CACHE_CODE_DIGITS;
        return t = t.charCodeAt(2) - com.cognitect.transit.caching.BASE_CHAR_IDX, e + t;
      }, com.cognitect.transit.caching.ReadCache = function () {
        this.idx = 0, this.cache = [];
      }, com.cognitect.transit.caching.ReadCache.prototype.write = function (t, e) {
        return this.idx == com.cognitect.transit.caching.MAX_CACHE_ENTRIES && (this.idx = 0), this.cache[this.idx] = t, this.idx++, t;
      }, com.cognitect.transit.caching.ReadCache.prototype.read = function (t, e) {
        return this.cache[com.cognitect.transit.caching.codeToIdx(t)];
      }, com.cognitect.transit.caching.ReadCache.prototype.clear = function () {
        this.idx = 0;
      }, com.cognitect.transit.caching.readCache = function () {
        return new com.cognitect.transit.caching.ReadCache();
      }, com.cognitect.transit.util = {}, com.cognitect.transit.util.objectKeys = void 0 !== Object.keys ? function (t) {
        return Object.keys(t);
      } : function (t) {
        return goog.object.getKeys(t);
      }, com.cognitect.transit.util.isArray = void 0 !== Array.isArray ? function (t) {
        return Array.isArray(t);
      } : function (t) {
        return "array" === goog.typeOf(t);
      }, com.cognitect.transit.util.chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", com.cognitect.transit.util.randInt = function (t) {
        return Math.round(Math.random() * t);
      }, com.cognitect.transit.util.randHex = function () {
        return com.cognitect.transit.util.randInt(15).toString(16);
      }, com.cognitect.transit.util.randomUUID = function () {
        var t = (8 | 3 & com.cognitect.transit.util.randInt(14)).toString(16);
        return com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + "-" + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + "-4" + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + "-" + t + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + "-" + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex();
      }, com.cognitect.transit.util.btoa = function (t) {
        if ("undefined" != typeof btoa) return btoa(t);
        t = String(t);

        for (var e, r, n = 0, o = com.cognitect.transit.util.chars, i = ""; t.charAt(0 | n) || (o = "=", n % 1); i += o.charAt(63 & e >> 8 - n % 1 * 8)) {
          if (255 < (r = t.charCodeAt(n += .75))) throw Error("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
          e = e << 8 | r;
        }

        return i;
      }, com.cognitect.transit.util.atob = function (t) {
        if ("undefined" != typeof atob) return atob(t);
        if (t = String(t).replace(/=+$/, ""), 1 == t.length % 4) throw Error("'atob' failed: The string to be decoded is not correctly encoded.");

        for (var e, r, n = 0, o = 0, i = ""; r = t.charAt(o++); ~r && (e = n % 4 ? 64 * e + r : r, n++ % 4) ? i += String.fromCharCode(255 & e >> (-2 * n & 6)) : 0) {
          r = com.cognitect.transit.util.chars.indexOf(r);
        }

        return i;
      }, com.cognitect.transit.util.Uint8ToBase64 = function (t) {
        for (var e, r = 0, n = t.length, o = ""; r < n;) {
          e = t.subarray(r, Math.min(r + 32768, n)), o += String.fromCharCode.apply(null, e), r += 32768;
        }

        return com.cognitect.transit.util.btoa(o);
      }, com.cognitect.transit.util.Base64ToUint8 = function (t) {
        t = com.cognitect.transit.util.atob(t);

        for (var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++) {
          var o = t.charCodeAt(n);
          r[n] = o;
        }

        return r;
      }, com.cognitect.transit.eq = {}, com.cognitect.transit.eq.hashCodeProperty = "transit$hashCode$", com.cognitect.transit.eq.hashCodeCounter = 1, com.cognitect.transit.eq.equals = function (t, e) {
        if (null == t) return null == e;
        if (t === e) return !0;

        if ("object" == typeof t) {
          if (com.cognitect.transit.util.isArray(t)) {
            if (com.cognitect.transit.util.isArray(e) && t.length === e.length) {
              for (var r = 0; r < t.length; r++) {
                if (!com.cognitect.transit.eq.equals(t[r], e[r])) return !1;
              }

              return !0;
            }

            return !1;
          }

          if (t.com$cognitect$transit$equals) return t.com$cognitect$transit$equals(e);

          if (null != e && "object" == typeof e) {
            if (e.com$cognitect$transit$equals) return e.com$cognitect$transit$equals(t);
            var n,
                r = 0,
                o = com.cognitect.transit.util.objectKeys(e).length;

            for (n in t) {
              if (t.hasOwnProperty(n) && (r++, !e.hasOwnProperty(n) || !com.cognitect.transit.eq.equals(t[n], e[n]))) return !1;
            }

            return r === o;
          }
        }

        return !1;
      }, com.cognitect.transit.eq.hashCombine = function (t, e) {
        return t ^ e + 2654435769 + (t << 6) + (t >> 2);
      }, com.cognitect.transit.eq.stringCodeCache = {}, com.cognitect.transit.eq.stringCodeCacheSize = 0, com.cognitect.transit.eq.STR_CACHE_MAX = 256, com.cognitect.transit.eq.hashString = function (t) {
        var e = com.cognitect.transit.eq.stringCodeCache[t];
        if (null != e) return e;

        for (var r = e = 0; r < t.length; ++r) {
          e = 31 * e + t.charCodeAt(r), e %= 4294967296;
        }

        return com.cognitect.transit.eq.stringCodeCacheSize++, com.cognitect.transit.eq.stringCodeCacheSize >= com.cognitect.transit.eq.STR_CACHE_MAX && (com.cognitect.transit.eq.stringCodeCache = {}, com.cognitect.transit.eq.stringCodeCacheSize = 1), com.cognitect.transit.eq.stringCodeCache[t] = e;
      }, com.cognitect.transit.eq.hashMapLike = function (t) {
        var e = 0;
        if (null != t.forEach) t.forEach(function (t, r, n) {
          e = (e + (com.cognitect.transit.eq.hashCode(r) ^ com.cognitect.transit.eq.hashCode(t))) % 4503599627370496;
        });else for (var r = com.cognitect.transit.util.objectKeys(t), n = 0; n < r.length; n++) {
          var o = r[n],
              i = t[o],
              e = (e + (com.cognitect.transit.eq.hashCode(o) ^ com.cognitect.transit.eq.hashCode(i))) % 4503599627370496;
        }
        return e;
      }, com.cognitect.transit.eq.hashArrayLike = function (t) {
        var e = 0;
        if (com.cognitect.transit.util.isArray(t)) for (var r = 0; r < t.length; r++) {
          e = com.cognitect.transit.eq.hashCombine(e, com.cognitect.transit.eq.hashCode(t[r]));
        } else t.forEach && t.forEach(function (t, r) {
          e = com.cognitect.transit.eq.hashCombine(e, com.cognitect.transit.eq.hashCode(t));
        });
        return e;
      }, com.cognitect.transit.eq.hashCode = function (t) {
        if (null == t) return 0;

        switch (typeof t) {
          case "number":
            return t;

          case "boolean":
            return !0 === t ? 1 : 0;

          case "string":
            return com.cognitect.transit.eq.hashString(t);

          case "function":
            var e = t[com.cognitect.transit.eq.hashCodeProperty];
            return e || (e = com.cognitect.transit.eq.hashCodeCounter, void 0 !== Object.defineProperty ? Object.defineProperty(t, com.cognitect.transit.eq.hashCodeProperty, {
              value: e,
              enumerable: !1
            }) : t[com.cognitect.transit.eq.hashCodeProperty] = e, com.cognitect.transit.eq.hashCodeCounter++), e;

          default:
            return t instanceof Date ? t.valueOf() : com.cognitect.transit.util.isArray(t) ? com.cognitect.transit.eq.hashArrayLike(t) : t.com$cognitect$transit$hashCode ? t.com$cognitect$transit$hashCode() : com.cognitect.transit.eq.hashMapLike(t);
        }
      }, com.cognitect.transit.eq.extendToEQ = function (t, e) {
        return t.com$cognitect$transit$hashCode = e.hashCode, t.com$cognitect$transit$equals = e.equals, t;
      }, com.cognitect.transit.types = {}, com.cognitect.transit.types.ITERATOR = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator", com.cognitect.transit.types.TaggedValue = function (t, e) {
        this.tag = t, this.rep = e, this.hashCode = -1;
      }, com.cognitect.transit.types.TaggedValue.prototype.toString = function () {
        return "[TaggedValue: " + this.tag + ", " + this.rep + "]";
      }, com.cognitect.transit.types.TaggedValue.prototype.equiv = function (t) {
        return com.cognitect.transit.eq.equals(this, t);
      }, com.cognitect.transit.types.TaggedValue.prototype.equiv = com.cognitect.transit.types.TaggedValue.prototype.equiv, com.cognitect.transit.types.TaggedValue.prototype.com$cognitect$transit$equals = function (t) {
        return t instanceof com.cognitect.transit.types.TaggedValue && this.tag === t.tag && com.cognitect.transit.eq.equals(this.rep, t.rep);
      }, com.cognitect.transit.types.TaggedValue.prototype.com$cognitect$transit$hashCode = function () {
        return -1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashCombine(com.cognitect.transit.eq.hashCode(this.tag), com.cognitect.transit.eq.hashCode(this.rep))), this.hashCode;
      }, com.cognitect.transit.types.taggedValue = function (t, e) {
        return new com.cognitect.transit.types.TaggedValue(t, e);
      }, com.cognitect.transit.types.isTaggedValue = function (t) {
        return t instanceof com.cognitect.transit.types.TaggedValue;
      }, com.cognitect.transit.types.nullValue = function () {
        return null;
      }, com.cognitect.transit.types.boolValue = function (t) {
        return "t" === t;
      }, com.cognitect.transit.types.MAX_INT = goog.math.Long.fromString("9007199254740991"), com.cognitect.transit.types.MIN_INT = goog.math.Long.fromString("-9007199254740991"), com.cognitect.transit.types.intValue = function (t) {
        return "number" == typeof t || t instanceof goog.math.Long ? t : (t = goog.math.Long.fromString(t, 10), t.greaterThan(com.cognitect.transit.types.MAX_INT) || t.lessThan(com.cognitect.transit.types.MIN_INT) ? t : t.toNumber());
      }, goog.math.Long.prototype.equiv = function (t) {
        return com.cognitect.transit.eq.equals(this, t);
      }, goog.math.Long.prototype.equiv = goog.math.Long.prototype.equiv, goog.math.Long.prototype.com$cognitect$transit$equals = function (t) {
        return t instanceof goog.math.Long && this.equals(t);
      }, goog.math.Long.prototype.com$cognitect$transit$hashCode = function () {
        return this.toInt();
      }, com.cognitect.transit.types.isInteger = function (t) {
        return t instanceof goog.math.Long || "number" == typeof t && !isNaN(t) && 1 / 0 !== t && parseFloat(t) === parseInt(t, 10);
      }, com.cognitect.transit.types.floatValue = function (t) {
        return parseFloat(t);
      }, com.cognitect.transit.types.bigInteger = function (t) {
        return com.cognitect.transit.types.taggedValue("n", t);
      }, com.cognitect.transit.types.isBigInteger = function (t) {
        return t instanceof com.cognitect.transit.types.TaggedValue && "n" === t.tag;
      }, com.cognitect.transit.types.bigDecimalValue = function (t) {
        return com.cognitect.transit.types.taggedValue("f", t);
      }, com.cognitect.transit.types.isBigDecimal = function (t) {
        return t instanceof com.cognitect.transit.types.TaggedValue && "f" === t.tag;
      }, com.cognitect.transit.types.charValue = function (t) {
        return t;
      }, com.cognitect.transit.types.Keyword = function (t) {
        this._name = t, this.hashCode = -1;
      }, com.cognitect.transit.types.Keyword.prototype.toString = function () {
        return ":" + this._name;
      }, com.cognitect.transit.types.Keyword.prototype.namespace = function () {
        var t = this._name.indexOf("/");

        return -1 != t ? this._name.substring(0, t) : null;
      }, com.cognitect.transit.types.Keyword.prototype.name = function () {
        var t = this._name.indexOf("/");

        return -1 != t ? this._name.substring(t + 1, this._name.length) : this._name;
      }, com.cognitect.transit.types.Keyword.prototype.equiv = function (t) {
        return com.cognitect.transit.eq.equals(this, t);
      }, com.cognitect.transit.types.Keyword.prototype.equiv = com.cognitect.transit.types.Keyword.prototype.equiv, com.cognitect.transit.types.Keyword.prototype.com$cognitect$transit$equals = function (t) {
        return t instanceof com.cognitect.transit.types.Keyword && this._name == t._name;
      }, com.cognitect.transit.types.Keyword.prototype.com$cognitect$transit$hashCode = function () {
        return -1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashCode(this._name)), this.hashCode;
      }, com.cognitect.transit.types.keyword = function (t) {
        return new com.cognitect.transit.types.Keyword(t);
      }, com.cognitect.transit.types.isKeyword = function (t) {
        return t instanceof com.cognitect.transit.types.Keyword;
      }, com.cognitect.transit.types.Symbol = function (t) {
        this._name = t, this.hashCode = -1;
      }, com.cognitect.transit.types.Symbol.prototype.namespace = function () {
        var t = this._name.indexOf("/");

        return -1 != t ? this._name.substring(0, t) : null;
      }, com.cognitect.transit.types.Symbol.prototype.name = function () {
        var t = this._name.indexOf("/");

        return -1 != t ? this._name.substring(t + 1, this._name.length) : this._name;
      }, com.cognitect.transit.types.Symbol.prototype.toString = function () {
        return this._name;
      }, com.cognitect.transit.types.Symbol.prototype.equiv = function (t) {
        return com.cognitect.transit.eq.equals(this, t);
      }, com.cognitect.transit.types.Symbol.prototype.equiv = com.cognitect.transit.types.Symbol.prototype.equiv, com.cognitect.transit.types.Symbol.prototype.com$cognitect$transit$equals = function (t) {
        return t instanceof com.cognitect.transit.types.Symbol && this._name == t._name;
      }, com.cognitect.transit.types.Symbol.prototype.com$cognitect$transit$hashCode = function () {
        return -1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashCode(this._name)), this.hashCode;
      }, com.cognitect.transit.types.symbol = function (t) {
        return new com.cognitect.transit.types.Symbol(t);
      }, com.cognitect.transit.types.isSymbol = function (t) {
        return t instanceof com.cognitect.transit.types.Symbol;
      }, com.cognitect.transit.types.hexFor = function (t, e, r) {
        var n = "";
        r = r || e + 1;

        for (var o = 8 * (7 - e), i = goog.math.Long.fromInt(255).shiftLeft(o); e < r; e++, o -= 8, i = i.shiftRightUnsigned(8)) {
          var c = t.and(i).shiftRightUnsigned(o).toString(16);
          1 == c.length && (c = "0" + c), n += c;
        }

        return n;
      }, com.cognitect.transit.types.UUID = function (t, e) {
        this.high = t, this.low = e, this.hashCode = -1;
      }, com.cognitect.transit.types.UUID.prototype.getLeastSignificantBits = function () {
        return this.low;
      }, com.cognitect.transit.types.UUID.prototype.getMostSignificantBits = function () {
        return this.high;
      }, com.cognitect.transit.types.UUID.prototype.toString = function () {
        var t = this.high,
            e = this.low,
            r = com.cognitect.transit.types.hexFor(t, 0, 4) + "-";
        return r += com.cognitect.transit.types.hexFor(t, 4, 6) + "-", r += com.cognitect.transit.types.hexFor(t, 6, 8) + "-", r += com.cognitect.transit.types.hexFor(e, 0, 2) + "-", r += com.cognitect.transit.types.hexFor(e, 2, 8);
      }, com.cognitect.transit.types.UUID.prototype.equiv = function (t) {
        return com.cognitect.transit.eq.equals(this, t);
      }, com.cognitect.transit.types.UUID.prototype.equiv = com.cognitect.transit.types.UUID.prototype.equiv, com.cognitect.transit.types.UUID.prototype.com$cognitect$transit$equals = function (t) {
        return t instanceof com.cognitect.transit.types.UUID && this.high.equals(t.high) && this.low.equals(t.low);
      }, com.cognitect.transit.types.UUID.prototype.com$cognitect$transit$hashCode = function () {
        return -1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashCode(this.toString())), this.hashCode;
      }, com.cognitect.transit.types.UUIDfromString = function (t) {
        t = t.replace(/-/g, "");
        var e,
            r,
            n = e = 0;

        for (r = 24; 8 > n; n += 2, r -= 8) {
          e |= parseInt(t.substring(n, n + 2), 16) << r;
        }

        var o = 0;

        for (n = 8, r = 24; 16 > n; n += 2, r -= 8) {
          o |= parseInt(t.substring(n, n + 2), 16) << r;
        }

        var i = goog.math.Long.fromBits(o, e);

        for (e = 0, n = 16, r = 24; 24 > n; n += 2, r -= 8) {
          e |= parseInt(t.substring(n, n + 2), 16) << r;
        }

        for (o = 0, r = n = 24; 32 > n; n += 2, r -= 8) {
          o |= parseInt(t.substring(n, n + 2), 16) << r;
        }

        return t = goog.math.Long.fromBits(o, e), new com.cognitect.transit.types.UUID(i, t);
      }, com.cognitect.transit.types.uuid = function (t) {
        return com.cognitect.transit.types.UUIDfromString(t);
      }, com.cognitect.transit.types.isUUID = function (t) {
        return t instanceof com.cognitect.transit.types.UUID;
      }, com.cognitect.transit.types.date = function (t) {
        return t = "number" == typeof t ? t : parseInt(t, 10), new Date(t);
      }, com.cognitect.transit.types.verboseDate = function (t) {
        return new Date(t);
      }, Date.prototype.com$cognitect$transit$equals = function (t) {
        return t instanceof Date && this.valueOf() === t.valueOf();
      }, Date.prototype.com$cognitect$transit$hashCode = function () {
        return this.valueOf();
      }, com.cognitect.transit.types.binary = function (t, e) {
        return e && !1 === e.preferBuffers || void 0 === goog.global.Buffer ? "undefined" != typeof Uint8Array ? com.cognitect.transit.util.Base64ToUint8(t) : com.cognitect.transit.types.taggedValue("b", t) : new goog.global.Buffer(t, "base64");
      }, com.cognitect.transit.types.isBinary = function (t) {
        return void 0 !== goog.global.Buffer && t instanceof goog.global.Buffer || "undefined" != typeof Uint8Array && t instanceof Uint8Array || t instanceof com.cognitect.transit.types.TaggedValue && "b" === t.tag;
      }, com.cognitect.transit.types.uri = function (t) {
        return com.cognitect.transit.types.taggedValue("r", t);
      }, com.cognitect.transit.types.isURI = function (t) {
        return t instanceof com.cognitect.transit.types.TaggedValue && "r" === t.tag;
      }, com.cognitect.transit.types.KEYS = 0, com.cognitect.transit.types.VALUES = 1, com.cognitect.transit.types.ENTRIES = 2, com.cognitect.transit.types.TransitArrayMapIterator = function (t, e) {
        this.entries = t, this.type = e || com.cognitect.transit.types.KEYS, this.idx = 0;
      }, com.cognitect.transit.types.TransitArrayMapIterator.prototype.next = function () {
        if (this.idx < this.entries.length) {
          var t = {
            value: this.type === com.cognitect.transit.types.KEYS ? this.entries[this.idx] : this.type === com.cognitect.transit.types.VALUES ? this.entries[this.idx + 1] : [this.entries[this.idx], this.entries[this.idx + 1]],
            done: !1
          };
          return this.idx += 2, t;
        }

        return {
          value: null,
          done: !0
        };
      }, com.cognitect.transit.types.TransitArrayMapIterator.prototype.next = com.cognitect.transit.types.TransitArrayMapIterator.prototype.next, com.cognitect.transit.types.TransitArrayMapIterator.prototype[com.cognitect.transit.types.ITERATOR] = function () {
        return this;
      }, com.cognitect.transit.types.TransitMapIterator = function (t, e) {
        this.map = t, this.type = e || com.cognitect.transit.types.KEYS, this.keys = this.map.getKeys(), this.idx = 0, this.bucket = null, this.bucketIdx = 0;
      }, com.cognitect.transit.types.TransitMapIterator.prototype.next = function () {
        if (this.idx < this.map.size) {
          null != this.bucket && this.bucketIdx < this.bucket.length || (this.bucket = this.map.map[this.keys[this.idx]], this.bucketIdx = 0);
          var t = {
            value: this.type === com.cognitect.transit.types.KEYS ? this.bucket[this.bucketIdx] : this.type === com.cognitect.transit.types.VALUES ? this.bucket[this.bucketIdx + 1] : [this.bucket[this.bucketIdx], this.bucket[this.bucketIdx + 1]],
            done: !1
          };
          return this.idx++, this.bucketIdx += 2, t;
        }

        return {
          value: null,
          done: !0
        };
      }, com.cognitect.transit.types.TransitMapIterator.prototype.next = com.cognitect.transit.types.TransitMapIterator.prototype.next, com.cognitect.transit.types.TransitMapIterator.prototype[com.cognitect.transit.types.ITERATOR] = function () {
        return this;
      }, com.cognitect.transit.types.mapEquals = function (t, e) {
        if (t instanceof com.cognitect.transit.types.TransitMap && com.cognitect.transit.types.isMap(e)) {
          if (t.size !== e.size) return !1;

          for (var r in t.map) {
            for (var n = t.map[r], o = 0; o < n.length; o += 2) {
              if (!com.cognitect.transit.eq.equals(n[o + 1], e.get(n[o]))) return !1;
            }
          }

          return !0;
        }

        if (t instanceof com.cognitect.transit.types.TransitArrayMap && com.cognitect.transit.types.isMap(e)) {
          if (t.size !== e.size) return !1;

          for (r = t._entries, o = 0; o < r.length; o += 2) {
            if (!com.cognitect.transit.eq.equals(r[o + 1], e.get(r[o]))) return !1;
          }

          return !0;
        }

        if (null != e && "object" == typeof e && (o = com.cognitect.transit.util.objectKeys(e), r = o.length, t.size === r)) {
          for (n = 0; n < r; n++) {
            var i = o[n];
            if (!t.has(i) || !com.cognitect.transit.eq.equals(e[i], t.get(i))) return !1;
          }

          return !0;
        }

        return !1;
      }, com.cognitect.transit.types.SMALL_ARRAY_MAP_THRESHOLD = 8, com.cognitect.transit.types.ARRAY_MAP_THRESHOLD = 32, com.cognitect.transit.types.ARRAY_MAP_ACCESS_THRESHOLD = 32, com.cognitect.transit.types.print = function (t) {
        return null == t ? "null" : goog.isArray(t) ? "[" + t.toString() + "]" : goog.isString(t) ? '"' + t + '"' : t.toString();
      }, com.cognitect.transit.types.printMap = function (t) {
        var e = 0,
            r = "TransitMap {";
        return t.forEach(function (n, o) {
          r += com.cognitect.transit.types.print(o) + " => " + com.cognitect.transit.types.print(n), e < t.size - 1 && (r += ", "), e++;
        }), r + "}";
      }, com.cognitect.transit.types.printSet = function (t) {
        var e = 0,
            r = "TransitSet {";
        return t.forEach(function (n) {
          r += com.cognitect.transit.types.print(n), e < t.size - 1 && (r += ", "), e++;
        }), r + "}";
      }, com.cognitect.transit.types.TransitArrayMap = function (t) {
        this._entries = t, this.backingMap = null, this.hashCode = -1, this.size = t.length / 2, this.accesses = 0;
      }, com.cognitect.transit.types.TransitArrayMap.prototype.toString = function () {
        return com.cognitect.transit.types.printMap(this);
      }, com.cognitect.transit.types.TransitArrayMap.prototype.inspect = function () {
        return this.toString();
      }, com.cognitect.transit.types.TransitArrayMap.prototype.convert = function () {
        if (this.backingMap) throw Error("Invalid operation, already converted");
        return !(this.size < com.cognitect.transit.types.SMALL_ARRAY_MAP_THRESHOLD) && ++this.accesses > com.cognitect.transit.types.ARRAY_MAP_ACCESS_THRESHOLD && (this.backingMap = com.cognitect.transit.types.map(this._entries, !1, !0), this._entries = [], !0);
      }, com.cognitect.transit.types.TransitArrayMap.prototype.clear = function () {
        this.hashCode = -1, this.backingMap ? this.backingMap.clear() : this._entries = [], this.size = 0;
      }, com.cognitect.transit.types.TransitArrayMap.prototype.clear = com.cognitect.transit.types.TransitArrayMap.prototype.clear, com.cognitect.transit.types.TransitArrayMap.prototype.keys = function () {
        return this.backingMap ? this.backingMap.keys() : new com.cognitect.transit.types.TransitArrayMapIterator(this._entries, com.cognitect.transit.types.KEYS);
      }, com.cognitect.transit.types.TransitArrayMap.prototype.keys = com.cognitect.transit.types.TransitArrayMap.prototype.keys, com.cognitect.transit.types.TransitArrayMap.prototype.keySet = function () {
        if (this.backingMap) return this.backingMap.keySet();

        for (var t = [], e = 0, r = 0; r < this._entries.length; e++, r += 2) {
          t[e] = this._entries[r];
        }

        return t;
      }, com.cognitect.transit.types.TransitArrayMap.prototype.keySet = com.cognitect.transit.types.TransitArrayMap.prototype.keySet, com.cognitect.transit.types.TransitArrayMap.prototype.entries = function () {
        return this.backingMap ? this.backingMap.entries() : new com.cognitect.transit.types.TransitArrayMapIterator(this._entries, com.cognitect.transit.types.ENTRIES);
      }, com.cognitect.transit.types.TransitArrayMap.prototype.entries = com.cognitect.transit.types.TransitArrayMap.prototype.entries, com.cognitect.transit.types.TransitArrayMap.prototype.values = function () {
        return this.backingMap ? this.backingMap.values() : new com.cognitect.transit.types.TransitArrayMapIterator(this._entries, com.cognitect.transit.types.VALUES);
      }, com.cognitect.transit.types.TransitArrayMap.prototype.values = com.cognitect.transit.types.TransitArrayMap.prototype.values, com.cognitect.transit.types.TransitArrayMap.prototype.forEach = function (t) {
        if (this.backingMap) this.backingMap.forEach(t);else for (var e = 0; e < this._entries.length; e += 2) {
          t(this._entries[e + 1], this._entries[e]);
        }
      }, com.cognitect.transit.types.TransitArrayMap.prototype.forEach = com.cognitect.transit.types.TransitArrayMap.prototype.forEach, com.cognitect.transit.types.TransitArrayMap.prototype.get = function (t, e) {
        if (this.backingMap) return this.backingMap.get(t);
        if (this.convert()) return this.get(t);

        for (var r = 0; r < this._entries.length; r += 2) {
          if (com.cognitect.transit.eq.equals(this._entries[r], t)) return this._entries[r + 1];
        }

        return e;
      }, com.cognitect.transit.types.TransitArrayMap.prototype.get = com.cognitect.transit.types.TransitArrayMap.prototype.get, com.cognitect.transit.types.TransitArrayMap.prototype.has = function (t) {
        if (this.backingMap) return this.backingMap.has(t);
        if (this.convert()) return this.has(t);

        for (var e = 0; e < this._entries.length; e += 2) {
          if (com.cognitect.transit.eq.equals(this._entries[e], t)) return !0;
        }

        return !1;
      }, com.cognitect.transit.types.TransitArrayMap.prototype.has = com.cognitect.transit.types.TransitArrayMap.prototype.has, com.cognitect.transit.types.TransitArrayMap.prototype.set = function (t, e) {
        if (this.hashCode = -1, this.backingMap) this.backingMap.set(t, e), this.size = this.backingMap.size;else {
          for (var r = 0; r < this._entries.length; r += 2) {
            if (com.cognitect.transit.eq.equals(this._entries[r], t)) return void (this._entries[r + 1] = e);
          }

          this._entries.push(t), this._entries.push(e), this.size++, this.size > com.cognitect.transit.types.ARRAY_MAP_THRESHOLD && (this.backingMap = com.cognitect.transit.types.map(this._entries, !1, !0), this._entries = null);
        }
      }, com.cognitect.transit.types.TransitArrayMap.prototype.set = com.cognitect.transit.types.TransitArrayMap.prototype.set, com.cognitect.transit.types.TransitArrayMap.prototype.delete = function (t) {
        if (this.hashCode = -1, this.backingMap) return t = this.backingMap.delete(t), this.size = this.backingMap.size, t;

        for (var e = 0; e < this._entries.length; e += 2) {
          if (com.cognitect.transit.eq.equals(this._entries[e], t)) return t = this._entries[e + 1], this._entries.splice(e, 2), this.size--, t;
        }
      }, com.cognitect.transit.types.TransitArrayMap.prototype.clone = function () {
        var t = com.cognitect.transit.types.map();
        return this.forEach(function (e, r) {
          t.set(r, e);
        }), t;
      }, com.cognitect.transit.types.TransitArrayMap.prototype.clone = com.cognitect.transit.types.TransitArrayMap.prototype.clone, com.cognitect.transit.types.TransitArrayMap.prototype[com.cognitect.transit.types.ITERATOR] = function () {
        return this.entries();
      }, com.cognitect.transit.types.TransitArrayMap.prototype.com$cognitect$transit$hashCode = function () {
        return this.backingMap ? this.backingMap.com$cognitect$transit$hashCode() : (-1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashMapLike(this)), this.hashCode);
      }, com.cognitect.transit.types.TransitArrayMap.prototype.com$cognitect$transit$equals = function (t) {
        return this.backingMap ? com.cognitect.transit.types.mapEquals(this.backingMap, t) : com.cognitect.transit.types.mapEquals(this, t);
      }, com.cognitect.transit.types.TransitMap = function (t, e, r) {
        this.map = e || {}, this._keys = t || [], this.size = r || 0, this.hashCode = -1;
      }, com.cognitect.transit.types.TransitMap.prototype.toString = function () {
        return com.cognitect.transit.types.printMap(this);
      }, com.cognitect.transit.types.TransitMap.prototype.inspect = function () {
        return this.toString();
      }, com.cognitect.transit.types.TransitMap.prototype.clear = function () {
        this.hashCode = -1, this.map = {}, this._keys = [], this.size = 0;
      }, com.cognitect.transit.types.TransitMap.prototype.clear = com.cognitect.transit.types.TransitMap.prototype.clear, com.cognitect.transit.types.TransitMap.prototype.getKeys = function () {
        return null != this._keys ? this._keys : com.cognitect.transit.util.objectKeys(this.map);
      }, com.cognitect.transit.types.TransitMap.prototype.delete = function (t) {
        this.hashCode = -1, this._keys = null;

        for (var e = com.cognitect.transit.eq.hashCode(t), r = this.map[e], n = 0; n < r.length; n += 2) {
          if (com.cognitect.transit.eq.equals(t, r[n])) return t = r[n + 1], r.splice(n, 2), 0 === r.length && delete this.map[e], this.size--, t;
        }
      }, com.cognitect.transit.types.TransitMap.prototype.entries = function () {
        return new com.cognitect.transit.types.TransitMapIterator(this, com.cognitect.transit.types.ENTRIES);
      }, com.cognitect.transit.types.TransitMap.prototype.entries = com.cognitect.transit.types.TransitMap.prototype.entries, com.cognitect.transit.types.TransitMap.prototype.forEach = function (t) {
        for (var e = this.getKeys(), r = 0; r < e.length; r++) {
          for (var n = this.map[e[r]], o = 0; o < n.length; o += 2) {
            t(n[o + 1], n[o], this);
          }
        }
      }, com.cognitect.transit.types.TransitMap.prototype.forEach = com.cognitect.transit.types.TransitMap.prototype.forEach, com.cognitect.transit.types.TransitMap.prototype.get = function (t, e) {
        var r = com.cognitect.transit.eq.hashCode(t),
            r = this.map[r];
        if (null == r) return e;

        for (var n = 0; n < r.length; n += 2) {
          if (com.cognitect.transit.eq.equals(t, r[n])) return r[n + 1];
        }
      }, com.cognitect.transit.types.TransitMap.prototype.get = com.cognitect.transit.types.TransitMap.prototype.get, com.cognitect.transit.types.TransitMap.prototype.has = function (t) {
        var e = com.cognitect.transit.eq.hashCode(t),
            e = this.map[e];
        if (null != e) for (var r = 0; r < e.length; r += 2) {
          if (com.cognitect.transit.eq.equals(t, e[r])) return !0;
        }
        return !1;
      }, com.cognitect.transit.types.TransitMap.prototype.has = com.cognitect.transit.types.TransitMap.prototype.has, com.cognitect.transit.types.TransitMap.prototype.keys = function () {
        return new com.cognitect.transit.types.TransitMapIterator(this, com.cognitect.transit.types.KEYS);
      }, com.cognitect.transit.types.TransitMap.prototype.keys = com.cognitect.transit.types.TransitMap.prototype.keys, com.cognitect.transit.types.TransitMap.prototype.keySet = function () {
        for (var t = this.getKeys(), e = [], r = 0; r < t.length; r++) {
          for (var n = this.map[t[r]], o = 0; o < n.length; o += 2) {
            e.push(n[o]);
          }
        }

        return e;
      }, com.cognitect.transit.types.TransitMap.prototype.keySet = com.cognitect.transit.types.TransitMap.prototype.keySet, com.cognitect.transit.types.TransitMap.prototype.set = function (t, e) {
        this.hashCode = -1;
        var r = com.cognitect.transit.eq.hashCode(t),
            n = this.map[r];
        if (null == n) this._keys && this._keys.push(r), this.map[r] = [t, e], this.size++;else {
          for (var r = !0, o = 0; o < n.length; o += 2) {
            if (com.cognitect.transit.eq.equals(e, n[o])) {
              r = !1, n[o] = e;
              break;
            }
          }

          r && (n.push(t), n.push(e), this.size++);
        }
      }, com.cognitect.transit.types.TransitMap.prototype.set = com.cognitect.transit.types.TransitMap.prototype.set, com.cognitect.transit.types.TransitMap.prototype.values = function () {
        return new com.cognitect.transit.types.TransitMapIterator(this, com.cognitect.transit.types.VALUES);
      }, com.cognitect.transit.types.TransitMap.prototype.values = com.cognitect.transit.types.TransitMap.prototype.values, com.cognitect.transit.types.TransitMap.prototype.clone = function () {
        var t = com.cognitect.transit.types.map();
        return this.forEach(function (e, r) {
          t.set(r, e);
        }), t;
      }, com.cognitect.transit.types.TransitMap.prototype.clone = com.cognitect.transit.types.TransitMap.prototype.clone, com.cognitect.transit.types.TransitMap.prototype[com.cognitect.transit.types.ITERATOR] = function () {
        return this.entries();
      }, com.cognitect.transit.types.TransitMap.prototype.com$cognitect$transit$hashCode = function () {
        return -1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashMapLike(this)), this.hashCode;
      }, com.cognitect.transit.types.TransitMap.prototype.com$cognitect$transit$equals = function (t) {
        return com.cognitect.transit.types.mapEquals(this, t);
      }, com.cognitect.transit.types.map = function (t, e, r) {
        if (t = t || [], e = !1 !== e || e, (!0 !== r || !r) && t.length <= 2 * com.cognitect.transit.types.ARRAY_MAP_THRESHOLD) {
          if (e) {
            var n = t;

            for (t = [], e = 0; e < n.length; e += 2) {
              var o = !1;

              for (r = 0; r < t.length; r += 2) {
                if (com.cognitect.transit.eq.equals(t[r], n[e])) {
                  t[r + 1] = n[e + 1], o = !0;
                  break;
                }
              }

              o || (t.push(n[e]), t.push(n[e + 1]));
            }
          }

          return new com.cognitect.transit.types.TransitArrayMap(t);
        }

        var n = {},
            o = [],
            i = 0;

        for (e = 0; e < t.length; e += 2) {
          r = com.cognitect.transit.eq.hashCode(t[e]);
          var c = n[r];
          if (null == c) o.push(r), n[r] = [t[e], t[e + 1]], i++;else {
            var a = !0;

            for (r = 0; r < c.length; r += 2) {
              if (com.cognitect.transit.eq.equals(c[r], t[e])) {
                c[r + 1] = t[e + 1], a = !1;
                break;
              }
            }

            a && (c.push(t[e]), c.push(t[e + 1]), i++);
          }
        }

        return new com.cognitect.transit.types.TransitMap(o, n, i);
      }, com.cognitect.transit.types.isArrayMap = function (t) {
        return t instanceof com.cognitect.transit.types.TransitArrayMap;
      }, com.cognitect.transit.types.isMap = function (t) {
        return t instanceof com.cognitect.transit.types.TransitArrayMap || t instanceof com.cognitect.transit.types.TransitMap;
      }, com.cognitect.transit.types.TransitSet = function (t) {
        this.map = t, this.size = t.size;
      }, com.cognitect.transit.types.TransitSet.prototype.toString = function () {
        return com.cognitect.transit.types.printSet(this);
      }, com.cognitect.transit.types.TransitSet.prototype.inspect = function () {
        return this.toString();
      }, com.cognitect.transit.types.TransitSet.prototype.add = function (t) {
        this.map.set(t, t), this.size = this.map.size;
      }, com.cognitect.transit.types.TransitSet.prototype.add = com.cognitect.transit.types.TransitSet.prototype.add, com.cognitect.transit.types.TransitSet.prototype.clear = function () {
        this.map = new com.cognitect.transit.types.TransitMap(), this.size = 0;
      }, com.cognitect.transit.types.TransitSet.prototype.clear = com.cognitect.transit.types.TransitSet.prototype.clear;
      com.cognitect.transit.types.TransitSet.prototype.delete = function (t) {
        return t = this.map.delete(t), this.size = this.map.size, t;
      }, com.cognitect.transit.types.TransitSet.prototype.entries = function () {
        return this.map.entries();
      }, com.cognitect.transit.types.TransitSet.prototype.entries = com.cognitect.transit.types.TransitSet.prototype.entries, com.cognitect.transit.types.TransitSet.prototype.forEach = function (t, e) {
        var r = this;
        this.map.forEach(function (e, n, o) {
          t(n, r);
        });
      }, com.cognitect.transit.types.TransitSet.prototype.forEach = com.cognitect.transit.types.TransitSet.prototype.forEach, com.cognitect.transit.types.TransitSet.prototype.has = function (t) {
        return this.map.has(t);
      }, com.cognitect.transit.types.TransitSet.prototype.has = com.cognitect.transit.types.TransitSet.prototype.has, com.cognitect.transit.types.TransitSet.prototype.keys = function () {
        return this.map.keys();
      }, com.cognitect.transit.types.TransitSet.prototype.keys = com.cognitect.transit.types.TransitSet.prototype.keys, com.cognitect.transit.types.TransitSet.prototype.keySet = function () {
        return this.map.keySet();
      }, com.cognitect.transit.types.TransitSet.prototype.keySet = com.cognitect.transit.types.TransitSet.prototype.keySet, com.cognitect.transit.types.TransitSet.prototype.values = function () {
        return this.map.values();
      }, com.cognitect.transit.types.TransitSet.prototype.values = com.cognitect.transit.types.TransitSet.prototype.values, com.cognitect.transit.types.TransitSet.prototype.clone = function () {
        var t = com.cognitect.transit.types.set();
        return this.forEach(function (e) {
          t.add(e);
        }), t;
      }, com.cognitect.transit.types.TransitSet.prototype.clone = com.cognitect.transit.types.TransitSet.prototype.clone, com.cognitect.transit.types.TransitSet.prototype[com.cognitect.transit.types.ITERATOR] = function () {
        return this.values();
      }, com.cognitect.transit.types.TransitSet.prototype.com$cognitect$transit$equals = function (t) {
        return t instanceof com.cognitect.transit.types.TransitSet && (this.size === t.size ? com.cognitect.transit.eq.equals(this.map, t.map) : void 0);
      }, com.cognitect.transit.types.TransitSet.prototype.com$cognitect$transit$hashCode = function (t) {
        return com.cognitect.transit.eq.hashCode(this.map);
      }, com.cognitect.transit.types.set = function (t) {
        t = t || [];

        for (var e = {}, r = [], n = 0, o = 0; o < t.length; o++) {
          var i = com.cognitect.transit.eq.hashCode(t[o]),
              c = e[i];
          if (null == c) r.push(i), e[i] = [t[o], t[o]], n++;else {
            for (var i = !0, a = 0; a < c.length; a += 2) {
              if (com.cognitect.transit.eq.equals(c[a], t[o])) {
                i = !1;
                break;
              }
            }

            i && (c.push(t[o]), c.push(t[o]), n++);
          }
        }

        return new com.cognitect.transit.types.TransitSet(new com.cognitect.transit.types.TransitMap(r, e, n));
      }, com.cognitect.transit.types.isSet = function (t) {
        return t instanceof com.cognitect.transit.types.TransitSet;
      }, com.cognitect.transit.types.quoted = function (t) {
        return com.cognitect.transit.types.taggedValue("'", t);
      }, com.cognitect.transit.types.isQuoted = function (t) {
        return t instanceof com.cognitect.transit.types.TaggedValue && "'" === t.tag;
      }, com.cognitect.transit.types.list = function (t) {
        return com.cognitect.transit.types.taggedValue("list", t);
      }, com.cognitect.transit.types.isList = function (t) {
        return t instanceof com.cognitect.transit.types.TaggedValue && "list" === t.tag;
      }, com.cognitect.transit.types.link = function (t) {
        return com.cognitect.transit.types.taggedValue("link", t);
      }, com.cognitect.transit.types.isLink = function (t) {
        return t instanceof com.cognitect.transit.types.TaggedValue && "link" === t.tag;
      }, com.cognitect.transit.types.specialDouble = function (t) {
        switch (t) {
          case "-INF":
            return -1 / 0;

          case "INF":
            return 1 / 0;

          case "NaN":
            return NaN;

          default:
            throw Error("Invalid special double value " + t);
        }
      }, com.cognitect.transit.handlers = {}, com.cognitect.transit.handlers.ctorGuid = 0, com.cognitect.transit.handlers.ctorGuidProperty = "transit$guid$" + com.cognitect.transit.util.randomUUID(), com.cognitect.transit.handlers.typeTag = function (t) {
        if (null == t) return "null";
        if (t === String) return "string";
        if (t === Boolean) return "boolean";
        if (t === Number) return "number";
        if (t === Array) return "array";
        if (t === Object) return "map";
        var e = t[com.cognitect.transit.handlers.ctorGuidProperty];
        return null == e && (void 0 !== Object.defineProperty ? (e = ++com.cognitect.transit.handlers.ctorGuid, Object.defineProperty(t, com.cognitect.transit.handlers.ctorGuidProperty, {
          value: e,
          enumerable: !1
        })) : t[com.cognitect.transit.handlers.ctorGuidProperty] = e = ++com.cognitect.transit.handlers.ctorGuid), e;
      }, com.cognitect.transit.handlers.constructor = function (t) {
        return null == t ? null : t.constructor;
      }, com.cognitect.transit.handlers.padZeros = function (t, e) {
        for (var r = t.toString(), n = r.length; n < e; n++) {
          r = "0" + r;
        }

        return r;
      }, com.cognitect.transit.handlers.stringableKeys = function (t) {
        t = com.cognitect.transit.util.objectKeys(t);

        for (var e = 0; e < t.length; e++) {
          ;
        }

        return !0;
      }, com.cognitect.transit.handlers.NilHandler = function () {}, com.cognitect.transit.handlers.NilHandler.prototype.tag = function (t) {
        return "_";
      }, com.cognitect.transit.handlers.NilHandler.prototype.rep = function (t) {
        return null;
      }, com.cognitect.transit.handlers.NilHandler.prototype.stringRep = function (t) {
        return "null";
      }, com.cognitect.transit.handlers.StringHandler = function () {}, com.cognitect.transit.handlers.StringHandler.prototype.tag = function (t) {
        return "s";
      }, com.cognitect.transit.handlers.StringHandler.prototype.rep = function (t) {
        return t;
      }, com.cognitect.transit.handlers.StringHandler.prototype.stringRep = function (t) {
        return t;
      }, com.cognitect.transit.handlers.NumberHandler = function () {}, com.cognitect.transit.handlers.NumberHandler.prototype.tag = function (t) {
        return "i";
      }, com.cognitect.transit.handlers.NumberHandler.prototype.rep = function (t) {
        return t;
      }, com.cognitect.transit.handlers.NumberHandler.prototype.stringRep = function (t) {
        return t.toString();
      }, com.cognitect.transit.handlers.IntegerHandler = function () {}, com.cognitect.transit.handlers.IntegerHandler.prototype.tag = function (t) {
        return "i";
      }, com.cognitect.transit.handlers.IntegerHandler.prototype.rep = function (t) {
        return t.toString();
      }, com.cognitect.transit.handlers.IntegerHandler.prototype.stringRep = function (t) {
        return t.toString();
      }, com.cognitect.transit.handlers.BooleanHandler = function () {}, com.cognitect.transit.handlers.BooleanHandler.prototype.tag = function (t) {
        return "?";
      }, com.cognitect.transit.handlers.BooleanHandler.prototype.rep = function (t) {
        return t;
      }, com.cognitect.transit.handlers.BooleanHandler.prototype.stringRep = function (t) {
        return t.toString();
      }, com.cognitect.transit.handlers.ArrayHandler = function () {}, com.cognitect.transit.handlers.ArrayHandler.prototype.tag = function (t) {
        return "array";
      }, com.cognitect.transit.handlers.ArrayHandler.prototype.rep = function (t) {
        return t;
      }, com.cognitect.transit.handlers.ArrayHandler.prototype.stringRep = function (t) {
        return null;
      }, com.cognitect.transit.handlers.MapHandler = function () {}, com.cognitect.transit.handlers.MapHandler.prototype.tag = function (t) {
        return "map";
      }, com.cognitect.transit.handlers.MapHandler.prototype.rep = function (t) {
        return t;
      }, com.cognitect.transit.handlers.MapHandler.prototype.stringRep = function (t) {
        return null;
      }, com.cognitect.transit.handlers.VerboseDateHandler = function () {}, com.cognitect.transit.handlers.VerboseDateHandler.prototype.tag = function (t) {
        return "t";
      }, com.cognitect.transit.handlers.VerboseDateHandler.prototype.rep = function (t) {
        return t.getUTCFullYear() + "-" + com.cognitect.transit.handlers.padZeros(t.getUTCMonth() + 1, 2) + "-" + com.cognitect.transit.handlers.padZeros(t.getUTCDate(), 2) + "T" + com.cognitect.transit.handlers.padZeros(t.getUTCHours(), 2) + ":" + com.cognitect.transit.handlers.padZeros(t.getUTCMinutes(), 2) + ":" + com.cognitect.transit.handlers.padZeros(t.getUTCSeconds(), 2) + "." + com.cognitect.transit.handlers.padZeros(t.getUTCMilliseconds(), 3) + "Z";
      }, com.cognitect.transit.handlers.VerboseDateHandler.prototype.stringRep = function (t, e) {
        return e.rep(t);
      }, com.cognitect.transit.handlers.DateHandler = function () {}, com.cognitect.transit.handlers.DateHandler.prototype.tag = function (t) {
        return "m";
      }, com.cognitect.transit.handlers.DateHandler.prototype.rep = function (t) {
        return t.valueOf();
      }, com.cognitect.transit.handlers.DateHandler.prototype.stringRep = function (t) {
        return t.valueOf().toString();
      }, com.cognitect.transit.handlers.DateHandler.prototype.getVerboseHandler = function (t) {
        return new com.cognitect.transit.handlers.VerboseDateHandler();
      }, com.cognitect.transit.handlers.UUIDHandler = function () {}, com.cognitect.transit.handlers.UUIDHandler.prototype.tag = function (t) {
        return "u";
      }, com.cognitect.transit.handlers.UUIDHandler.prototype.rep = function (t) {
        return t.toString();
      }, com.cognitect.transit.handlers.UUIDHandler.prototype.stringRep = function (t) {
        return t.toString();
      }, com.cognitect.transit.handlers.KeywordHandler = function () {}, com.cognitect.transit.handlers.KeywordHandler.prototype.tag = function (t) {
        return ":";
      }, com.cognitect.transit.handlers.KeywordHandler.prototype.rep = function (t) {
        return t._name;
      }, com.cognitect.transit.handlers.KeywordHandler.prototype.stringRep = function (t, e) {
        return e.rep(t);
      }, com.cognitect.transit.handlers.SymbolHandler = function () {}, com.cognitect.transit.handlers.SymbolHandler.prototype.tag = function (t) {
        return "$";
      }, com.cognitect.transit.handlers.SymbolHandler.prototype.rep = function (t) {
        return t._name;
      }, com.cognitect.transit.handlers.SymbolHandler.prototype.stringRep = function (t, e) {
        return e.rep(t);
      }, com.cognitect.transit.handlers.TaggedHandler = function () {}, com.cognitect.transit.handlers.TaggedHandler.prototype.tag = function (t) {
        return t.tag;
      }, com.cognitect.transit.handlers.TaggedHandler.prototype.rep = function (t) {
        return t.rep;
      }, com.cognitect.transit.handlers.TaggedHandler.prototype.stringRep = function (t, e) {
        return null;
      }, com.cognitect.transit.handlers.TransitSetHandler = function () {}, com.cognitect.transit.handlers.TransitSetHandler.prototype.tag = function (t) {
        return "set";
      }, com.cognitect.transit.handlers.TransitSetHandler.prototype.rep = function (t) {
        var e = [];
        return t.forEach(function (t, r) {
          e.push(t);
        }), com.cognitect.transit.types.taggedValue("array", e);
      }, com.cognitect.transit.handlers.TransitSetHandler.prototype.stringRep = function (t, e) {
        return null;
      }, com.cognitect.transit.handlers.TransitArrayMapHandler = function () {}, com.cognitect.transit.handlers.TransitArrayMapHandler.prototype.tag = function (t) {
        return "map";
      }, com.cognitect.transit.handlers.TransitArrayMapHandler.prototype.rep = function (t) {
        return t;
      }, com.cognitect.transit.handlers.TransitArrayMapHandler.prototype.stringRep = function (t, e) {
        return null;
      }, com.cognitect.transit.handlers.TransitMapHandler = function () {}, com.cognitect.transit.handlers.TransitMapHandler.prototype.tag = function (t) {
        return "map";
      }, com.cognitect.transit.handlers.TransitMapHandler.prototype.rep = function (t) {
        return t;
      }, com.cognitect.transit.handlers.TransitMapHandler.prototype.stringRep = function (t, e) {
        return null;
      }, com.cognitect.transit.handlers.BufferHandler = function () {}, com.cognitect.transit.handlers.BufferHandler.prototype.tag = function (t) {
        return "b";
      }, com.cognitect.transit.handlers.BufferHandler.prototype.rep = function (t) {
        return t.toString("base64");
      }, com.cognitect.transit.handlers.BufferHandler.prototype.stringRep = function (t, e) {
        return null;
      }, com.cognitect.transit.handlers.Uint8ArrayHandler = function () {}, com.cognitect.transit.handlers.Uint8ArrayHandler.prototype.tag = function (t) {
        return "b";
      }, com.cognitect.transit.handlers.Uint8ArrayHandler.prototype.rep = function (t) {
        return com.cognitect.transit.util.Uint8ToBase64(t);
      }, com.cognitect.transit.handlers.Uint8ArrayHandler.prototype.stringRep = function (t, e) {
        return null;
      }, com.cognitect.transit.handlers.defaultHandlers = function (t) {
        return t.set(null, new com.cognitect.transit.handlers.NilHandler()), t.set(String, new com.cognitect.transit.handlers.StringHandler()), t.set(Number, new com.cognitect.transit.handlers.NumberHandler()), t.set(goog.math.Long, new com.cognitect.transit.handlers.IntegerHandler()), t.set(Boolean, new com.cognitect.transit.handlers.BooleanHandler()), t.set(Array, new com.cognitect.transit.handlers.ArrayHandler()), t.set(Object, new com.cognitect.transit.handlers.MapHandler()), t.set(Date, new com.cognitect.transit.handlers.DateHandler()), t.set(com.cognitect.transit.types.UUID, new com.cognitect.transit.handlers.UUIDHandler()), t.set(com.cognitect.transit.types.Keyword, new com.cognitect.transit.handlers.KeywordHandler()), t.set(com.cognitect.transit.types.Symbol, new com.cognitect.transit.handlers.SymbolHandler()), t.set(com.cognitect.transit.types.TaggedValue, new com.cognitect.transit.handlers.TaggedHandler()), t.set(com.cognitect.transit.types.TransitSet, new com.cognitect.transit.handlers.TransitSetHandler()), t.set(com.cognitect.transit.types.TransitArrayMap, new com.cognitect.transit.handlers.TransitArrayMapHandler()), t.set(com.cognitect.transit.types.TransitMap, new com.cognitect.transit.handlers.TransitMapHandler()), void 0 !== goog.global.Buffer && t.set(goog.global.Buffer, new com.cognitect.transit.handlers.BufferHandler()), "undefined" != typeof Uint8Array && t.set(Uint8Array, new com.cognitect.transit.handlers.Uint8ArrayHandler()), t;
      }, com.cognitect.transit.handlers.Handlers = function () {
        this.handlers = {}, com.cognitect.transit.handlers.defaultHandlers(this);
      }, com.cognitect.transit.handlers.Handlers.prototype.get = function (t) {
        return t = "string" == typeof t ? this.handlers[t] : this.handlers[com.cognitect.transit.handlers.typeTag(t)], null != t ? t : this.handlers.default;
      }, com.cognitect.transit.handlers.Handlers.prototype.get = com.cognitect.transit.handlers.Handlers.prototype.get, com.cognitect.transit.handlers.validTag = function (t) {
        switch (t) {
          case "null":
          case "string":
          case "boolean":
          case "number":
          case "array":
          case "map":
            return !1;
        }

        return !0;
      }, com.cognitect.transit.handlers.Handlers.prototype.set = function (t, e) {
        "string" == typeof t && com.cognitect.transit.handlers.validTag(t) ? this.handlers[t] = e : this.handlers[com.cognitect.transit.handlers.typeTag(t)] = e;
      }, com.cognitect.transit.impl = {}, com.cognitect.transit.impl.decoder = {}, com.cognitect.transit.impl.decoder.Tag = function (t) {
        this.str = t;
      }, com.cognitect.transit.impl.decoder.tag = function (t) {
        return new com.cognitect.transit.impl.decoder.Tag(t);
      }, com.cognitect.transit.impl.decoder.isTag = function (t) {
        return t && t instanceof com.cognitect.transit.impl.decoder.Tag;
      }, com.cognitect.transit.impl.decoder.isGroundHandler = function (t) {
        switch (t) {
          case "_":
          case "s":
          case "?":
          case "i":
          case "d":
          case "b":
          case "'":
          case "array":
          case "map":
            return !0;
        }

        return !1;
      }, com.cognitect.transit.impl.decoder.Decoder = function (t) {
        this.options = t || {}, this.handlers = {};

        for (var e in this.defaults.handlers) {
          this.handlers[e] = this.defaults.handlers[e];
        }

        for (e in this.options.handlers) {
          if (com.cognitect.transit.impl.decoder.isGroundHandler(e)) throw Error('Cannot override handler for ground type "' + e + '"');
          this.handlers[e] = this.options.handlers[e];
        }

        this.preferStrings = null != this.options.preferStrings ? this.options.preferStrings : this.defaults.preferStrings, this.preferBuffers = null != this.options.preferBuffers ? this.options.preferBuffers : this.defaults.preferBuffers, this.defaultHandler = this.options.defaultHandler || this.defaults.defaultHandler, this.mapBuilder = this.options.mapBuilder, this.arrayBuilder = this.options.arrayBuilder;
      }, com.cognitect.transit.impl.decoder.Decoder.prototype.defaults = {
        handlers: {
          _: function _(t, e) {
            return com.cognitect.transit.types.nullValue();
          },
          "?": function _(t, e) {
            return com.cognitect.transit.types.boolValue(t);
          },
          b: function b(t, e) {
            return com.cognitect.transit.types.binary(t, e);
          },
          i: function i(t, e) {
            return com.cognitect.transit.types.intValue(t);
          },
          n: function n(t, e) {
            return com.cognitect.transit.types.bigInteger(t);
          },
          d: function d(t, e) {
            return com.cognitect.transit.types.floatValue(t);
          },
          f: function f(t, e) {
            return com.cognitect.transit.types.bigDecimalValue(t);
          },
          c: function c(t, e) {
            return com.cognitect.transit.types.charValue(t);
          },
          ":": function _(t, e) {
            return com.cognitect.transit.types.keyword(t);
          },
          $: function $(t, e) {
            return com.cognitect.transit.types.symbol(t);
          },
          r: function r(t, e) {
            return com.cognitect.transit.types.uri(t);
          },
          z: function z(t, e) {
            return com.cognitect.transit.types.specialDouble(t);
          },
          "'": function _(t, e) {
            return t;
          },
          m: function m(t, e) {
            return com.cognitect.transit.types.date(t);
          },
          t: function t(_t2, e) {
            return com.cognitect.transit.types.verboseDate(_t2);
          },
          u: function u(t, e) {
            return com.cognitect.transit.types.uuid(t);
          },
          set: function set(t, e) {
            return com.cognitect.transit.types.set(t);
          },
          list: function list(t, e) {
            return com.cognitect.transit.types.list(t);
          },
          link: function link(t, e) {
            return com.cognitect.transit.types.link(t);
          },
          cmap: function cmap(t, e) {
            return com.cognitect.transit.types.map(t, !1);
          }
        },
        defaultHandler: function defaultHandler(t, e) {
          return com.cognitect.transit.types.taggedValue(t, e);
        },
        preferStrings: !0,
        preferBuffers: !0
      }, com.cognitect.transit.impl.decoder.Decoder.prototype.decode = function (t, e, r, n) {
        if (null == t) return null;

        switch (typeof t) {
          case "string":
            return this.decodeString(t, e, r, n);

          case "object":
            return com.cognitect.transit.util.isArray(t) ? "^ " === t[0] ? this.decodeArrayHash(t, e, r, n) : this.decodeArray(t, e, r, n) : this.decodeHash(t, e, r, n);
        }

        return t;
      }, com.cognitect.transit.impl.decoder.Decoder.prototype.decode = com.cognitect.transit.impl.decoder.Decoder.prototype.decode, com.cognitect.transit.impl.decoder.Decoder.prototype.decodeString = function (t, e, r, n) {
        return com.cognitect.transit.caching.isCacheable(t, r) ? (t = this.parseString(t, e, !1), e && e.write(t, r), t) : com.cognitect.transit.caching.isCacheCode(t) ? e.read(t, r) : this.parseString(t, e, r);
      }, com.cognitect.transit.impl.decoder.Decoder.prototype.decodeHash = function (t, e, r, n) {
        r = com.cognitect.transit.util.objectKeys(t);
        var o = r[0];
        if (n = 1 == r.length ? this.decode(o, e, !1, !1) : null, com.cognitect.transit.impl.decoder.isTag(n)) return t = t[o], r = this.handlers[n.str], null != r ? r(this.decode(t, e, !1, !0), this) : com.cognitect.transit.types.taggedValue(n.str, this.decode(t, e, !1, !1));

        if (this.mapBuilder) {
          if (r.length < 2 * com.cognitect.transit.types.SMALL_ARRAY_MAP_THRESHOLD && this.mapBuilder.fromArray) {
            var i = [];

            for (o = 0; o < r.length; o++) {
              n = r[o], i.push(this.decode(n, e, !0, !1)), i.push(this.decode(t[n], e, !1, !1));
            }

            return this.mapBuilder.fromArray(i, t);
          }

          for (i = this.mapBuilder.init(t), o = 0; o < r.length; o++) {
            n = r[o], i = this.mapBuilder.add(i, this.decode(n, e, !0, !1), this.decode(t[n], e, !1, !1), t);
          }

          return this.mapBuilder.finalize(i, t);
        }

        for (i = [], o = 0; o < r.length; o++) {
          n = r[o], i.push(this.decode(n, e, !0, !1)), i.push(this.decode(t[n], e, !1, !1));
        }

        return com.cognitect.transit.types.map(i, !1);
      }, com.cognitect.transit.impl.decoder.Decoder.prototype.decodeArrayHash = function (t, e, r, n) {
        if (this.mapBuilder) {
          if (t.length < 2 * com.cognitect.transit.types.SMALL_ARRAY_MAP_THRESHOLD + 1 && this.mapBuilder.fromArray) {
            for (n = [], r = 1; r < t.length; r += 2) {
              n.push(this.decode(t[r], e, !0, !1)), n.push(this.decode(t[r + 1], e, !1, !1));
            }

            return this.mapBuilder.fromArray(n, t);
          }

          for (n = this.mapBuilder.init(t), r = 1; r < t.length; r += 2) {
            n = this.mapBuilder.add(n, this.decode(t[r], e, !0, !1), this.decode(t[r + 1], e, !1, !1), t);
          }

          return this.mapBuilder.finalize(n, t);
        }

        for (n = [], r = 1; r < t.length; r += 2) {
          n.push(this.decode(t[r], e, !0, !1)), n.push(this.decode(t[r + 1], e, !1, !1));
        }

        return com.cognitect.transit.types.map(n, !1);
      }, com.cognitect.transit.impl.decoder.Decoder.prototype.decodeArray = function (t, e, r, n) {
        if (n) {
          var o = [];

          for (n = 0; n < t.length; n++) {
            o.push(this.decode(t[n], e, r, !1));
          }

          return o;
        }

        if (o = e && e.idx, 2 === t.length && "string" == typeof t[0] && (n = this.decode(t[0], e, !1, !1), com.cognitect.transit.impl.decoder.isTag(n))) return o = t[1], t = this.handlers[n.str], null != t ? o = t(this.decode(o, e, r, !0), this) : com.cognitect.transit.types.taggedValue(n.str, this.decode(o, e, r, !1));

        if (e && o != e.idx && (e.idx = o), this.arrayBuilder) {
          if (32 >= t.length && this.arrayBuilder.fromArray) {
            for (o = [], n = 0; n < t.length; n++) {
              o.push(this.decode(t[n], e, r, !1));
            }

            return this.arrayBuilder.fromArray(o, t);
          }

          for (o = this.arrayBuilder.init(t), n = 0; n < t.length; n++) {
            o = this.arrayBuilder.add(o, this.decode(t[n], e, r, !1), t);
          }

          return this.arrayBuilder.finalize(o, t);
        }

        for (o = [], n = 0; n < t.length; n++) {
          o.push(this.decode(t[n], e, r, !1));
        }

        return o;
      }, com.cognitect.transit.impl.decoder.Decoder.prototype.parseString = function (t, e, r) {
        return t.charAt(0) === com.cognitect.transit.delimiters.ESC ? (e = t.charAt(1)) === com.cognitect.transit.delimiters.ESC || e === com.cognitect.transit.delimiters.SUB || e === com.cognitect.transit.delimiters.RES ? t.substring(1) : e === com.cognitect.transit.delimiters.TAG ? com.cognitect.transit.impl.decoder.tag(t.substring(2)) : (r = this.handlers[e], null == r ? this.defaultHandler(e, t.substring(2)) : r(t.substring(2), this)) : t;
      }, com.cognitect.transit.impl.decoder.decoder = function (t) {
        return new com.cognitect.transit.impl.decoder.Decoder(t);
      }, com.cognitect.transit.impl.reader = {}, com.cognitect.transit.impl.reader.JSONUnmarshaller = function (t) {
        this.decoder = new com.cognitect.transit.impl.decoder.Decoder(t);
      }, com.cognitect.transit.impl.reader.JSONUnmarshaller.prototype.unmarshal = function (t, e) {
        return this.decoder.decode(JSON.parse(t), e);
      }, com.cognitect.transit.impl.reader.Reader = function (t, e) {
        this.unmarshaller = t, this.options = e || {}, this.cache = this.options.cache ? this.options.cache : new com.cognitect.transit.caching.ReadCache();
      }, com.cognitect.transit.impl.reader.Reader.prototype.read = function (t) {
        return t = this.unmarshaller.unmarshal(t, this.cache), this.cache.clear(), t;
      }, com.cognitect.transit.impl.reader.Reader.prototype.read = com.cognitect.transit.impl.reader.Reader.prototype.read, com.cognitect.transit.impl.writer = {}, com.cognitect.transit.impl.writer.escape = function (t) {
        if (0 < t.length) {
          var e = t.charAt(0);
          return e === com.cognitect.transit.delimiters.ESC || e === com.cognitect.transit.delimiters.SUB || e === com.cognitect.transit.delimiters.RES ? com.cognitect.transit.delimiters.ESC + t : t;
        }

        return t;
      }, com.cognitect.transit.impl.writer.JSONMarshaller = function (t) {
        if (this.opts = t || {}, this.preferStrings = null == this.opts.preferStrings || this.opts.preferStrings, this.objectBuilder = this.opts.objectBuilder || null, this.transform = this.opts.transform || null, this.handlers = new com.cognitect.transit.handlers.Handlers(), t = this.opts.handlers) {
          if (com.cognitect.transit.util.isArray(t) || !t.forEach) throw Error('transit writer "handlers" option must be a map');
          var e = this;
          t.forEach(function (t, r) {
            if (void 0 === r) throw Error("Cannot create handler for JavaScript undefined");
            e.handlers.set(r, t);
          });
        }

        this.handlerForForeign = this.opts.handlerForForeign, this.unpack = this.opts.unpack || function (t) {
          return !(!com.cognitect.transit.types.isArrayMap(t) || null !== t.backingMap) && t._entries;
        }, this.verbose = this.opts && this.opts.verbose || !1;
      }, com.cognitect.transit.impl.writer.JSONMarshaller.prototype.handler = function (t) {
        var e = this.handlers.get(com.cognitect.transit.handlers.constructor(t));
        return null != e ? e : (t = t && t.transitTag) ? this.handlers.get(t) : null;
      }, com.cognitect.transit.impl.writer.JSONMarshaller.prototype.registerHandler = function (t, e) {
        this.handlers.set(t, e);
      }, com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitNil = function (t, e) {
        return t ? this.emitString(com.cognitect.transit.delimiters.ESC, "_", "", t, e) : null;
      }, com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitString = function (t, e, r, n, o) {
        return t = t + e + r, o ? o.write(t, n) : t;
      }, com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitBoolean = function (t, e, r) {
        return e ? this.emitString(com.cognitect.transit.delimiters.ESC, "?", t.toString()[0], e, r) : t;
      }, com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitInteger = function (t, e, r) {
        return 1 / 0 === t ? this.emitString(com.cognitect.transit.delimiters.ESC, "z", "INF", e, r) : -1 / 0 === t ? this.emitString(com.cognitect.transit.delimiters.ESC, "z", "-INF", e, r) : isNaN(t) ? this.emitString(com.cognitect.transit.delimiters.ESC, "z", "NaN", e, r) : e || "string" == typeof t || t instanceof goog.math.Long ? this.emitString(com.cognitect.transit.delimiters.ESC, "i", t.toString(), e, r) : t;
      }, com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitDouble = function (t, e, r) {
        return e ? this.emitString(t.ESC, "d", t, e, r) : t;
      }, com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitBinary = function (t, e, r) {
        return this.emitString(com.cognitect.transit.delimiters.ESC, "b", t, e, r);
      }, com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitQuoted = function (t, e, r) {
        if (t.verbose) {
          t = {};
          return t[this.emitString(com.cognitect.transit.delimiters.ESC_TAG, "'", "", !0, r)] = com.cognitect.transit.impl.writer.marshal(this, e, !1, r), t;
        }

        return [this.emitString(com.cognitect.transit.delimiters.ESC_TAG, "'", "", !0, r), com.cognitect.transit.impl.writer.marshal(this, e, !1, r)];
      }, com.cognitect.transit.impl.writer.emitObjects = function (t, e, r) {
        var n = [];
        if (com.cognitect.transit.util.isArray(e)) for (var o = 0; o < e.length; o++) {
          n.push(com.cognitect.transit.impl.writer.marshal(t, e[o], !1, r));
        } else e.forEach(function (e, o) {
          n.push(com.cognitect.transit.impl.writer.marshal(t, e, !1, r));
        });
        return n;
      }, com.cognitect.transit.impl.writer.emitArray = function (t, e, r, n) {
        return com.cognitect.transit.impl.writer.emitObjects(t, e, n);
      }, com.cognitect.transit.impl.writer.isStringableKey = function (t, e) {
        if ("string" != typeof e) {
          var r = t.handler(e);
          return r && 1 === r.tag(e).length;
        }

        return !0;
      }, com.cognitect.transit.impl.writer.stringableKeys = function (t, e) {
        var r = t.unpack(e),
            n = !0;

        if (r) {
          for (var o = 0; o < r.length && (n = com.cognitect.transit.impl.writer.isStringableKey(t, r[o])); o += 2) {
            ;
          }

          return n;
        }

        if (e.keys && (r = e.keys(), o = null, r.next)) {
          for (o = r.next(); !o.done && (n = com.cognitect.transit.impl.writer.isStringableKey(t, o.value));) {
            o = r.next();
          }

          return n;
        }

        if (e.forEach) return e.forEach(function (e, r) {
          n = n && com.cognitect.transit.impl.writer.isStringableKey(t, r);
        }), n;
        throw Error("Cannot walk keys of object type " + com.cognitect.transit.handlers.constructor(e).name);
      }, com.cognitect.transit.impl.writer.isForeignObject = function (t) {
        if (t.constructor.transit$isObject) return !0;
        var e = t.constructor.toString(),
            e = e.substr(9),
            e = e.substr(0, e.indexOf("(")),
            e = "Object" == e;
        return void 0 !== Object.defineProperty ? Object.defineProperty(t.constructor, "transit$isObject", {
          value: e,
          enumerable: !1
        }) : t.constructor.transit$isObject = e, e;
      }, com.cognitect.transit.impl.writer.emitMap = function (t, e, r, n) {
        var o = null,
            i = null,
            c = null,
            o = null;

        if (r = 0, e.constructor === Object || null != e.forEach || t.handlerForForeign && com.cognitect.transit.impl.writer.isForeignObject(e)) {
          if (t.verbose) {
            if (null != e.forEach) {
              if (com.cognitect.transit.impl.writer.stringableKeys(t, e)) {
                var a = {};
                e.forEach(function (e, r) {
                  a[com.cognitect.transit.impl.writer.marshal(t, r, !0, !1)] = com.cognitect.transit.impl.writer.marshal(t, e, !1, n);
                });
              } else {
                if (o = t.unpack(e), i = [], c = t.emitString(com.cognitect.transit.delimiters.ESC_TAG, "cmap", "", !0, n), o) for (; r < o.length; r += 2) {
                  i.push(com.cognitect.transit.impl.writer.marshal(t, o[r], !1, !1)), i.push(com.cognitect.transit.impl.writer.marshal(t, o[r + 1], !1, n));
                } else e.forEach(function (e, r) {
                  i.push(com.cognitect.transit.impl.writer.marshal(t, r, !1, !1)), i.push(com.cognitect.transit.impl.writer.marshal(t, e, !1, n));
                });
                a = {}, a[c] = i;
              }
            } else for (o = com.cognitect.transit.util.objectKeys(e), a = {}; r < o.length; r++) {
              a[com.cognitect.transit.impl.writer.marshal(t, o[r], !0, !1)] = com.cognitect.transit.impl.writer.marshal(t, e[o[r]], !1, n);
            }
            return a;
          }

          if (null != e.forEach) {
            if (com.cognitect.transit.impl.writer.stringableKeys(t, e)) {
              if (o = t.unpack(e), a = ["^ "], o) for (; r < o.length; r += 2) {
                a.push(com.cognitect.transit.impl.writer.marshal(t, o[r], !0, n)), a.push(com.cognitect.transit.impl.writer.marshal(t, o[r + 1], !1, n));
              } else e.forEach(function (e, r) {
                a.push(com.cognitect.transit.impl.writer.marshal(t, r, !0, n)), a.push(com.cognitect.transit.impl.writer.marshal(t, e, !1, n));
              });
              return a;
            }

            if (o = t.unpack(e), i = [], c = t.emitString(com.cognitect.transit.delimiters.ESC_TAG, "cmap", "", !0, n), o) for (; r < o.length; r += 2) {
              i.push(com.cognitect.transit.impl.writer.marshal(t, o[r], !1, n)), i.push(com.cognitect.transit.impl.writer.marshal(t, o[r + 1], !1, n));
            } else e.forEach(function (e, r) {
              i.push(com.cognitect.transit.impl.writer.marshal(t, r, !1, n)), i.push(com.cognitect.transit.impl.writer.marshal(t, e, !1, n));
            });
            return [c, i];
          }

          for (a = ["^ "], o = com.cognitect.transit.util.objectKeys(e); r < o.length; r++) {
            a.push(com.cognitect.transit.impl.writer.marshal(t, o[r], !0, n)), a.push(com.cognitect.transit.impl.writer.marshal(t, e[o[r]], !1, n));
          }

          return a;
        }

        if (null != t.objectBuilder) return t.objectBuilder(e, function (e) {
          return com.cognitect.transit.impl.writer.marshal(t, e, !0, n);
        }, function (e) {
          return com.cognitect.transit.impl.writer.marshal(t, e, !1, n);
        });
        throw r = com.cognitect.transit.handlers.constructor(e).name, o = Error("Cannot write " + r), o.data = {
          obj: e,
          type: r
        }, o;
      }, com.cognitect.transit.impl.writer.emitTaggedMap = function (t, e, r, n, o) {
        return t.verbose ? (n = {}, n[t.emitString(com.cognitect.transit.delimiters.ESC_TAG, e, "", !0, o)] = com.cognitect.transit.impl.writer.marshal(t, r, !1, o), n) : [t.emitString(com.cognitect.transit.delimiters.ESC_TAG, e, "", !0, o), com.cognitect.transit.impl.writer.marshal(t, r, !1, o)];
      }, com.cognitect.transit.impl.writer.emitEncoded = function (t, e, r, n, o, i, c) {
        if (1 === r.length) {
          if ("string" == typeof n) return t.emitString(com.cognitect.transit.delimiters.ESC, r, n, i, c);

          if (i || t.preferStrings) {
            if ((n = t.verbose && e.getVerboseHandler()) ? (r = n.tag(o), n = n.stringRep(o, n)) : n = e.stringRep(o, e), null !== n) return t.emitString(com.cognitect.transit.delimiters.ESC, r, n, i, c);
            throw t = Error('Tag "' + r + '" cannot be encoded as string'), t.data = {
              tag: r,
              rep: n,
              obj: o
            }, t;
          }
        }

        return com.cognitect.transit.impl.writer.emitTaggedMap(t, r, n, i, c);
      }, com.cognitect.transit.impl.writer.marshal = function (t, e, r, n) {
        null !== t.transform && (e = t.transform(e));
        var o = t.handler(e) || (t.handlerForForeign ? t.handlerForForeign(e, t.handlers) : null),
            i = o ? o.tag(e) : null,
            c = o ? o.rep(e) : null;
        if (null == o || null == i) throw t = com.cognitect.transit.handlers.constructor(e).name, r = Error("Cannot write " + t), r.data = {
          obj: e,
          type: t
        }, r;

        switch (i) {
          case "_":
            return t.emitNil(r, n);

          case "s":
            return t.emitString("", "", com.cognitect.transit.impl.writer.escape(c), r, n);

          case "?":
            return t.emitBoolean(c, r, n);

          case "i":
            return t.emitInteger(c, r, n);

          case "d":
            return t.emitDouble(c, r, n);

          case "b":
            return t.emitBinary(c, r, n);

          case "'":
            return t.emitQuoted(t, c, n);

          case "array":
            return com.cognitect.transit.impl.writer.emitArray(t, c, r, n);

          case "map":
            return com.cognitect.transit.impl.writer.emitMap(t, c, r, n);

          default:
            return com.cognitect.transit.impl.writer.emitEncoded(t, o, i, c, e, r, n);
        }
      }, com.cognitect.transit.impl.writer.maybeQuoted = function (t, e) {
        var r = t.handler(e) || (t.handlerForForeign ? t.handlerForForeign(e, t.handlers) : null);
        if (null != r) return 1 === r.tag(e).length ? com.cognitect.transit.types.quoted(e) : e;
        var r = com.cognitect.transit.handlers.constructor(e).name,
            n = Error("Cannot write " + r);
        throw n.data = {
          obj: e,
          type: r
        }, n;
      }, com.cognitect.transit.impl.writer.marshalTop = function (t, e, r, n) {
        return JSON.stringify(com.cognitect.transit.impl.writer.marshal(t, com.cognitect.transit.impl.writer.maybeQuoted(t, e), r, n));
      }, com.cognitect.transit.impl.writer.Writer = function (t, e) {
        this._marshaller = t, this.options = e || {}, this.cache = !1 === this.options.cache ? null : this.options.cache ? this.options.cache : new com.cognitect.transit.caching.WriteCache();
      }, com.cognitect.transit.impl.writer.Writer.prototype.marshaller = function () {
        return this._marshaller;
      }, com.cognitect.transit.impl.writer.Writer.prototype.marshaller = com.cognitect.transit.impl.writer.Writer.prototype.marshaller, com.cognitect.transit.impl.writer.Writer.prototype.write = function (t, e) {
        var r = e || {},
            n = r.asMapKey || !1,
            o = !this._marshaller.verbose && this.cache;
        return r = !1 === r.marshalTop ? com.cognitect.transit.impl.writer.marshal(this._marshaller, t, n, o) : com.cognitect.transit.impl.writer.marshalTop(this._marshaller, t, n, o), null != this.cache && this.cache.clear(), r;
      }, com.cognitect.transit.impl.writer.Writer.prototype.write = com.cognitect.transit.impl.writer.Writer.prototype.write, com.cognitect.transit.impl.writer.Writer.prototype.register = function (t, e) {
        this._marshaller.registerHandler(t, e);
      }, com.cognitect.transit.impl.writer.Writer.prototype.register = com.cognitect.transit.impl.writer.Writer.prototype.register;
      var TRANSIT_DEV = !0,
          TRANSIT_NODE_TARGET = !0,
          TRANSIT_BROWSER_TARGET = !1,
          TRANSIT_BROWSER_AMD_TARGET = !1;
      com.cognitect.transit.reader = function (t, e) {
        if ("json" === t || "json-verbose" === t || null == t) {
          var r = new com.cognitect.transit.impl.reader.JSONUnmarshaller(e);
          return new com.cognitect.transit.impl.reader.Reader(r, e);
        }

        throw Error("Cannot create reader of type " + t);
      }, com.cognitect.transit.writer = function (t, e) {
        if ("json" === t || "json-verbose" === t || null == t) {
          "json-verbose" === t && (null == e && (e = {}), e.verbose = !0);
          var r = new com.cognitect.transit.impl.writer.JSONMarshaller(e);
          return new com.cognitect.transit.impl.writer.Writer(r, e);
        }

        throw r = Error('Type must be "json"'), r.data = {
          type: t
        }, r;
      }, com.cognitect.transit.makeWriteHandler = function (t) {
        var e = function e() {};

        return e.prototype.tag = t.tag, e.prototype.rep = t.rep, e.prototype.stringRep = t.stringRep, e.prototype.getVerboseHandler = t.getVerboseHandler, new e();
      }, com.cognitect.transit.makeBuilder = function (t) {
        var e = function e() {};

        return e.prototype.init = t.init, e.prototype.add = t.add, e.prototype.finalize = t.finalize, e.prototype.fromArray = t.fromArray, new e();
      }, com.cognitect.transit.date = com.cognitect.transit.types.date, com.cognitect.transit.integer = com.cognitect.transit.types.intValue, com.cognitect.transit.isInteger = com.cognitect.transit.types.isInteger, com.cognitect.transit.uuid = com.cognitect.transit.types.uuid, com.cognitect.transit.isUUID = com.cognitect.transit.types.isUUID, com.cognitect.transit.bigInt = com.cognitect.transit.types.bigInteger, com.cognitect.transit.isBigInt = com.cognitect.transit.types.isBigInteger, com.cognitect.transit.bigDec = com.cognitect.transit.types.bigDecimalValue, com.cognitect.transit.isBigDec = com.cognitect.transit.types.isBigDecimal, com.cognitect.transit.keyword = com.cognitect.transit.types.keyword, com.cognitect.transit.isKeyword = com.cognitect.transit.types.isKeyword, com.cognitect.transit.symbol = com.cognitect.transit.types.symbol, com.cognitect.transit.isSymbol = com.cognitect.transit.types.isSymbol, com.cognitect.transit.binary = com.cognitect.transit.types.binary, com.cognitect.transit.isBinary = com.cognitect.transit.types.isBinary, com.cognitect.transit.uri = com.cognitect.transit.types.uri, com.cognitect.transit.isURI = com.cognitect.transit.types.isURI, com.cognitect.transit.map = com.cognitect.transit.types.map, com.cognitect.transit.isMap = com.cognitect.transit.types.isMap, com.cognitect.transit.set = com.cognitect.transit.types.set, com.cognitect.transit.isSet = com.cognitect.transit.types.isSet, com.cognitect.transit.list = com.cognitect.transit.types.list, com.cognitect.transit.isList = com.cognitect.transit.types.isList, com.cognitect.transit.quoted = com.cognitect.transit.types.quoted, com.cognitect.transit.isQuoted = com.cognitect.transit.types.isQuoted, com.cognitect.transit.tagged = com.cognitect.transit.types.taggedValue, com.cognitect.transit.isTaggedValue = com.cognitect.transit.types.isTaggedValue, com.cognitect.transit.link = com.cognitect.transit.types.link, com.cognitect.transit.isLink = com.cognitect.transit.types.isLink, com.cognitect.transit.hash = com.cognitect.transit.eq.hashCode, com.cognitect.transit.hashMapLike = com.cognitect.transit.eq.hashMapLike, com.cognitect.transit.hashArrayLike = com.cognitect.transit.eq.hashArrayLike, com.cognitect.transit.equals = com.cognitect.transit.eq.equals, com.cognitect.transit.extendToEQ = com.cognitect.transit.eq.extendToEQ, com.cognitect.transit.mapToObject = function (t) {
        var e = {};
        return t.forEach(function (t, r) {
          if ("string" != typeof r) throw Error("Cannot convert map with non-string keys");
          e[r] = t;
        }), e;
      }, com.cognitect.transit.objectToMap = function (t) {
        var e,
            r = com.cognitect.transit.map();

        for (e in t) {
          t.hasOwnProperty(e) && r.set(e, t[e]);
        }

        return r;
      }, com.cognitect.transit.decoder = com.cognitect.transit.impl.decoder.decoder, com.cognitect.transit.readCache = com.cognitect.transit.caching.readCache, com.cognitect.transit.writeCache = com.cognitect.transit.caching.writeCache, com.cognitect.transit.UUIDfromString = com.cognitect.transit.types.UUIDfromString, com.cognitect.transit.randomUUID = com.cognitect.transit.util.randomUUID, com.cognitect.transit.stringableKeys = com.cognitect.transit.impl.writer.stringableKeys, TRANSIT_BROWSER_TARGET && (goog.exportSymbol("transit.reader", com.cognitect.transit.reader), goog.exportSymbol("transit.writer", com.cognitect.transit.writer), goog.exportSymbol("transit.makeBuilder", com.cognitect.transit.makeBuilder), goog.exportSymbol("transit.makeWriteHandler", com.cognitect.transit.makeWriteHandler), goog.exportSymbol("transit.date", com.cognitect.transit.types.date), goog.exportSymbol("transit.integer", com.cognitect.transit.types.intValue), goog.exportSymbol("transit.isInteger", com.cognitect.transit.types.isInteger), goog.exportSymbol("transit.uuid", com.cognitect.transit.types.uuid), goog.exportSymbol("transit.isUUID", com.cognitect.transit.types.isUUID), goog.exportSymbol("transit.bigInt", com.cognitect.transit.types.bigInteger), goog.exportSymbol("transit.isBigInt", com.cognitect.transit.types.isBigInteger), goog.exportSymbol("transit.bigDec", com.cognitect.transit.types.bigDecimalValue), goog.exportSymbol("transit.isBigDec", com.cognitect.transit.types.isBigDecimal), goog.exportSymbol("transit.keyword", com.cognitect.transit.types.keyword), goog.exportSymbol("transit.isKeyword", com.cognitect.transit.types.isKeyword), goog.exportSymbol("transit.symbol", com.cognitect.transit.types.symbol), goog.exportSymbol("transit.isSymbol", com.cognitect.transit.types.isSymbol), goog.exportSymbol("transit.binary", com.cognitect.transit.types.binary), goog.exportSymbol("transit.isBinary", com.cognitect.transit.types.isBinary), goog.exportSymbol("transit.uri", com.cognitect.transit.types.uri), goog.exportSymbol("transit.isURI", com.cognitect.transit.types.isURI), goog.exportSymbol("transit.map", com.cognitect.transit.types.map), goog.exportSymbol("transit.isMap", com.cognitect.transit.types.isMap), goog.exportSymbol("transit.set", com.cognitect.transit.types.set), goog.exportSymbol("transit.isSet", com.cognitect.transit.types.isSet), goog.exportSymbol("transit.list", com.cognitect.transit.types.list), goog.exportSymbol("transit.isList", com.cognitect.transit.types.isList), goog.exportSymbol("transit.quoted", com.cognitect.transit.types.quoted), goog.exportSymbol("transit.isQuoted", com.cognitect.transit.types.isQuoted), goog.exportSymbol("transit.tagged", com.cognitect.transit.types.taggedValue), goog.exportSymbol("transit.isTaggedValue", com.cognitect.transit.types.isTaggedValue), goog.exportSymbol("transit.link", com.cognitect.transit.types.link), goog.exportSymbol("transit.isLink", com.cognitect.transit.types.isLink), goog.exportSymbol("transit.hash", com.cognitect.transit.eq.hashCode), goog.exportSymbol("transit.hashMapLike", com.cognitect.transit.eq.hashMapLike), goog.exportSymbol("transit.hashArrayLike", com.cognitect.transit.eq.hashArrayLike), goog.exportSymbol("transit.equals", com.cognitect.transit.eq.equals), goog.exportSymbol("transit.extendToEQ", com.cognitect.transit.eq.extendToEQ), goog.exportSymbol("transit.mapToObject", com.cognitect.transit.mapToObject), goog.exportSymbol("transit.objectToMap", com.cognitect.transit.objectToMap), goog.exportSymbol("transit.decoder", com.cognitect.transit.impl.decoder.decoder), goog.exportSymbol("transit.UUIDfromString", com.cognitect.transit.types.UUIDfromString), goog.exportSymbol("transit.randomUUID", com.cognitect.transit.util.randomUUID), goog.exportSymbol("transit.stringableKeys", com.cognitect.transit.impl.writer.stringableKeys), goog.exportSymbol("transit.readCache", com.cognitect.transit.caching.readCache), goog.exportSymbol("transit.writeCache", com.cognitect.transit.caching.writeCache)), TRANSIT_NODE_TARGET && (module.exports = {
        reader: com.cognitect.transit.reader,
        writer: com.cognitect.transit.writer,
        makeBuilder: com.cognitect.transit.makeBuilder,
        makeWriteHandler: com.cognitect.transit.makeWriteHandler,
        date: com.cognitect.transit.types.date,
        integer: com.cognitect.transit.types.intValue,
        isInteger: com.cognitect.transit.types.isInteger,
        uuid: com.cognitect.transit.types.uuid,
        isUUID: com.cognitect.transit.types.isUUID,
        bigInt: com.cognitect.transit.types.bigInteger,
        isBigInt: com.cognitect.transit.types.isBigInteger,
        bigDec: com.cognitect.transit.types.bigDecimalValue,
        isBigDec: com.cognitect.transit.types.isBigDecimal,
        keyword: com.cognitect.transit.types.keyword,
        isKeyword: com.cognitect.transit.types.isKeyword,
        symbol: com.cognitect.transit.types.symbol,
        isSymbol: com.cognitect.transit.types.isSymbol,
        binary: com.cognitect.transit.types.binary,
        isBinary: com.cognitect.transit.types.isBinary,
        uri: com.cognitect.transit.types.uri,
        isURI: com.cognitect.transit.types.isURI,
        map: com.cognitect.transit.types.map,
        isMap: com.cognitect.transit.types.isMap,
        set: com.cognitect.transit.types.set,
        isSet: com.cognitect.transit.types.isSet,
        list: com.cognitect.transit.types.list,
        isList: com.cognitect.transit.types.isList,
        quoted: com.cognitect.transit.types.quoted,
        isQuoted: com.cognitect.transit.types.isQuoted,
        tagged: com.cognitect.transit.types.taggedValue,
        isTaggedValue: com.cognitect.transit.types.isTaggedValue,
        link: com.cognitect.transit.types.link,
        isLink: com.cognitect.transit.types.isLink,
        hash: com.cognitect.transit.eq.hashCode,
        hashArrayLike: com.cognitect.transit.eq.hashArrayLike,
        hashMapLike: com.cognitect.transit.eq.hashMapLike,
        equals: com.cognitect.transit.eq.equals,
        extendToEQ: com.cognitect.transit.eq.extendToEQ,
        mapToObject: com.cognitect.transit.mapToObject,
        objectToMap: com.cognitect.transit.objectToMap,
        decoder: com.cognitect.transit.impl.decoder.decoder,
        UUIDfromString: com.cognitect.transit.types.UUIDfromString,
        randomUUID: com.cognitect.transit.util.randomUUID,
        stringableKeys: com.cognitect.transit.impl.writer.stringableKeys,
        readCache: com.cognitect.transit.caching.readCache,
        writeCache: com.cognitect.transit.caching.writeCache
      });
    }).call(exports, __webpack_require__(40));
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function a(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function s(t, e, r) {
      return e && a(t.prototype, e), r && a(t, r), t;
    }

    r.d(e, "a", function () {
      return f;
    });

    var u = r(78),
        g = r.n(u),
        p = r(35),
        l = function l(t) {
      return ((t.headers || {})["content-type"] || "").startsWith("application/transit+json");
    },
        f = function () {
      function t() {
        c(this, t);
      }

      return s(t, [{
        key: "error",
        value: function value(t) {
          var e = Object(p.a)(t.typeHandlers),
              r = e.reader;
          return t.error.response && l(t.error.response) ? g()(o({}, t), "error.response.data", function (t) {
            return r.read(t);
          }) : t;
        }
      }, {
        key: "leave",
        value: function value(t) {
          var e = Object(p.a)(t.typeHandlers),
              r = e.reader;
          return t.res && l(t.res) ? g()(o({}, t), "res.data", function (t) {
            return r.read(t);
          }) : t;
        }
      }]), t;
    }();
  }, function (t, e, r) {
    function n(t, e, r, n) {
      return i(t, e, r(o(t, e)), n);
    }

    var o = r(17),
        i = r(32);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return "function" == typeof t ? t : o;
    }

    var o = r(11);
    t.exports = n;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function c(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function a(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function s(t, e, r) {
      return e && a(t.prototype, e), r && a(t, r), t;
    }

    r.d(e, "a", function () {
      return p;
    });

    var u = r(78),
        g = r.n(u),
        p = function () {
      function t() {
        c(this, t);
      }

      return s(t, [{
        key: "error",
        value: function value(t) {
          return t.error.response ? g()(o({}, t), "error.response", function (t) {
            return {
              status: t.status,
              statusText: t.statusText,
              data: t.data
            };
          }) : t;
        }
      }, {
        key: "leave",
        value: function value(t) {
          return t.res ? g()(o({}, t), "res", function (t) {
            return {
              status: t.status,
              statusText: t.statusText,
              data: t.data
            };
          }) : t;
        }
      }]), t;
    }();
  }, function (t, e, r) {
    "use strict";

    r.d(e, "a", function () {
      return c;
    });

    var n = r(241),
        o = r(79),
        i = r(80),
        c = function c(t, e, r) {
      return Object(n.a)() ? Object(o.a)({
        clientId: e,
        secure: r
      }) : Object(i.a)();
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    r.d(e, "a", function () {
      return o;
    });

    var o = function o() {
      return "object" === ("undefined" == typeof document ? "undefined" : n(document)) && "string" == typeof document.cookie;
    };
  }, function (t, e, r) {
    var n, o;
    !function (i) {
      var c;

      if (n = i, void 0 !== (o = "function" == typeof n ? n.call(e, r, e, t) : n) && (t.exports = o), c = !0, t.exports = i(), c = !0, !c) {
        var a = window.Cookies,
            s = window.Cookies = i();

        s.noConflict = function () {
          return window.Cookies = a, s;
        };
      }
    }(function () {
      function t() {
        for (var t = 0, e = {}; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            e[n] = r[n];
          }
        }

        return e;
      }

      function e(t) {
        return t.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }

      function r(n) {
        function o() {}

        function i(e, r, i) {
          if ("undefined" != typeof document) {
            i = t({
              path: "/"
            }, o.defaults, i), "number" == typeof i.expires && (i.expires = new Date(1 * new Date() + 864e5 * i.expires)), i.expires = i.expires ? i.expires.toUTCString() : "";

            try {
              var c = JSON.stringify(r);
              /^[\{\[]/.test(c) && (r = c);
            } catch (t) {}

            r = n.write ? n.write(r, e) : encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), e = encodeURIComponent(String(e)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var a = "";

            for (var s in i) {
              i[s] && (a += "; " + s, !0 !== i[s] && (a += "=" + i[s].split(";")[0]));
            }

            return document.cookie = e + "=" + r + a;
          }
        }

        function c(t, r) {
          if ("undefined" != typeof document) {
            for (var o = {}, i = document.cookie ? document.cookie.split("; ") : [], c = 0; c < i.length; c++) {
              var a = i[c].split("="),
                  s = a.slice(1).join("=");
              r || '"' !== s.charAt(0) || (s = s.slice(1, -1));

              try {
                var u = e(a[0]);
                if (s = (n.read || n)(s, u) || e(s), r) try {
                  s = JSON.parse(s);
                } catch (t) {}
                if (o[u] = s, t === u) break;
              } catch (t) {}
            }

            return t ? o[t] : o;
          }
        }

        return o.set = i, o.get = function (t) {
          return c(t, !1);
        }, o.getJSON = function (t) {
          return c(t, !0);
        }, o.remove = function (e, r) {
          i(e, "", t(r, {
            expires: -1
          }));
        }, o.defaults = {}, o.withConverter = r, o;
      }

      return r(function () {});
    });
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? n(r, !0).forEach(function (e) {
          i(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(r).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    function i(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    var c = function c(t, e) {
      return "".concat(e, "-").concat(t, "-token");
    },
        a = function a(t) {
      var e,
          r = t.clientId,
          n = t.req,
          i = t.res,
          a = t.secure,
          s = c(r, "st"),
          u = function u() {
        var t = n.cookies[s];
        return t ? JSON.parse(t) : null;
      };

      return {
        getToken: function getToken() {
          return e = e || u();
        },
        setToken: function setToken(t) {
          e = t;
          var r = a ? {
            secure: !0
          } : {};
          i.cookie(s, JSON.stringify(t), o({
            maxAge: 15552e6
          }, r));
        },
        removeToken: function removeToken() {
          e = null, i.clearCookie(s);
        }
      };
    };

    e.a = a;
  }]);
});